var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 349,
    viewBox: "0 0 306 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 217.845V261.195L153.213 282.87L191.355 261.195V217.845L153.213 196.17L115.074 217.845Z",
    fill: "#27E6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 152.818V196.17L267.635 217.845L305.775 196.17V152.818L267.635 131.144L229.494 152.818Z",
    fill: "#27E6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.65332 152.818V196.17L38.7945 217.845L76.9337 196.17V152.818L38.7945 131.144L0.65332 152.818Z",
    fill: "#27E6D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.213 66.1172L115.074 87.7921V131.144L153.213 152.819L191.355 131.144V87.7921L153.213 66.1172Z",
    fill: "#27E6D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.475 84.7737C226.001 84.7737 222.522 84.0201 219.87 82.5109C217.252 81.0234 215.81 79.0349 215.806 76.9102C215.804 74.8013 217.222 72.8265 219.803 71.3509C225.075 68.3365 233.685 68.3365 238.991 71.3529C241.607 72.8384 243.05 74.8269 243.052 76.9496C243.054 79.0585 241.635 81.0333 239.054 82.5089C236.418 84.0161 232.948 84.7717 229.473 84.7717L229.475 84.7737ZM229.382 69.457C225.976 69.457 222.573 70.1968 219.988 71.6744C217.53 73.081 216.176 74.9413 216.178 76.9102C216.18 78.8948 217.557 80.7689 220.053 82.1874C225.259 85.1445 233.701 85.1445 238.871 82.1874C241.33 80.7808 242.685 78.9204 242.681 76.9516C242.679 74.967 241.302 73.0948 238.81 71.6764C236.205 70.1968 232.791 69.457 229.382 69.457Z",
    fill: "url(#paint0_linear_376_5139)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.532 95.6104C207.058 95.6104 203.579 94.8567 200.927 93.3476C198.31 91.8601 196.866 89.8715 196.864 87.7469C196.862 85.638 198.281 83.6632 200.86 82.1876C206.134 79.1712 214.744 79.1712 220.052 82.1876C222.666 83.6731 224.106 85.6597 224.11 87.7843C224.112 89.8952 222.694 91.87 220.111 93.3476C217.475 94.8548 214.005 95.6104 210.532 95.6104ZM210.443 80.2937C207.034 80.2937 203.63 81.0335 201.043 82.5131C198.584 83.9197 197.231 85.778 197.235 87.7488C197.237 89.7334 198.614 91.6076 201.108 93.026C206.313 95.9852 214.756 95.9852 219.925 93.026C222.386 91.6174 223.742 89.7571 223.738 87.7863C223.736 85.8017 222.361 83.9295 219.868 82.5131C217.264 81.0335 213.851 80.2937 210.443 80.2937Z",
    fill: "url(#paint1_linear_376_5139)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.601 106.444C226.125 106.444 222.646 105.691 219.99 104.182C217.376 102.696 215.936 100.707 215.932 98.5848C215.93 96.4759 217.348 94.5011 219.927 93.0255C225.201 90.0091 233.809 90.0071 239.115 93.0235C241.731 94.511 243.174 96.4995 243.178 98.6222C243.18 100.731 241.761 102.708 239.178 104.184C236.542 105.691 233.072 106.444 229.599 106.444H229.601ZM229.514 91.1277C226.106 91.1277 222.699 91.8675 220.112 93.349C217.654 94.7556 216.302 96.6159 216.304 98.5848C216.306 100.569 217.681 102.442 220.175 103.86C225.383 106.819 233.825 106.821 238.997 103.862C241.458 102.453 242.811 100.595 242.809 98.6242C242.807 96.6396 241.43 94.7655 238.936 93.347C236.333 91.8694 232.923 91.1296 229.516 91.1296L229.514 91.1277Z",
    fill: "url(#paint2_linear_376_5139)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.544 95.6084C245.069 95.6084 241.589 94.8528 238.934 93.3456C236.317 91.8601 234.877 89.8715 234.873 87.7488C234.871 85.6399 236.29 83.6652 238.871 82.1895C244.143 79.1732 252.749 79.1732 258.054 82.1895C260.673 83.677 262.115 85.6656 262.119 87.7902C262.121 89.8991 260.702 91.8719 258.121 93.3495C255.485 94.8567 252.018 95.6103 248.544 95.6103V95.6084ZM248.452 80.2917C245.045 80.2917 241.643 81.0315 239.056 82.5111C236.597 83.9177 235.241 85.778 235.245 87.7468C235.247 89.7315 236.623 91.6036 239.117 93.022C244.324 95.9812 252.766 95.9832 257.938 93.024C260.399 91.6174 261.751 89.7571 261.749 87.7883C261.747 85.8037 260.369 83.9295 257.873 82.5111C255.271 81.0315 251.858 80.2917 248.452 80.2917Z",
    fill: "url(#paint3_linear_376_5139)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.765 127.261C233.81 127.261 232.929 127.036 232.153 126.586C230.326 125.527 229.316 123.337 229.308 120.42C229.29 114.414 233.585 107.074 238.879 104.055C241.505 102.558 243.982 102.331 245.848 103.414C247.674 104.474 248.685 106.665 248.693 109.581C248.71 115.586 244.417 122.927 239.125 125.943C237.588 126.819 236.105 127.261 234.763 127.261H234.765ZM239.064 104.379C233.873 107.338 229.662 114.535 229.678 120.42C229.686 123.199 230.63 125.275 232.338 126.265C234.085 127.281 236.432 127.05 238.942 125.62C244.131 122.663 248.34 115.468 248.322 109.581C248.314 106.801 247.371 104.726 245.662 103.734C243.915 102.718 241.57 102.947 239.064 104.377V104.379Z",
    fill: "url(#paint4_linear_376_5139)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M253.844 137.993C252.889 137.993 252.008 137.768 251.232 137.319C249.405 136.257 248.393 134.068 248.385 131.152C248.367 125.145 252.66 117.802 257.952 114.786C260.58 113.288 263.055 113.059 264.925 114.145C266.751 115.206 267.764 117.396 267.772 120.313C267.787 126.319 263.494 133.659 258.2 136.678C256.668 137.551 255.184 137.993 253.844 137.993ZM262.31 113.841C261.036 113.841 259.615 114.267 258.137 115.107C252.948 118.064 248.739 125.261 248.757 131.15C248.765 133.928 249.711 136.005 251.417 136.995C253.165 138.009 255.507 137.782 258.015 136.354C263.207 133.395 267.417 126.198 267.401 120.313C267.393 117.534 266.448 115.456 264.739 114.464C264.02 114.048 263.201 113.841 262.312 113.841H262.31Z",
    fill: "url(#paint5_linear_376_5139)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253.782 116.425C252.828 116.425 251.947 116.202 251.171 115.75C249.345 114.691 248.334 112.499 248.324 109.583C248.309 103.578 252.6 96.2375 257.894 93.2211C260.524 91.7238 263 91.4949 264.866 92.578C266.692 93.6374 267.703 95.8271 267.711 98.7449C267.727 104.75 263.434 112.091 258.138 115.109C256.603 115.983 255.121 116.425 253.782 116.425ZM262.254 92.2761C260.977 92.2761 259.556 92.7023 258.077 93.5446C252.887 96.5018 248.679 103.697 248.695 109.583C248.703 112.363 249.648 114.438 251.354 115.431C253.104 116.445 255.447 116.216 257.953 114.788C263.144 111.828 267.354 104.632 267.339 98.7469C267.331 95.9672 266.385 93.8918 264.679 92.9015C263.962 92.4853 263.142 92.2781 262.252 92.2781L262.254 92.2761Z",
    fill: "url(#paint6_linear_376_5139)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M234.831 148.83C233.875 148.83 232.994 148.607 232.216 148.155C230.39 147.094 229.379 144.906 229.369 141.99C229.353 135.981 233.646 128.639 238.942 125.62C241.567 124.125 244.041 123.896 245.909 124.979C247.737 126.04 248.748 128.232 248.756 131.15C248.772 137.155 244.481 144.496 239.187 147.512C237.652 148.386 236.168 148.828 234.829 148.828L234.831 148.83ZM239.128 125.944C233.936 128.903 229.726 136.1 229.742 141.988C229.749 144.766 230.695 146.841 232.403 147.834C234.153 148.85 236.497 148.621 239.005 147.191C244.195 144.233 248.403 137.039 248.388 131.152C248.38 128.37 247.434 126.293 245.724 125.303C243.976 124.289 241.634 124.517 239.128 125.944Z",
    fill: "url(#paint7_linear_376_5139)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224.215 127.145C222.873 127.145 221.387 126.705 219.849 125.831C214.549 122.821 210.252 115.496 210.268 109.505C210.276 106.599 211.284 104.415 213.107 103.355C214.974 102.268 217.457 102.495 220.091 103.991C225.393 107.003 229.692 114.328 229.676 120.321C229.668 123.227 228.659 125.411 226.835 126.47C226.057 126.924 225.17 127.149 224.213 127.149L224.215 127.145ZM215.733 103.048C214.838 103.048 214.017 103.255 213.296 103.675C211.592 104.665 210.65 106.737 210.64 109.505C210.622 115.378 214.837 122.556 220.032 125.508C222.55 126.936 224.898 127.163 226.652 126.147C228.356 125.157 229.3 123.087 229.308 120.319C229.323 114.446 225.109 107.266 219.912 104.314C218.432 103.474 217.012 103.05 215.735 103.05L215.733 103.048Z",
    fill: "url(#paint8_linear_376_5139)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M205.113 137.853C203.771 137.853 202.288 137.413 200.753 136.541C195.451 133.529 191.152 126.204 191.17 120.211C191.178 117.305 192.187 115.119 194.011 114.06C195.883 112.973 198.363 113.198 200.999 114.695C206.299 117.705 210.596 125.032 210.58 131.028C210.573 133.933 209.562 136.115 207.737 137.177C206.959 137.63 206.073 137.855 205.113 137.855V137.853ZM196.637 113.752C195.743 113.752 194.919 113.961 194.198 114.379C192.492 115.372 191.55 117.441 191.542 120.211C191.525 126.084 195.741 133.263 200.938 136.216C203.452 137.644 205.803 137.869 207.552 136.851C209.258 135.861 210.202 133.789 210.21 131.024C210.228 125.149 206.014 117.968 200.818 115.016C199.338 114.176 197.916 113.752 196.639 113.752H196.637Z",
    fill: "url(#paint9_linear_376_5139)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M205.177 116.332C203.835 116.332 202.351 115.892 200.817 115.018C195.515 112.006 191.216 104.681 191.231 98.6876C191.239 95.7817 192.248 93.5978 194.073 92.5384C195.944 91.4514 198.425 91.6783 201.061 93.1756C206.361 96.1861 210.658 103.509 210.642 109.502C210.634 112.408 209.625 114.592 207.801 115.651C207.023 116.105 206.136 116.33 205.177 116.33V116.332ZM196.697 92.2346C195.802 92.2346 194.981 92.4418 194.26 92.862C192.555 93.8523 191.612 95.9217 191.604 98.6895C191.588 104.563 195.802 111.743 201 114.695C203.514 116.121 205.862 116.35 207.616 115.332C209.32 114.342 210.264 112.27 210.272 109.502C210.287 103.629 206.075 96.4504 200.88 93.4992C199.4 92.6588 197.975 92.2326 196.699 92.2326L196.697 92.2346Z",
    fill: "url(#paint10_linear_376_5139)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M224.151 148.668C222.809 148.668 221.326 148.228 219.787 147.354C214.487 144.344 210.19 137.019 210.206 131.027C210.214 128.119 211.225 125.936 213.049 124.874C214.917 123.787 217.399 124.012 220.032 125.508C225.333 128.52 229.632 135.847 229.615 141.842C229.607 144.746 228.598 146.93 226.774 147.989C225.993 148.443 225.107 148.668 224.149 148.668H224.151ZM215.675 124.567C214.781 124.567 213.959 124.774 213.236 125.194C211.53 126.186 210.586 128.256 210.578 131.025C210.561 136.898 214.775 144.077 219.97 147.029C222.488 148.459 224.839 148.684 226.59 147.666C228.295 146.675 229.238 144.606 229.246 141.838C229.264 135.963 225.048 128.78 219.85 125.827C218.373 124.989 216.952 124.565 215.675 124.565V124.567Z",
    fill: "url(#paint11_linear_376_5139)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 153.004C229.463 153.004 229.431 152.996 229.404 152.98L191.263 131.306C191.205 131.272 191.168 131.211 191.168 131.144V87.794C191.168 87.7269 191.203 87.6657 191.263 87.6322L229.404 65.9573C229.461 65.9237 229.53 65.9237 229.587 65.9573L267.728 87.6322C267.785 87.6657 267.823 87.7269 267.823 87.794V131.144C267.823 131.211 267.787 131.272 267.728 131.306L229.587 152.98C229.559 152.996 229.528 153.004 229.496 153.004H229.494ZM191.54 131.035L229.494 152.606L267.448 131.035V87.9005L229.494 66.3301L191.54 87.9005V131.035Z",
    fill: "url(#paint12_linear_376_5139)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M229.495 109.654C229.463 109.654 229.432 109.646 229.404 109.63L191.263 87.9556C191.174 87.9043 191.143 87.7918 191.192 87.7031C191.243 87.6143 191.356 87.5827 191.444 87.634L229.493 109.258L267.542 87.634C267.63 87.5827 267.743 87.6143 267.794 87.7031C267.843 87.7918 267.813 87.9063 267.723 87.9556L229.582 109.63C229.554 109.646 229.523 109.654 229.491 109.654H229.495Z",
    fill: "url(#paint13_linear_376_5139)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M229.495 153.004C229.392 153.004 229.31 152.921 229.31 152.818V109.469C229.31 109.366 229.392 109.283 229.495 109.283C229.597 109.283 229.68 109.366 229.68 109.469V152.818C229.68 152.921 229.597 153.004 229.495 153.004Z",
    fill: "url(#paint14_linear_376_5139)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M163.785 274.764C161.903 274.764 160.168 274.324 158.639 273.436C155.035 271.345 153.039 267.007 153.024 261.223C152.988 249.238 161.558 234.592 172.127 228.569C177.342 225.6 182.244 225.143 185.928 227.279C189.531 229.37 191.525 233.706 191.543 239.487C191.577 251.473 183.006 266.125 172.436 272.146C169.386 273.884 166.443 274.76 163.787 274.76L163.785 274.764ZM180.78 226.326C178.187 226.326 175.305 227.188 172.31 228.895C161.844 234.857 153.358 249.36 153.394 261.223C153.41 266.869 155.339 271.093 158.824 273.115C162.39 275.184 167.158 274.726 172.249 271.824C182.715 265.863 191.204 251.357 191.169 239.491C191.153 233.848 189.224 229.625 185.739 227.603C184.269 226.75 182.594 226.326 180.778 226.326H180.78Z",
    fill: "url(#paint15_linear_376_5139)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M142.634 274.752C139.98 274.752 137.039 273.874 133.989 272.136C123.423 266.115 114.854 251.466 114.89 239.481C114.906 233.701 116.899 229.365 120.503 227.273C124.187 225.137 129.085 225.593 134.298 228.564C144.862 234.585 153.429 249.23 153.393 261.213C153.378 266.997 151.382 271.335 147.778 273.427C146.251 274.314 144.516 274.754 142.634 274.754V274.752ZM125.647 226.319C123.831 226.319 122.158 226.743 120.688 227.595C117.205 229.617 115.276 233.839 115.26 239.481C115.225 251.347 123.71 265.851 134.172 271.813C139.259 274.711 144.027 275.17 147.591 273.103C151.076 271.081 153.005 266.857 153.021 261.211C153.057 249.349 144.575 234.849 134.113 228.887C131.12 227.183 128.238 226.321 125.647 226.321V226.319Z",
    fill: "url(#paint16_linear_376_5139)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.303 233.278C146.38 233.278 139.447 231.783 134.157 228.792C128.979 225.864 126.126 221.96 126.12 217.798C126.114 213.665 128.924 209.786 134.032 206.878C144.542 200.897 161.696 200.897 172.274 206.878C177.452 209.806 180.305 213.71 180.313 217.872C180.318 222.005 177.507 225.884 172.4 228.792C167.146 231.783 160.228 233.278 153.305 233.278H153.303ZM153.128 202.761C146.267 202.761 139.421 204.243 134.216 207.204C129.227 210.043 126.485 213.805 126.491 217.798C126.496 221.82 129.282 225.61 134.34 228.468C144.815 234.393 161.808 234.393 172.215 228.468C177.204 225.629 179.946 221.867 179.94 217.872C179.934 213.85 177.146 210.06 172.091 207.202C166.854 204.241 159.986 202.759 153.128 202.759V202.761Z",
    fill: "url(#paint17_linear_376_5139)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M153.215 283.057C153.184 283.057 153.152 283.049 153.124 283.034L114.983 261.359C114.926 261.325 114.889 261.264 114.889 261.197V217.847C114.889 217.78 114.924 217.719 114.983 217.685L153.124 196.011C153.182 195.977 153.251 195.977 153.308 196.011L191.449 217.685C191.506 217.719 191.543 217.78 191.543 217.847V261.197C191.543 261.264 191.508 261.325 191.449 261.359L153.308 283.034C153.28 283.049 153.249 283.057 153.217 283.057H153.215ZM115.261 261.088L153.215 282.659L191.169 261.088V217.954L153.215 196.383L115.261 217.954V261.088Z",
    fill: "url(#paint18_linear_376_5139)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M153.216 239.705C153.184 239.705 153.153 239.698 153.125 239.682L114.984 218.007C114.895 217.956 114.864 217.843 114.913 217.754C114.964 217.664 115.076 217.634 115.165 217.683L153.214 239.307L191.262 217.683C191.351 217.634 191.463 217.664 191.514 217.754C191.564 217.843 191.534 217.958 191.444 218.007L153.302 239.682C153.275 239.698 153.243 239.705 153.212 239.705H153.216Z",
    fill: "url(#paint19_linear_376_5139)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M153.214 283.058C153.112 283.058 153.029 282.975 153.029 282.872V239.522C153.029 239.42 153.112 239.337 153.214 239.337C153.317 239.337 153.4 239.42 153.4 239.522V282.872C153.4 282.975 153.317 283.058 153.214 283.058Z",
    fill: "url(#paint20_linear_376_5139)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M229.493 283.057C229.462 283.057 229.43 283.049 229.403 283.034L191.264 261.359C191.206 261.325 191.169 261.264 191.169 261.197V217.847C191.169 217.78 191.204 217.719 191.264 217.685L229.403 196.011C229.46 195.977 229.529 195.977 229.586 196.011L267.727 217.685C267.784 217.719 267.822 217.78 267.822 217.847V261.197C267.822 261.264 267.786 261.325 267.727 261.359L229.586 283.034C229.558 283.049 229.527 283.057 229.495 283.057H229.493ZM191.539 261.088L229.493 282.659L267.447 261.088V217.954L229.493 196.383L191.539 217.954V261.088Z",
    fill: "url(#paint21_linear_376_5139)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 239.705C229.462 239.705 229.431 239.698 229.403 239.682L191.264 218.007C191.175 217.956 191.144 217.843 191.193 217.754C191.244 217.664 191.357 217.634 191.445 217.683L229.494 239.307L267.543 217.683C267.631 217.634 267.743 217.664 267.795 217.754C267.844 217.843 267.814 217.958 267.724 218.007L229.583 239.682C229.555 239.698 229.523 239.705 229.492 239.705H229.494Z",
    fill: "url(#paint22_linear_376_5139)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 283.058C229.391 283.058 229.309 282.975 229.309 282.872V239.522C229.309 239.42 229.391 239.337 229.494 239.337C229.596 239.337 229.679 239.42 229.679 239.522V282.872C229.679 282.975 229.596 283.058 229.494 283.058Z",
    fill: "url(#paint23_linear_376_5139)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 251.144C191.29 251.144 191.227 251.11 191.194 251.049C191.144 250.958 191.174 250.846 191.265 250.796L220.506 234.3C220.595 234.251 220.709 234.28 220.758 234.371C220.808 234.462 220.778 234.574 220.688 234.624L191.446 251.12C191.416 251.136 191.385 251.144 191.355 251.144Z",
    fill: "url(#paint24_linear_376_5139)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M200.345 266.49C200.28 266.49 200.217 266.457 200.184 266.395C200.135 266.307 200.164 266.192 200.255 266.143L229.404 249.769C229.491 249.719 229.605 249.749 229.656 249.84C229.705 249.929 229.676 250.043 229.585 250.092L200.436 266.466C200.408 266.482 200.377 266.49 200.345 266.49Z",
    fill: "url(#paint25_linear_376_5139)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M238.849 277.741C238.817 277.741 238.784 277.733 238.754 277.715C238.666 277.662 238.636 277.549 238.687 277.461L267.472 228.309C267.523 228.22 267.637 228.191 267.726 228.244C267.815 228.297 267.844 228.41 267.793 228.498L239.008 277.65C238.973 277.709 238.912 277.741 238.849 277.741Z",
    fill: "url(#paint26_linear_376_5139)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M229.495 272.61C229.463 272.61 229.43 272.602 229.4 272.584C229.311 272.531 229.282 272.418 229.335 272.33L258.218 223.012C258.271 222.923 258.384 222.894 258.472 222.945C258.561 222.998 258.591 223.111 258.539 223.2L229.656 272.517C229.621 272.576 229.56 272.608 229.497 272.608L229.495 272.61Z",
    fill: "url(#paint27_linear_376_5139)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M258.833 213.028L200.247 212.976C200.144 212.976 200.062 212.894 200.062 212.791C200.062 212.688 200.144 212.605 200.247 212.605L258.833 212.657C258.935 212.657 259.018 212.74 259.018 212.842C259.018 212.945 258.935 213.028 258.833 213.028Z",
    fill: "url(#paint28_linear_376_5139)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M258.377 223.292L200.52 223.239C200.418 223.239 200.335 223.156 200.335 223.053C200.335 222.951 200.418 222.868 200.52 222.868L258.377 222.921C258.48 222.921 258.562 223.004 258.562 223.106C258.562 223.209 258.48 223.292 258.377 223.292Z",
    fill: "url(#paint29_linear_376_5139)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9338 283.057C76.9023 283.057 76.8708 283.049 76.8432 283.034L38.702 261.359C38.6449 261.325 38.6074 261.264 38.6074 261.197V217.847C38.6074 217.78 38.6429 217.719 38.702 217.685L76.8432 196.011C76.9003 195.977 76.9693 195.977 77.0264 196.011L115.168 217.685C115.225 217.719 115.262 217.78 115.262 217.847V261.197C115.262 261.264 115.227 261.325 115.168 261.359L77.0264 283.034C76.9988 283.049 76.9673 283.057 76.9358 283.057H76.9338ZM38.9798 261.088L76.9338 282.659L114.888 261.088V217.954L76.9338 196.383L38.9798 217.954V261.088Z",
    fill: "url(#paint30_linear_376_5139)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9344 239.705C76.9029 239.705 76.8713 239.698 76.8438 239.682L38.7026 218.007C38.6139 217.956 38.5824 217.843 38.6316 217.754C38.6829 217.664 38.7952 217.634 38.8858 217.683L76.9344 239.307L114.983 217.683C115.072 217.634 115.184 217.664 115.235 217.754C115.284 217.843 115.255 217.958 115.164 218.007L77.023 239.682C76.9955 239.698 76.9639 239.705 76.9324 239.705H76.9344Z",
    fill: "url(#paint31_linear_376_5139)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9332 283.058C76.8308 283.058 76.748 282.975 76.748 282.872V239.522C76.748 239.42 76.8308 239.337 76.9332 239.337C77.0357 239.337 77.1184 239.42 77.1184 239.522V282.872C77.1184 282.975 77.0357 283.058 76.9332 283.058Z",
    fill: "url(#paint32_linear_376_5139)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9336 242.765C76.8686 242.765 76.8075 242.73 76.774 242.674L74.0827 238.088C74.0492 238.031 74.0492 237.96 74.0827 237.9C74.1162 237.843 74.1773 237.806 74.2443 237.806H79.6249C79.6919 237.806 79.753 237.841 79.7865 237.9C79.82 237.958 79.82 238.029 79.7865 238.088L77.0952 242.674C77.0617 242.732 77.0006 242.765 76.9356 242.765H76.9336ZM74.5674 238.179L76.9336 242.213L79.2998 238.179H74.5674Z",
    fill: "url(#paint33_linear_376_5139)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9328 247.523C76.8678 247.523 76.8067 247.488 76.7732 247.433L69.8952 235.706C69.8617 235.649 69.8617 235.576 69.8952 235.519C69.9287 235.462 69.9898 235.426 70.0568 235.426H83.8108C83.8778 235.426 83.9389 235.462 83.9723 235.519C84.0058 235.576 84.0058 235.647 83.9723 235.706L77.0944 247.433C77.0609 247.49 76.9998 247.523 76.9348 247.523H76.9328ZM70.3799 235.797L76.9328 246.969L83.4857 235.797H70.3799Z",
    fill: "url(#paint34_linear_376_5139)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.933 252.28C76.8679 252.28 76.8069 252.244 76.7734 252.189L65.7107 233.328C65.6772 233.27 65.6772 233.197 65.7107 233.14C65.7442 233.083 65.8052 233.047 65.8722 233.047H87.9976C88.0646 233.047 88.1257 233.083 88.1592 233.14C88.1927 233.197 88.1927 233.268 88.1592 233.328L77.0965 252.189C77.063 252.246 77.0019 252.28 76.9369 252.28H76.933ZM66.1934 233.418L76.933 251.726L87.6725 233.418H66.1953H66.1934Z",
    fill: "url(#paint35_linear_376_5139)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9331 257.037C76.8681 257.037 76.8071 257.001 76.7736 256.946L61.5202 230.939C61.4867 230.882 61.4867 230.809 61.5202 230.751C61.5537 230.694 61.6148 230.659 61.6818 230.659L92.1845 230.669C92.2515 230.669 92.3126 230.704 92.3461 230.763C92.3795 230.82 92.3795 230.891 92.3461 230.951L77.0967 256.948C77.0632 257.005 77.0021 257.039 76.9371 257.039L76.9331 257.037ZM62.0029 231.03L76.9331 256.482L91.8574 231.037L62.0029 231.028V231.03Z",
    fill: "url(#paint36_linear_376_5139)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9333 261.795C76.8682 261.795 76.8072 261.759 76.7737 261.704L57.3396 228.571C57.3061 228.514 57.3061 228.443 57.3396 228.384C57.3731 228.327 57.4341 228.289 57.5011 228.289H96.3693C96.4363 228.289 96.4974 228.325 96.5309 228.384C96.5644 228.441 96.5644 228.512 96.5309 228.571L77.0968 261.704C77.0633 261.761 77.0022 261.795 76.9372 261.795H76.9333ZM57.8242 228.662L76.9333 261.242L96.0423 228.662H57.8223H57.8242Z",
    fill: "url(#paint37_linear_376_5139)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9334 266.553C76.8684 266.553 76.8073 266.517 76.7738 266.462L53.155 226.192C53.1215 226.135 53.1215 226.062 53.155 226.004C53.1885 225.947 53.2496 225.91 53.3166 225.91H100.556C100.623 225.91 100.684 225.945 100.718 226.004C100.751 226.062 100.751 226.133 100.718 226.192L77.0989 266.462C77.0654 266.519 77.0043 266.553 76.9393 266.553H76.9334ZM53.6377 226.283L76.9334 265.998L100.229 226.283H53.6397H53.6377Z",
    fill: "url(#paint38_linear_376_5139)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9336 271.309C76.8685 271.309 76.8075 271.274 76.774 271.219L48.9685 223.813C48.935 223.756 48.935 223.683 48.9685 223.625C49.002 223.568 49.0631 223.533 49.13 223.533H104.739C104.806 223.533 104.867 223.568 104.901 223.625C104.934 223.683 104.934 223.754 104.901 223.813L77.0951 271.219C77.0616 271.276 77.0005 271.309 76.9355 271.309H76.9336ZM49.4532 223.904L76.9336 270.755L104.414 223.904H49.4532Z",
    fill: "url(#paint39_linear_376_5139)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9337 276.066C76.8687 276.066 76.8076 276.031 76.7741 275.975L44.7839 221.434C44.7504 221.377 44.7504 221.304 44.7839 221.247C44.8174 221.189 44.8785 221.154 44.9455 221.154H108.926C108.993 221.154 109.054 221.189 109.087 221.247C109.121 221.304 109.121 221.375 109.087 221.434L77.0972 275.975C77.0637 276.033 77.0027 276.066 76.9376 276.066H76.9337ZM45.2666 221.525L76.9337 275.514L108.601 221.525H45.2686H45.2666Z",
    fill: "url(#paint40_linear_376_5139)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9329 280.824C76.8679 280.824 76.8068 280.789 76.7733 280.733L40.5984 219.057C40.5649 218.999 40.5649 218.926 40.5984 218.869C40.6319 218.812 40.6929 218.776 40.7599 218.776H113.112C113.179 218.776 113.24 218.812 113.273 218.869C113.307 218.926 113.307 218.997 113.273 219.057L77.0984 280.733C77.0649 280.791 77.0038 280.824 76.9388 280.824H76.9329ZM41.0811 219.147L76.9329 280.272L112.785 219.147H41.0811Z",
    fill: "url(#paint41_linear_376_5139)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1564 281.795C79.1249 281.795 79.0914 281.787 79.0618 281.769C78.9732 281.716 78.9436 281.604 78.9948 281.515L114.914 220.276C114.965 220.187 115.079 220.157 115.168 220.209C115.256 220.262 115.286 220.374 115.233 220.463L79.314 281.702C79.2785 281.761 79.2175 281.793 79.1544 281.793L79.1564 281.795Z",
    fill: "url(#paint42_linear_376_5139)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7129 281.795C74.6499 281.795 74.5868 281.761 74.5533 281.704L38.6345 220.465C38.5833 220.376 38.6129 220.262 38.6996 220.211C38.7863 220.159 38.9005 220.189 38.9537 220.278L74.8725 281.517C74.9237 281.605 74.8942 281.72 74.8055 281.771C74.776 281.789 74.7425 281.797 74.711 281.797L74.7129 281.795Z",
    fill: "url(#paint43_linear_376_5139)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5263 279.416C70.4632 279.416 70.4002 279.382 70.3667 279.325L38.6345 225.222C38.5833 225.133 38.6129 225.018 38.6996 224.967C38.7882 224.914 38.9005 224.945 38.9537 225.032L70.6858 279.136C70.7371 279.224 70.7075 279.339 70.6189 279.39C70.5893 279.408 70.5558 279.416 70.5243 279.416H70.5263Z",
    fill: "url(#paint44_linear_376_5139)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3404 279.416C83.3089 279.416 83.2754 279.408 83.2458 279.39C83.1571 279.337 83.1276 279.224 83.1808 279.135L114.915 225.032C114.966 224.943 115.08 224.914 115.169 224.967C115.258 225.02 115.287 225.133 115.234 225.221L83.5 279.325C83.4645 279.384 83.4034 279.416 83.3404 279.416Z",
    fill: "url(#paint45_linear_376_5139)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3415 277.036C66.2785 277.036 66.2154 277.003 66.1819 276.946L38.6345 229.98C38.5833 229.891 38.6129 229.777 38.6996 229.725C38.7882 229.672 38.9005 229.704 38.9537 229.79L66.5011 276.756C66.5523 276.845 66.5228 276.959 66.4341 277.011C66.4046 277.029 66.3711 277.036 66.3396 277.036H66.3415Z",
    fill: "url(#paint46_linear_376_5139)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5255 277.036C87.494 277.036 87.4605 277.028 87.431 277.011C87.3423 276.957 87.3127 276.845 87.364 276.756L114.911 229.79C114.963 229.702 115.077 229.672 115.166 229.725C115.254 229.779 115.284 229.891 115.231 229.98L87.6831 276.946C87.6477 277.005 87.5866 277.036 87.5236 277.036H87.5255Z",
    fill: "url(#paint47_linear_376_5139)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1549 274.659C62.0918 274.659 62.0288 274.626 61.9953 274.568L38.6326 234.738C38.5814 234.649 38.6109 234.535 38.6976 234.484C38.7863 234.43 38.8986 234.462 38.9518 234.549L62.3145 274.379C62.3657 274.468 62.3361 274.582 62.2475 274.634C62.2179 274.651 62.1844 274.659 62.1529 274.659H62.1549Z",
    fill: "url(#paint48_linear_376_5139)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M91.712 274.659C91.6805 274.659 91.647 274.651 91.6175 274.634C91.5288 274.58 91.4993 274.468 91.5505 274.379L114.913 234.549C114.964 234.46 115.079 234.43 115.167 234.484C115.256 234.535 115.286 234.649 115.232 234.738L91.8697 274.568C91.8342 274.628 91.7731 274.659 91.7101 274.659H91.712Z",
    fill: "url(#paint49_linear_376_5139)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9701 272.28C57.9071 272.28 57.844 272.247 57.8105 272.189L38.6345 239.494C38.5833 239.406 38.6129 239.291 38.6996 239.24C38.7863 239.189 38.9005 239.218 38.9537 239.307L58.1297 272.002C58.181 272.091 58.1514 272.205 58.0627 272.256C58.0332 272.274 57.9997 272.282 57.9682 272.282L57.9701 272.28Z",
    fill: "url(#paint50_linear_376_5139)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M95.898 272.28C95.8665 272.28 95.833 272.272 95.8034 272.254C95.7148 272.201 95.6852 272.089 95.7384 272L114.914 239.305C114.966 239.216 115.08 239.187 115.169 239.238C115.257 239.291 115.287 239.404 115.234 239.493L96.0576 272.187C96.0221 272.247 95.961 272.278 95.898 272.278V272.28Z",
    fill: "url(#paint51_linear_376_5139)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7854 269.901C53.7224 269.901 53.6593 269.867 53.6258 269.81L38.6345 244.251C38.5833 244.162 38.6129 244.048 38.6996 243.996C38.7882 243.943 38.9005 243.975 38.9537 244.061L53.945 269.621C53.9962 269.709 53.9667 269.824 53.88 269.875C53.8504 269.893 53.8169 269.901 53.7854 269.901Z",
    fill: "url(#paint52_linear_376_5139)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M100.083 269.901C100.052 269.901 100.018 269.893 99.9886 269.875C99.8999 269.822 99.8704 269.709 99.9216 269.621L114.913 244.061C114.964 243.973 115.078 243.943 115.167 243.996C115.256 244.05 115.285 244.162 115.232 244.251L100.241 269.81C100.205 269.869 100.144 269.901 100.081 269.901H100.083Z",
    fill: "url(#paint53_linear_376_5139)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5987 267.522C49.5357 267.522 49.4726 267.488 49.4392 267.431L38.6345 249.009C38.5833 248.92 38.6129 248.806 38.6996 248.755C38.7882 248.701 38.9005 248.733 38.9537 248.82L49.7583 267.242C49.8095 267.33 49.78 267.445 49.6913 267.496C49.6618 267.514 49.6283 267.522 49.5968 267.522H49.5987Z",
    fill: "url(#paint54_linear_376_5139)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M104.268 267.522C104.237 267.522 104.203 267.514 104.174 267.496C104.085 267.443 104.055 267.33 104.109 267.241L114.913 248.82C114.964 248.731 115.079 248.701 115.167 248.755C115.256 248.806 115.285 248.92 115.232 249.009L104.428 267.431C104.392 267.49 104.331 267.522 104.268 267.522Z",
    fill: "url(#paint55_linear_376_5139)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M45.414 265.142C45.351 265.142 45.2879 265.109 45.2544 265.052L38.6345 253.765C38.5833 253.677 38.6129 253.562 38.6996 253.511C38.7863 253.46 38.9005 253.489 38.9537 253.578L45.5736 264.864C45.6248 264.953 45.5953 265.068 45.5086 265.119C45.479 265.137 45.4455 265.144 45.414 265.144V265.142Z",
    fill: "url(#paint56_linear_376_5139)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M108.455 265.143C108.424 265.143 108.39 265.135 108.361 265.117C108.272 265.064 108.242 264.951 108.294 264.862L114.914 253.576C114.965 253.487 115.079 253.458 115.168 253.509C115.256 253.562 115.286 253.675 115.233 253.764L108.613 265.05C108.577 265.109 108.516 265.141 108.453 265.141L108.455 265.143Z",
    fill: "url(#paint57_linear_376_5139)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2274 262.765C41.1643 262.765 41.1013 262.732 41.0678 262.674L38.6326 258.524C38.5814 258.435 38.6109 258.321 38.6976 258.269C38.7843 258.218 38.8986 258.248 38.9518 258.336L41.3869 262.487C41.4382 262.576 41.4086 262.69 41.32 262.742C41.2904 262.759 41.2569 262.767 41.2254 262.767L41.2274 262.765Z",
    fill: "url(#paint58_linear_376_5139)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M112.64 262.765C112.608 262.765 112.575 262.757 112.545 262.74C112.457 262.686 112.427 262.574 112.478 262.485L114.913 258.334C114.965 258.246 115.079 258.216 115.168 258.267C115.256 258.321 115.286 258.433 115.233 258.522L112.797 262.673C112.762 262.732 112.701 262.763 112.638 262.763L112.64 262.765Z",
    fill: "url(#paint59_linear_376_5139)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M112.962 216.831H40.9059C40.8035 216.831 40.7207 216.748 40.7207 216.646C40.7207 216.543 40.8035 216.46 40.9059 216.46H112.962C113.065 216.46 113.147 216.543 113.147 216.646C113.147 216.748 113.065 216.831 112.962 216.831Z",
    fill: "url(#paint60_linear_376_5139)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M108.943 214.547H44.943C44.8406 214.547 44.7578 214.464 44.7578 214.361C44.7578 214.259 44.8406 214.176 44.943 214.176H108.941C109.044 214.176 109.126 214.259 109.126 214.361C109.126 214.464 109.044 214.547 108.941 214.547H108.943Z",
    fill: "url(#paint61_linear_376_5139)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M104.798 212.191H49.069C48.9665 212.191 48.8838 212.108 48.8838 212.006C48.8838 211.903 48.9665 211.82 49.069 211.82H104.796C104.899 211.82 104.981 211.903 104.981 212.006C104.981 212.108 104.899 212.191 104.796 212.191H104.798Z",
    fill: "url(#paint62_linear_376_5139)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M100.652 209.836H53.2135C53.1111 209.836 53.0283 209.753 53.0283 209.65C53.0283 209.548 53.1111 209.465 53.2135 209.465H100.652C100.755 209.465 100.837 209.548 100.837 209.65C100.837 209.753 100.755 209.836 100.652 209.836Z",
    fill: "url(#paint63_linear_376_5139)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M96.509 207.48H57.359C57.2566 207.48 57.1738 207.397 57.1738 207.295C57.1738 207.192 57.2566 207.109 57.359 207.109H96.509C96.6114 207.109 96.6942 207.192 96.6942 207.295C96.6942 207.397 96.6114 207.48 96.509 207.48Z",
    fill: "url(#paint64_linear_376_5139)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3639 205.125H61.5026C61.4001 205.125 61.3174 205.042 61.3174 204.939C61.3174 204.837 61.4001 204.754 61.5026 204.754H92.3639C92.4663 204.754 92.5491 204.837 92.5491 204.939C92.5491 205.042 92.4663 205.125 92.3639 205.125Z",
    fill: "url(#paint65_linear_376_5139)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2188 202.769H65.6481C65.5456 202.769 65.4629 202.686 65.4629 202.584C65.4629 202.481 65.5456 202.398 65.6481 202.398H88.2188C88.3212 202.398 88.4039 202.481 88.4039 202.584C88.4039 202.686 88.3212 202.769 88.2188 202.769Z",
    fill: "url(#paint66_linear_376_5139)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0746 200.414H69.7926C69.6902 200.414 69.6074 200.331 69.6074 200.228C69.6074 200.126 69.6902 200.043 69.7926 200.043H84.0746C84.1771 200.043 84.2598 200.126 84.2598 200.228C84.2598 200.331 84.1771 200.414 84.0746 200.414Z",
    fill: "url(#paint67_linear_376_5139)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9303 198.058H73.9567C73.8542 198.058 73.7715 197.976 73.7715 197.873C73.7715 197.77 73.8542 197.688 73.9567 197.688H79.9303C80.0328 197.688 80.1155 197.77 80.1155 197.873C80.1155 197.976 80.0328 198.058 79.9303 198.058Z",
    fill: "url(#paint68_linear_376_5139)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 87.9792C115.043 87.9792 115.011 87.9713 114.984 87.9556L76.8426 66.2807C76.7855 66.2471 76.748 66.186 76.748 66.1189V22.7671C76.748 22.7 76.7835 22.6389 76.8426 22.6053L114.982 0.928473C115.039 0.894936 115.108 0.894936 115.165 0.928473L153.306 22.6034C153.363 22.6369 153.401 22.6981 153.401 22.7651V66.1169C153.401 66.184 153.365 66.2452 153.306 66.2787L115.165 87.9536C115.137 87.9694 115.106 87.9773 115.074 87.9773V87.9792ZM77.1204 66.0104L115.074 87.5807L153.028 66.0104V22.8736L115.074 1.30527L77.1204 22.8756V66.0104Z",
    fill: "url(#paint69_linear_376_5139)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 44.6277C115.043 44.6277 115.012 44.6198 114.984 44.604L76.8432 22.9291C76.7545 22.8778 76.723 22.7654 76.7723 22.6766C76.8235 22.5878 76.9358 22.5543 77.0245 22.6075L115.073 44.2311L153.122 22.6075C153.21 22.5563 153.323 22.5878 153.374 22.6766C153.423 22.7654 153.394 22.8798 153.303 22.9291L115.162 44.604C115.134 44.6198 115.103 44.6277 115.071 44.6277H115.075Z",
    fill: "url(#paint70_linear_376_5139)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 87.979C114.972 87.979 114.89 87.8961 114.89 87.7935V44.4437C114.89 44.3412 114.972 44.2583 115.075 44.2583C115.177 44.2583 115.26 44.3412 115.26 44.4437V87.7935C115.26 87.8961 115.177 87.979 115.075 87.979Z",
    fill: "url(#paint71_linear_376_5139)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M106.102 17.8825H85.8541C85.7517 17.8825 85.6689 17.7996 85.6689 17.697C85.6689 17.5945 85.7517 17.5116 85.8541 17.5116H105.917V6.18984C105.917 6.08725 105.999 6.00439 106.102 6.00439C106.204 6.00439 106.287 6.08725 106.287 6.18984V17.697C106.287 17.7996 106.204 17.8825 106.102 17.8825Z",
    fill: "url(#paint72_linear_376_5139)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M144.294 17.8825H124.047C123.944 17.8825 123.861 17.7996 123.861 17.697V6.18984C123.861 6.08725 123.944 6.00439 124.047 6.00439C124.149 6.00439 124.232 6.08725 124.232 6.18984V17.5116H144.294C144.397 17.5116 144.48 17.5945 144.48 17.697C144.48 17.7996 144.397 17.8825 144.294 17.8825Z",
    fill: "url(#paint73_linear_376_5139)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M134.24 45.4208C134.207 45.4208 134.175 45.413 134.148 45.3952L123.954 39.5005C123.897 39.467 123.861 39.4058 123.861 39.3388V28.0643C123.861 27.9618 123.944 27.8789 124.047 27.8789H143.89C143.957 27.8789 144.017 27.9144 144.05 27.9716C144.084 28.0288 144.084 28.0999 144.05 28.1571L134.4 45.3261C134.376 45.3695 134.335 45.4011 134.288 45.4149C134.272 45.4189 134.254 45.4208 134.238 45.4208H134.24ZM124.232 39.2342L134.171 44.9809L143.573 28.2537H124.234V39.2362L124.232 39.2342Z",
    fill: "url(#paint74_linear_376_5139)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9083 45.4208C95.8925 45.4208 95.8748 45.4189 95.859 45.4149C95.8117 45.4011 95.7704 45.3695 95.7467 45.3261L86.0967 28.1571C86.0632 28.0999 86.0651 28.0288 86.0967 27.9716C86.1301 27.9144 86.1912 27.8789 86.2562 27.8789H106.1C106.203 27.8789 106.285 27.9618 106.285 28.0643V39.3388C106.285 39.4058 106.25 39.467 106.193 39.5005L95.9989 45.3952C95.9713 45.411 95.9378 45.4208 95.9063 45.4208H95.9083ZM86.5754 28.2518L95.9772 44.9789L105.915 39.2322V28.2498H86.5754V28.2518Z",
    fill: "url(#paint75_linear_376_5139)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9338 55.7241C76.8687 55.7241 76.8057 55.6906 76.7722 55.6275C76.7229 55.5387 76.7545 55.4243 76.8451 55.3749L86.3316 50.1057L76.7742 33.1003C76.7249 33.0115 76.7545 32.8971 76.8451 32.8478C76.9338 32.7965 77.048 32.8281 77.0973 32.9188L86.7473 50.0879C86.773 50.1313 86.7769 50.1826 86.7631 50.2299C86.7493 50.2773 86.7178 50.3187 86.6744 50.3424L77.0244 55.7024C76.9968 55.7182 76.9653 55.7261 76.9338 55.7261V55.7241Z",
    fill: "url(#paint76_linear_376_5139)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M153.214 55.7246C153.184 55.7246 153.153 55.7167 153.123 55.701L143.473 50.3409C143.43 50.3173 143.398 50.2758 143.384 50.2285C143.37 50.1811 143.376 50.1298 143.4 50.0864L153.05 32.9174C153.101 32.8266 153.214 32.7951 153.302 32.8463C153.391 32.8957 153.422 33.0101 153.373 33.0989L143.816 50.1042L153.302 55.3735C153.393 55.4228 153.424 55.5372 153.375 55.626C153.342 55.6872 153.279 55.7227 153.214 55.7227V55.7246Z",
    fill: "url(#paint77_linear_376_5139)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 77.8847C115.042 77.8847 115.009 77.8768 114.979 77.859C114.891 77.8058 114.861 77.6933 114.912 77.6045L125.012 60.4512L114.979 54.6513C114.891 54.6 114.861 54.4856 114.91 54.3968C114.962 54.308 115.078 54.2765 115.165 54.3297L125.358 60.2244C125.402 60.25 125.433 60.2895 125.445 60.3388C125.457 60.3861 125.451 60.4374 125.425 60.4808L115.232 77.7959C115.196 77.8551 115.135 77.8867 115.072 77.8867L115.074 77.8847Z",
    fill: "url(#paint78_linear_376_5139)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 77.8843C115.011 77.8843 114.948 77.8508 114.915 77.7936L104.721 60.4785C104.695 60.4351 104.689 60.3858 104.701 60.3365C104.715 60.2891 104.744 60.2477 104.788 60.222L114.982 54.3274C115.068 54.2761 115.183 54.3057 115.236 54.3945C115.287 54.4832 115.256 54.5977 115.167 54.6489L105.135 60.4489L115.234 77.6022C115.285 77.691 115.256 77.8054 115.169 77.8567C115.139 77.8744 115.106 77.8823 115.074 77.8823V77.8843Z",
    fill: "url(#paint79_linear_376_5139)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M124.486 82.6292C124.455 82.6292 124.421 82.6213 124.392 82.6036C124.303 82.5503 124.274 82.4379 124.325 82.3491L134.399 65.2392C134.452 65.1504 134.564 65.1208 134.651 65.1721L144.583 70.9129C144.671 70.9642 144.701 71.0786 144.652 71.1674C144.598 71.2562 144.484 71.2857 144.397 71.2345L134.625 65.5844L124.646 82.5365C124.611 82.5957 124.55 82.6272 124.486 82.6272V82.6292Z",
    fill: "url(#paint80_linear_376_5139)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M105.66 82.6288C105.597 82.6288 105.534 82.5953 105.501 82.5381L95.5217 65.586L85.7495 71.236C85.6628 71.2873 85.5465 71.2577 85.4953 71.1689C85.4441 71.0802 85.4756 70.9657 85.5643 70.9145L95.4961 65.1737C95.5827 65.1244 95.697 65.152 95.7482 65.2407L105.822 82.3506C105.873 82.4394 105.844 82.5538 105.757 82.6051C105.727 82.6229 105.694 82.6308 105.662 82.6308L105.66 82.6288Z",
    fill: "url(#paint81_linear_376_5139)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 218.031C115.043 218.031 115.011 218.023 114.984 218.007L76.8426 196.33C76.7855 196.297 76.748 196.236 76.748 196.169V152.819C76.748 152.752 76.7835 152.691 76.8426 152.657L114.984 130.982C115.041 130.949 115.11 130.949 115.167 130.982L153.308 152.657C153.365 152.691 153.403 152.752 153.403 152.819V196.169C153.403 196.236 153.367 196.297 153.308 196.33L115.167 218.007C115.139 218.023 115.108 218.031 115.076 218.031H115.074ZM77.1204 196.06L115.074 217.63L153.028 196.06V152.925L115.074 131.355L77.1204 152.925V196.06Z",
    fill: "url(#paint82_linear_376_5139)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 174.681C115.043 174.681 115.012 174.673 114.984 174.657L76.8432 152.982C76.7545 152.931 76.723 152.819 76.7723 152.73C76.8235 152.639 76.9358 152.607 77.0245 152.661L115.073 174.284L153.122 152.661C153.21 152.607 153.323 152.641 153.374 152.73C153.423 152.819 153.394 152.933 153.303 152.982L115.162 174.657C115.134 174.673 115.103 174.681 115.071 174.681H115.075Z",
    fill: "url(#paint83_linear_376_5139)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 218.031C114.972 218.031 114.89 217.948 114.89 217.845V174.494C114.89 174.391 114.972 174.308 115.075 174.308C115.177 174.308 115.26 174.391 115.26 174.494V217.845C115.26 217.948 115.177 218.031 115.075 218.031Z",
    fill: "url(#paint84_linear_376_5139)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3712 152.17C89.468 152.17 87.9746 151.284 87.9746 150.153C87.9746 149.023 89.4661 148.137 91.3712 148.137C93.2764 148.137 94.7679 149.023 94.7679 150.153C94.7679 151.284 93.2764 152.17 91.3712 152.17ZM91.3712 148.508C89.732 148.508 88.347 149.262 88.347 150.153C88.347 151.045 89.732 151.799 91.3712 151.799C93.0105 151.799 94.3955 151.045 94.3955 150.153C94.3955 149.262 93.0105 148.508 91.3712 148.508Z",
    fill: "url(#paint85_linear_376_5139)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M100.897 157.64C98.9934 157.64 97.5 156.754 97.5 155.624C97.5 154.494 98.9914 153.608 100.897 153.608C102.802 153.608 104.291 154.494 104.291 155.624C104.291 156.754 102.8 157.64 100.897 157.64ZM100.897 153.979C99.2574 153.979 97.8724 154.732 97.8724 155.624C97.8724 156.516 99.2574 157.269 100.897 157.269C102.536 157.269 103.921 156.516 103.921 155.624C103.921 154.732 102.536 153.979 100.897 153.979Z",
    fill: "url(#paint86_linear_376_5139)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M110.421 163.112C108.518 163.112 107.024 162.227 107.024 161.096C107.024 159.966 108.516 159.08 110.421 159.08C112.326 159.08 113.818 159.966 113.818 161.096C113.818 162.227 112.326 163.112 110.421 163.112ZM110.421 159.451C108.782 159.451 107.397 160.205 107.397 161.096C107.397 161.988 108.782 162.742 110.421 162.742C112.06 162.742 113.445 161.988 113.445 161.096C113.445 160.205 112.06 159.451 110.421 159.451Z",
    fill: "url(#paint87_linear_376_5139)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M119.946 168.583C118.043 168.583 116.55 167.697 116.55 166.567C116.55 165.437 118.041 164.551 119.946 164.551C121.852 164.551 123.343 165.437 123.343 166.567C123.343 167.697 121.852 168.583 119.946 168.583ZM119.946 164.922C118.307 164.922 116.922 165.675 116.922 166.567C116.922 167.459 118.307 168.212 119.946 168.212C121.586 168.212 122.971 167.459 122.971 166.567C122.971 165.675 121.586 164.922 119.946 164.922Z",
    fill: "url(#paint88_linear_376_5139)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1315 143.904C95.2508 143.904 94.4194 143.709 93.787 143.353C93.6963 143.304 93.6668 143.19 93.716 143.101C93.7653 143.01 93.8815 142.979 93.9682 143.03C94.5455 143.353 95.3139 143.533 96.1315 143.533C97.7707 143.533 99.1558 142.779 99.1558 141.888C99.1558 141.475 98.8622 141.077 98.3303 140.767C98.2416 140.716 98.212 140.601 98.2633 140.513C98.3145 140.424 98.4268 140.394 98.5174 140.446C99.1676 140.824 99.5262 141.337 99.5262 141.888C99.5262 143.018 98.0347 143.904 96.1295 143.904H96.1315Z",
    fill: "url(#paint89_linear_376_5139)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M105.656 149.374C103.753 149.374 102.26 148.488 102.26 147.358C102.26 146.228 103.751 145.342 105.656 145.342C107.562 145.342 109.053 146.228 109.053 147.358C109.053 148.488 107.562 149.374 105.656 149.374ZM105.656 145.713C104.017 145.713 102.632 146.466 102.632 147.358C102.632 148.25 104.017 149.003 105.656 149.003C107.296 149.003 108.681 148.25 108.681 147.358C108.681 146.466 107.296 145.713 105.656 145.713Z",
    fill: "url(#paint90_linear_376_5139)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M115.183 154.845C113.28 154.845 111.786 153.959 111.786 152.829C111.786 151.698 113.278 150.812 115.183 150.812C117.088 150.812 118.579 151.698 118.579 152.829C118.579 153.959 117.088 154.845 115.183 154.845ZM115.183 151.183C113.544 151.183 112.159 151.937 112.159 152.829C112.159 153.72 113.544 154.474 115.183 154.474C116.822 154.474 118.207 153.72 118.207 152.829C118.207 151.937 116.822 151.183 115.183 151.183Z",
    fill: "url(#paint91_linear_376_5139)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M124.709 160.318C122.806 160.318 121.312 159.432 121.312 158.301C121.312 157.171 122.804 156.285 124.709 156.285C126.614 156.285 128.106 157.171 128.106 158.301C128.106 159.432 126.614 160.318 124.709 160.318ZM124.709 156.656C123.07 156.656 121.685 157.41 121.685 158.301C121.685 159.193 123.07 159.947 124.709 159.947C126.348 159.947 127.733 159.193 127.733 158.301C127.733 157.41 126.348 156.656 124.709 156.656Z",
    fill: "url(#paint92_linear_376_5139)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M131.819 165.164C131.784 165.164 131.75 165.154 131.719 165.135C131.149 164.766 130.838 164.283 130.838 163.772C130.838 162.641 132.329 161.755 134.233 161.755C135.044 161.755 135.828 161.925 136.441 162.233C136.532 162.278 136.569 162.391 136.524 162.481C136.477 162.574 136.366 162.61 136.274 162.564C135.712 162.282 134.989 162.126 134.233 162.126C132.593 162.126 131.208 162.88 131.208 163.772C131.208 164.15 131.46 164.525 131.92 164.823C132.006 164.878 132.03 164.995 131.975 165.081C131.939 165.137 131.88 165.166 131.819 165.166V165.164Z",
    fill: "url(#paint93_linear_376_5139)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2973 154.349C79.2322 154.349 79.1672 154.314 79.1337 154.251C79.0864 154.16 79.1199 154.048 79.2106 154C79.7918 153.689 80.1267 153.262 80.1267 152.83C80.1267 152.398 79.7878 151.962 79.1948 151.651C79.1042 151.603 79.0687 151.491 79.118 151.4C79.1653 151.309 79.2776 151.276 79.3682 151.323C80.0873 151.702 80.4991 152.252 80.4991 152.832C80.4991 153.412 80.105 153.947 79.3879 154.332C79.3603 154.347 79.3307 154.353 79.2992 154.353L79.2973 154.349Z",
    fill: "url(#paint94_linear_376_5139)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8765 159.792C88.8114 159.792 88.7484 159.759 88.7149 159.698C88.6656 159.609 88.6972 159.494 88.7858 159.445C89.3434 159.133 89.6507 158.727 89.6507 158.303C89.6507 157.411 88.2657 156.658 86.6265 156.658C85.7872 156.658 85.005 156.845 84.4238 157.184C84.3332 157.236 84.2209 157.206 84.1696 157.117C84.1184 157.028 84.148 156.914 84.2366 156.863C84.875 156.49 85.7222 156.287 86.6265 156.287C88.5297 156.287 90.0231 157.172 90.0231 158.303C90.0231 158.869 89.6488 159.39 88.9691 159.771C88.9395 159.786 88.9099 159.794 88.8784 159.794L88.8765 159.792Z",
    fill: "url(#paint95_linear_376_5139)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4517 165.233C98.3887 165.233 98.3256 165.2 98.2922 165.141C98.2409 165.052 98.2705 164.937 98.3591 164.886C98.8872 164.578 99.1768 164.182 99.1768 163.77C99.1768 162.878 97.7917 162.124 96.1525 162.124C95.3388 162.124 94.5724 162.302 93.9971 162.623C93.9065 162.673 93.7942 162.641 93.7449 162.552C93.6957 162.464 93.7272 162.349 93.8158 162.3C94.4463 161.949 95.2777 161.753 96.1525 161.753C98.0557 161.753 99.5491 162.639 99.5491 163.77C99.5491 164.318 99.1945 164.829 98.5483 165.206C98.5187 165.224 98.4872 165.231 98.4537 165.231L98.4517 165.233Z",
    fill: "url(#paint96_linear_376_5139)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M113.061 173.537C112.994 173.537 112.929 173.499 112.896 173.436C112.848 173.345 112.886 173.233 112.976 173.186C113.591 172.872 114.381 172.698 115.203 172.698C115.965 172.698 116.684 172.842 117.283 173.114C117.378 173.158 117.417 173.266 117.376 173.361C117.332 173.456 117.222 173.495 117.13 173.454C116.588 173.207 115.902 173.071 115.203 173.071C114.44 173.071 113.709 173.229 113.146 173.517C113.118 173.531 113.091 173.537 113.061 173.537Z",
    fill: "url(#paint97_linear_376_5139)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M110.358 141.309C108.454 141.309 106.961 140.423 106.961 139.293C106.961 138.163 108.452 137.277 110.358 137.277C112.263 137.277 113.754 138.163 113.754 139.293C113.754 140.423 112.263 141.309 110.358 141.309ZM110.358 137.648C108.718 137.648 107.333 138.401 107.333 139.293C107.333 140.185 108.718 140.938 110.358 140.938C111.997 140.938 113.382 140.185 113.382 139.293C113.382 138.401 111.997 137.648 110.358 137.648Z",
    fill: "url(#paint98_linear_376_5139)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M119.884 146.78C117.981 146.78 116.487 145.894 116.487 144.764C116.487 143.633 117.979 142.748 119.884 142.748C121.789 142.748 123.281 143.633 123.281 144.764C123.281 145.894 121.789 146.78 119.884 146.78ZM119.884 143.118C118.245 143.118 116.86 143.872 116.86 144.764C116.86 145.655 118.245 146.409 119.884 146.409C121.523 146.409 122.908 145.655 122.908 144.764C122.908 143.872 121.523 143.118 119.884 143.118Z",
    fill: "url(#paint99_linear_376_5139)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M129.409 152.251C127.506 152.251 126.013 151.365 126.013 150.234C126.013 149.104 127.504 148.218 129.409 148.218C131.315 148.218 132.806 149.104 132.806 150.234C132.806 151.365 131.315 152.251 129.409 152.251ZM129.409 148.589C127.77 148.589 126.385 149.343 126.385 150.234C126.385 151.126 127.77 151.88 129.409 151.88C131.049 151.88 132.434 151.126 132.434 150.234C132.434 149.343 131.049 148.589 129.409 148.589Z",
    fill: "url(#paint100_linear_376_5139)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M138.936 157.723C137.032 157.723 135.539 156.838 135.539 155.707C135.539 154.577 137.031 153.691 138.936 153.691C140.841 153.691 142.33 154.577 142.33 155.707C142.33 156.838 140.839 157.723 138.936 157.723ZM138.936 154.062C137.296 154.062 135.911 154.815 135.911 155.707C135.911 156.599 137.296 157.352 138.936 157.352C140.575 157.352 141.96 156.599 141.96 155.707C141.96 154.815 140.575 154.062 138.936 154.062Z",
    fill: "url(#paint101_linear_376_5139)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 133.16C114.183 133.16 113.341 132.961 112.707 132.596C112.618 132.544 112.587 132.432 112.638 132.343C112.687 132.254 112.801 132.223 112.89 132.274C113.469 132.606 114.246 132.789 115.073 132.789C115.901 132.789 116.675 132.608 117.254 132.276C117.343 132.225 117.457 132.256 117.506 132.345C117.557 132.434 117.526 132.548 117.437 132.6C116.803 132.963 115.962 133.162 115.071 133.162L115.075 133.16Z",
    fill: "url(#paint102_linear_376_5139)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M124.6 138.63C122.697 138.63 121.203 137.744 121.203 136.614C121.203 136.04 121.587 135.511 122.287 135.131C122.375 135.081 122.49 135.113 122.539 135.206C122.588 135.296 122.555 135.409 122.464 135.458C121.889 135.772 121.574 136.184 121.574 136.616C121.574 137.508 122.959 138.261 124.598 138.261C125.439 138.261 126.251 138.064 126.826 137.721C126.913 137.668 127.027 137.695 127.08 137.786C127.131 137.875 127.104 137.989 127.015 138.04C126.375 138.423 125.516 138.634 124.596 138.634L124.6 138.63Z",
    fill: "url(#paint103_linear_376_5139)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M134.124 144.103C132.221 144.103 130.728 143.217 130.728 142.087C130.728 141.505 131.143 140.952 131.868 140.574C131.957 140.526 132.071 140.562 132.119 140.653C132.166 140.743 132.13 140.856 132.04 140.903C131.443 141.217 131.098 141.647 131.098 142.087C131.098 142.979 132.483 143.732 134.122 143.732C134.989 143.732 135.819 143.525 136.396 143.164C136.484 143.111 136.599 143.134 136.652 143.223C136.707 143.31 136.68 143.424 136.593 143.48C135.956 143.878 135.056 144.105 134.122 144.105L134.124 144.103Z",
    fill: "url(#paint104_linear_376_5139)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M143.651 149.574C141.747 149.574 140.254 148.688 140.254 147.558C140.254 146.958 140.689 146.396 141.452 146.015C141.542 145.97 141.655 146.007 141.7 146.098C141.745 146.19 141.708 146.301 141.617 146.346C140.987 146.662 140.626 147.102 140.626 147.556C140.626 148.447 142.011 149.201 143.651 149.201C144.545 149.201 145.39 148.984 145.969 148.603C146.054 148.548 146.17 148.572 146.226 148.656C146.283 148.743 146.257 148.858 146.172 148.915C145.534 149.333 144.614 149.574 143.651 149.574Z",
    fill: "url(#paint105_linear_376_5139)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M150.743 154.409C150.707 154.409 150.672 154.399 150.64 154.377C150.085 154.01 149.779 153.531 149.779 153.028C149.779 152.41 150.236 151.838 151.034 151.458C151.125 151.414 151.237 151.454 151.283 151.544C151.326 151.637 151.288 151.748 151.194 151.793C150.532 152.111 150.152 152.56 150.152 153.028C150.152 153.403 150.398 153.772 150.845 154.068C150.93 154.125 150.956 154.239 150.898 154.326C150.863 154.379 150.804 154.409 150.743 154.409Z",
    fill: "url(#paint106_linear_376_5139)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M108.027 170.676C107.964 170.676 107.903 170.645 107.87 170.588C107.817 170.501 107.844 170.386 107.931 170.331C108.429 170.027 108.703 169.641 108.703 169.242C108.703 168.351 107.318 167.597 105.679 167.597C104.887 167.597 104.138 167.765 103.571 168.068C103.482 168.116 103.368 168.084 103.321 167.993C103.271 167.903 103.305 167.79 103.395 167.741C104.014 167.408 104.826 167.224 105.679 167.224C107.582 167.224 109.076 168.11 109.076 169.24C109.076 169.773 108.739 170.27 108.126 170.645C108.096 170.663 108.063 170.673 108.029 170.673L108.027 170.676Z",
    fill: "url(#paint107_linear_376_5139)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8538 169.463C81.9357 169.463 80.8324 168.686 80.0758 167.417C79.467 166.397 79.2326 165.293 79.4493 164.462C79.5616 164.03 79.7941 163.7 80.1231 163.511C81.1102 162.941 82.6391 163.76 83.6045 165.375C84.2132 166.397 84.4477 167.502 84.231 168.331C84.1187 168.763 83.8842 169.092 83.5572 169.281C83.3444 169.404 83.106 169.463 82.8558 169.463H82.8538ZM80.8127 163.706C80.6275 163.706 80.458 163.748 80.3083 163.835C80.0679 163.973 79.8946 164.223 79.8079 164.559C79.6207 165.283 79.8453 166.307 80.395 167.23C81.2244 168.623 82.5898 169.416 83.37 168.962C83.6104 168.822 83.7837 168.573 83.8704 168.238C84.0596 167.514 83.835 166.49 83.2833 165.567C82.6115 164.442 81.5929 163.706 80.8127 163.706Z",
    fill: "url(#paint108_linear_376_5139)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4192 174.93C91.5011 174.93 90.3978 174.153 89.6412 172.884C89.0325 171.862 88.798 170.757 89.0147 169.929C89.127 169.497 89.3595 169.167 89.6885 168.978C90.6795 168.406 92.2065 169.225 93.1699 170.842C93.7787 171.864 94.0131 172.969 93.7964 173.797C93.6841 174.229 93.4516 174.559 93.1226 174.748C92.9098 174.871 92.6714 174.93 92.4192 174.93ZM90.3801 169.173C90.1949 169.173 90.0254 169.215 89.8737 169.301C89.6334 169.44 89.46 169.69 89.3733 170.023C89.1842 170.747 89.4088 171.771 89.9604 172.695C90.7899 174.085 92.1493 174.878 92.9354 174.427C93.1758 174.287 93.3492 174.038 93.4359 173.705C93.625 172.981 93.4004 171.957 92.8487 171.034C92.1789 169.909 91.1583 169.173 90.3781 169.173H90.3801Z",
    fill: "url(#paint109_linear_376_5139)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M101.985 180.398C101.067 180.398 99.9632 179.621 99.2067 178.354C98.5979 177.332 98.3634 176.228 98.5802 175.399C98.6925 174.967 98.9269 174.637 99.254 174.448C100.241 173.878 101.77 174.697 102.733 176.312C103.342 177.332 103.577 178.437 103.36 179.268C103.248 179.7 103.015 180.029 102.686 180.218C102.473 180.341 102.235 180.4 101.985 180.4V180.398ZM99.9435 174.641C99.7583 174.641 99.5889 174.683 99.4392 174.77C99.1988 174.91 99.0254 175.158 98.9387 175.494C98.7496 176.218 98.9742 177.242 99.5258 178.165C100.355 179.556 101.719 180.349 102.501 179.897C102.741 179.759 102.915 179.508 103.001 179.173C103.188 178.449 102.964 177.425 102.414 176.502C101.742 175.377 100.724 174.641 99.9435 174.641Z",
    fill: "url(#paint110_linear_376_5139)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M111.55 185.865C110.632 185.865 109.529 185.087 108.772 183.821C108.163 182.799 107.929 181.694 108.146 180.866C108.258 180.434 108.49 180.104 108.819 179.915C109.806 179.343 111.335 180.163 112.299 181.779C112.908 182.799 113.142 183.904 112.925 184.734C112.813 185.166 112.581 185.496 112.251 185.685C112.039 185.807 111.8 185.867 111.55 185.867V185.865ZM109.509 180.108C109.324 180.108 109.154 180.149 109.005 180.236C108.764 180.376 108.591 180.625 108.504 180.96C108.317 181.684 108.54 182.708 109.091 183.631C109.921 185.022 111.286 185.815 112.066 185.364C112.307 185.225 112.48 184.975 112.567 184.64C112.754 183.915 112.529 182.892 111.98 181.968C111.31 180.842 110.289 180.108 109.509 180.108Z",
    fill: "url(#paint111_linear_376_5139)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0247 177.567C77.6563 177.567 77.2485 177.443 76.8387 177.198C76.75 177.145 76.7224 177.031 76.7737 176.944C76.8269 176.855 76.9411 176.826 77.0278 176.879C77.5992 177.22 78.1469 177.291 78.5311 177.068C78.7715 176.93 78.9448 176.68 79.0315 176.344C79.2187 175.62 78.9941 174.596 78.4444 173.673C78.0188 172.961 77.4376 172.371 76.8466 172.057C76.7559 172.01 76.7224 171.898 76.7697 171.807C76.817 171.716 76.9313 171.683 77.0199 171.73C77.678 172.079 78.2986 172.702 78.7636 173.484C79.3724 174.504 79.6068 175.608 79.3901 176.439C79.2778 176.871 79.0453 177.2 78.7163 177.39C78.5114 177.508 78.2769 177.567 78.0228 177.567H78.0247Z",
    fill: "url(#paint112_linear_376_5139)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5804 183.039C86.6623 183.039 85.5589 182.262 84.8024 180.994C84.1936 179.974 83.9591 178.869 84.1759 178.038C84.2882 177.606 84.5206 177.277 84.8497 177.088C85.8387 176.515 87.3656 177.336 88.331 178.95C88.9398 179.972 89.1743 181.077 88.9575 181.905C88.8452 182.337 88.6128 182.667 88.2837 182.856C88.071 182.978 87.8326 183.037 87.5823 183.037L87.5804 183.039ZM85.5392 177.283C85.354 177.283 85.1846 177.324 85.0349 177.411C84.7945 177.551 84.6211 177.8 84.5344 178.135C84.3473 178.859 84.5719 179.883 85.1216 180.806C85.951 182.197 87.3164 182.992 88.0966 182.538C88.3369 182.398 88.5103 182.15 88.597 181.814C88.7861 181.09 88.5615 180.066 88.0099 179.143C87.338 178.019 86.3194 177.283 85.5392 177.283Z",
    fill: "url(#paint113_linear_376_5139)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1458 188.506C96.2277 188.506 95.1243 187.729 94.3698 186.46C93.761 185.441 93.5265 184.336 93.7432 183.505C93.8555 183.073 94.088 182.744 94.4171 182.554C95.4041 181.982 96.933 182.803 97.8984 184.417C98.5072 185.439 98.7417 186.543 98.5249 187.374C98.4126 187.806 98.1782 188.135 97.8511 188.325C97.6383 188.447 97.3999 188.506 97.1478 188.506H97.1458ZM95.1066 182.75C94.9214 182.75 94.752 182.791 94.6023 182.876C94.3619 183.014 94.1885 183.265 94.1018 183.6C93.9146 184.324 94.1393 185.348 94.6889 186.271C95.5184 187.662 96.8837 188.457 97.6639 188.003C97.9043 187.863 98.0777 187.615 98.1644 187.281C98.3535 186.557 98.1289 185.533 97.5773 184.61C96.9054 183.486 95.8868 182.752 95.1066 182.752V182.75Z",
    fill: "url(#paint114_linear_376_5139)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M106.711 193.975C105.793 193.975 104.69 193.198 103.933 191.929C103.324 190.907 103.09 189.802 103.307 188.974C103.419 188.542 103.652 188.212 103.981 188.023C104.966 187.453 106.496 188.27 107.462 189.887C108.071 190.909 108.305 192.014 108.088 192.843C107.976 193.275 107.742 193.604 107.415 193.793C107.202 193.916 106.963 193.975 106.711 193.975ZM104.67 188.218C104.485 188.218 104.315 188.26 104.166 188.347C103.925 188.485 103.752 188.735 103.665 189.069C103.476 189.793 103.701 190.816 104.252 191.74C105.082 193.133 106.443 193.922 107.227 193.472C107.468 193.334 107.641 193.083 107.728 192.75C107.917 192.026 107.692 191.002 107.141 190.079C106.469 188.954 105.45 188.218 104.67 188.218Z",
    fill: "url(#paint115_linear_376_5139)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 199.019C115.038 199.019 115.003 199.009 114.971 198.99C114.416 198.625 113.894 198.06 113.498 197.398C112.889 196.376 112.654 195.271 112.871 194.442C112.983 194.01 113.218 193.681 113.545 193.492C113.982 193.239 114.554 193.257 115.153 193.539C115.245 193.582 115.285 193.693 115.241 193.785C115.198 193.878 115.086 193.918 114.993 193.874C114.506 193.645 114.057 193.624 113.73 193.813C113.49 193.953 113.316 194.202 113.23 194.537C113.041 195.261 113.265 196.285 113.817 197.208C114.183 197.824 114.666 198.347 115.174 198.68C115.261 198.737 115.285 198.852 115.228 198.938C115.192 198.994 115.133 199.023 115.072 199.023L115.074 199.019Z",
    fill: "url(#paint116_linear_376_5139)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2775 197.688C79.2775 197.688 79.2696 197.688 79.2637 197.688C79.1613 197.68 79.0844 197.591 79.0923 197.488C79.1396 196.798 78.9051 195.96 78.4461 195.19C78.0225 194.478 77.4393 193.888 76.8482 193.574C76.7576 193.527 76.7241 193.415 76.7714 193.324C76.8187 193.233 76.9329 193.2 77.0216 193.247C77.6816 193.596 78.3003 194.22 78.7652 195.001C79.2617 195.833 79.5159 196.751 79.4627 197.514C79.4568 197.613 79.374 197.688 79.2775 197.688Z",
    fill: "url(#paint117_linear_376_5139)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8447 203.124C88.8447 203.124 88.8368 203.124 88.8329 203.124C88.7304 203.118 88.6516 203.032 88.6575 202.929C88.6969 202.244 88.4605 201.418 88.0093 200.66C87.1798 199.269 85.8165 198.478 85.0343 198.928C84.6442 199.153 84.4393 199.668 84.4728 200.341C84.4787 200.443 84.3979 200.53 84.2955 200.536C84.197 200.542 84.1063 200.461 84.1004 200.36C84.061 199.544 84.3349 198.905 84.8491 198.607C85.8381 198.035 87.365 198.855 88.3304 200.469C88.8191 201.288 89.0732 202.193 89.0299 202.951C89.024 203.049 88.9412 203.126 88.8447 203.126V203.124Z",
    fill: "url(#paint118_linear_376_5139)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4105 208.561C98.4105 208.561 98.4046 208.561 98.4026 208.561C98.3002 208.557 98.2214 208.47 98.2253 208.368C98.2568 207.689 98.0204 206.872 97.5751 206.129C96.7457 204.738 95.3823 203.945 94.6001 204.397C94.2179 204.618 94.011 205.121 94.0366 205.778C94.0406 205.88 93.9598 205.967 93.8574 205.971C93.7766 205.971 93.6682 205.894 93.6643 205.791C93.6347 204.992 93.9086 204.367 94.413 204.073C95.4 203.503 96.9289 204.322 97.8943 205.937C98.375 206.744 98.6312 207.636 98.5957 208.386C98.5898 208.484 98.509 208.563 98.4105 208.563V208.561Z",
    fill: "url(#paint119_linear_376_5139)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M107.978 213.998H107.972C107.87 213.994 107.789 213.908 107.793 213.805C107.816 213.132 107.58 212.325 107.143 211.594C106.315 210.203 104.95 209.408 104.168 209.861C103.785 210.082 103.584 210.562 103.604 211.215C103.606 211.317 103.525 211.402 103.423 211.406C103.342 211.41 103.236 211.327 103.232 211.225C103.21 210.441 103.484 209.828 103.982 209.54C104.967 208.968 106.498 209.787 107.464 211.404C107.937 212.197 108.193 213.077 108.167 213.819C108.163 213.92 108.08 213.998 107.982 213.998H107.978Z",
    fill: "url(#paint120_linear_376_5139)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M112.98 216.842C112.878 216.842 112.795 216.761 112.795 216.658C112.783 215.881 113.049 215.295 113.546 215.007C113.983 214.754 114.555 214.772 115.154 215.052C115.246 215.096 115.286 215.206 115.242 215.301C115.199 215.394 115.087 215.431 114.994 215.39C114.507 215.161 114.06 215.139 113.731 215.328C113.357 215.545 113.156 216.015 113.166 216.65C113.166 216.753 113.085 216.838 112.982 216.84H112.98V216.842Z",
    fill: "url(#paint121_linear_376_5139)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0247 155.794C77.6563 155.794 77.2485 155.669 76.8387 155.425C76.75 155.371 76.7224 155.257 76.7737 155.17C76.8269 155.081 76.9411 155.052 77.0278 155.105C77.5992 155.446 78.1469 155.515 78.5311 155.295C78.868 155.099 79.067 154.691 79.0926 154.144C79.0985 154.042 79.197 153.959 79.2876 153.967C79.3901 153.971 79.4689 154.058 79.465 154.16C79.4334 154.839 79.1675 155.356 78.7163 155.616C78.5114 155.734 78.2769 155.794 78.0228 155.794H78.0247Z",
    fill: "url(#paint122_linear_376_5139)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M87.58 161.264C86.6619 161.264 85.5586 160.487 84.804 159.218C84.3705 158.49 84.1203 157.703 84.1006 157.001C84.0987 156.898 84.1775 156.814 84.2819 156.81H84.2878C84.3883 156.81 84.471 156.888 84.473 156.991C84.4907 157.63 84.7232 158.354 85.1251 159.029C85.9526 160.42 87.3199 161.215 88.1001 160.761C88.443 160.562 88.6439 160.144 88.6636 159.581C88.6676 159.479 88.768 159.41 88.8567 159.402C88.9591 159.406 89.0399 159.493 89.036 159.595C89.0104 160.29 88.7444 160.818 88.2873 161.083C88.0745 161.205 87.8361 161.264 87.5839 161.264H87.58Z",
    fill: "url(#paint123_linear_376_5139)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1455 166.733C96.2274 166.733 95.124 165.955 94.3675 164.687C93.9281 163.949 93.6779 163.152 93.6621 162.444C93.6602 162.341 93.741 162.256 93.8434 162.254H93.8473C93.9478 162.254 94.0306 162.335 94.0325 162.436C94.0463 163.083 94.2768 163.815 94.6847 164.497C95.5141 165.888 96.8795 166.681 97.6597 166.23C98.0104 166.026 98.2113 165.598 98.2251 165.02C98.2271 164.92 98.3099 164.839 98.4103 164.839H98.4143C98.5167 164.841 98.5975 164.928 98.5955 165.03C98.5778 165.742 98.3118 166.283 97.8449 166.553C97.6321 166.675 97.3937 166.735 97.1435 166.735L97.1455 166.733Z",
    fill: "url(#paint124_linear_376_5139)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M106.711 172.201C105.793 172.201 104.689 171.424 103.933 170.156C103.484 169.404 103.233 168.593 103.228 167.873C103.228 167.769 103.298 167.682 103.413 167.686C103.515 167.686 103.598 167.769 103.598 167.871C103.604 168.526 103.834 169.27 104.25 169.966C105.078 171.357 106.443 172.154 107.225 171.698C107.582 171.493 107.783 171.053 107.791 170.461C107.791 170.359 107.875 170.278 107.976 170.278H107.978C108.08 170.278 108.163 170.363 108.161 170.467C108.151 171.195 107.885 171.748 107.41 172.022C107.197 172.144 106.959 172.203 106.707 172.203L106.711 172.201Z",
    fill: "url(#paint125_linear_376_5139)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 177.246C115.038 177.246 115.003 177.236 114.971 177.216C114.416 176.853 113.894 176.287 113.498 175.624C113.025 174.829 112.781 174.026 112.792 173.302C112.792 173.2 112.877 173.119 112.978 173.119H112.98C113.082 173.119 113.165 173.205 113.163 173.308C113.151 173.963 113.378 174.699 113.815 175.433C114.181 176.048 114.664 176.571 115.172 176.904C115.259 176.962 115.283 177.076 115.226 177.161C115.19 177.216 115.131 177.246 115.07 177.246H115.074Z",
    fill: "url(#paint126_linear_376_5139)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7972 191.075C81.8791 191.075 80.7757 190.297 80.0192 189.029C79.4104 188.007 79.1759 186.902 79.3927 186.074C79.505 185.641 79.7374 185.312 80.0665 185.123C81.0535 184.553 82.5844 185.369 83.5478 186.987C84.1566 188.009 84.3911 189.114 84.1743 189.942C84.062 190.374 83.8276 190.704 83.5005 190.893C83.2877 191.015 83.0494 191.075 82.7972 191.075ZM80.756 185.318C80.5708 185.318 80.4014 185.359 80.2517 185.446C80.0113 185.584 79.8379 185.835 79.7512 186.168C79.5621 186.892 79.7867 187.916 80.3384 188.839C81.1678 190.232 82.5292 191.021 83.3134 190.571C83.5537 190.433 83.7271 190.183 83.8138 189.849C84.0029 189.125 83.7783 188.102 83.2267 187.176C82.5548 186.052 81.5362 185.316 80.756 185.316V185.318Z",
    fill: "url(#paint127_linear_376_5139)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3616 196.542C91.4435 196.542 90.3402 195.764 89.5836 194.498C88.9748 193.476 88.7404 192.371 88.9571 191.543C89.0694 191.111 89.3039 190.781 89.6309 190.592C90.618 190.022 92.1469 190.84 93.1103 192.456C93.7191 193.476 93.9535 194.581 93.7368 195.411C93.6245 195.843 93.392 196.173 93.063 196.362C92.8502 196.484 92.6118 196.544 92.3616 196.544V196.542ZM90.3205 190.785C90.1353 190.785 89.9658 190.826 89.8161 190.913C89.5757 191.053 89.4024 191.302 89.3157 191.637C89.1265 192.361 89.3511 193.385 89.9028 194.308C90.7323 195.699 92.0956 196.494 92.8778 196.04C93.1182 195.902 93.2915 195.652 93.3782 195.316C93.5654 194.592 93.3408 193.569 92.7911 192.645C92.1213 191.519 91.1007 190.785 90.3205 190.785Z",
    fill: "url(#paint128_linear_376_5139)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M101.927 202.01C101.009 202.01 99.9056 201.232 99.1491 199.964C98.5403 198.944 98.3058 197.839 98.5225 197.009C98.6348 196.577 98.8673 196.247 99.1963 196.058C100.183 195.486 101.712 196.306 102.676 197.922C103.285 198.942 103.519 200.047 103.302 200.877C103.19 201.309 102.957 201.639 102.628 201.828C102.416 201.95 102.177 202.01 101.927 202.01ZM99.8859 196.253C99.7007 196.253 99.5313 196.295 99.3815 196.381C99.1412 196.519 98.9678 196.77 98.8811 197.105C98.692 197.829 98.9166 198.853 99.4682 199.776C100.298 201.167 101.663 201.962 102.443 201.509C102.684 201.37 102.857 201.12 102.944 200.785C103.131 200.061 102.906 199.037 102.357 198.113C101.687 196.987 100.666 196.253 99.8859 196.253Z",
    fill: "url(#paint129_linear_376_5139)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M111.492 207.477C110.574 207.477 109.471 206.699 108.714 205.431C108.106 204.411 107.871 203.306 108.088 202.476C108.2 202.044 108.433 201.714 108.762 201.525C109.749 200.955 111.278 201.773 112.243 203.389C112.852 204.411 113.086 205.516 112.87 206.344C112.757 206.776 112.525 207.106 112.196 207.295C111.983 207.417 111.745 207.477 111.494 207.477H111.492ZM109.451 201.72C109.266 201.72 109.097 201.762 108.947 201.848C108.707 201.986 108.533 202.237 108.447 202.572C108.259 203.296 108.484 204.32 109.034 205.243C109.861 206.636 111.228 207.429 112.009 206.976C112.249 206.835 112.422 206.587 112.509 206.252C112.696 205.528 112.474 204.504 111.922 203.58C111.25 202.456 110.232 201.72 109.451 201.72Z",
    fill: "url(#paint130_linear_376_5139)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M147.432 169.463C147.179 169.463 146.941 169.404 146.73 169.282C146.401 169.092 146.169 168.763 146.056 168.331C145.84 167.5 146.076 166.396 146.683 165.376C147.646 163.76 149.173 162.943 150.162 163.513C150.491 163.703 150.724 164.032 150.836 164.464C151.053 165.295 150.816 166.399 150.21 167.419C149.453 168.688 148.35 169.465 147.432 169.465V169.463ZM149.473 163.707C148.693 163.707 147.674 164.44 147.002 165.567C146.452 166.49 146.226 167.514 146.415 168.238C146.502 168.571 146.675 168.822 146.915 168.962C147.698 169.416 149.061 168.621 149.89 167.23C150.44 166.307 150.667 165.283 150.478 164.559C150.391 164.225 150.218 163.975 149.977 163.837C149.827 163.75 149.656 163.709 149.473 163.709V163.707Z",
    fill: "url(#paint131_linear_376_5139)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M137.866 174.93C137.614 174.93 137.376 174.87 137.165 174.748C136.836 174.559 136.604 174.229 136.491 173.797C136.275 172.969 136.509 171.864 137.118 170.842C138.081 169.226 139.612 168.406 140.599 168.978C140.928 169.167 141.161 169.497 141.273 169.929C141.49 170.759 141.253 171.864 140.646 172.884C139.89 174.15 138.787 174.928 137.868 174.928L137.866 174.93ZM137.437 171.031C136.887 171.955 136.663 172.978 136.85 173.702C136.937 174.036 137.11 174.286 137.35 174.427C138.132 174.878 139.496 174.087 140.325 172.694C140.875 171.771 141.102 170.747 140.912 170.023C140.826 169.69 140.652 169.439 140.412 169.299C139.63 168.848 138.266 169.641 137.437 171.031Z",
    fill: "url(#paint132_linear_376_5139)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M128.3 180.398C128.048 180.398 127.809 180.339 127.597 180.217C127.27 180.027 127.035 179.698 126.923 179.266C126.708 178.437 126.943 177.33 127.549 176.31C128.513 174.695 130.044 173.876 131.031 174.446C131.36 174.636 131.592 174.965 131.704 175.397C131.919 176.226 131.685 177.332 131.078 178.352C130.321 179.621 129.218 180.398 128.3 180.398ZM127.87 176.5C127.321 177.423 127.094 178.447 127.283 179.173C127.37 179.506 127.543 179.757 127.784 179.895C128.568 180.349 129.931 179.556 130.759 178.163C131.308 177.24 131.535 176.216 131.346 175.492C131.259 175.158 131.086 174.908 130.845 174.77C130.063 174.318 128.7 175.111 127.87 176.502V176.5Z",
    fill: "url(#paint133_linear_376_5139)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M118.735 185.865C118.482 185.865 118.244 185.806 118.031 185.683C117.704 185.494 117.47 185.164 117.357 184.732C117.143 183.902 117.377 182.797 117.984 181.777C118.947 180.159 120.476 179.345 121.465 179.913C121.794 180.102 122.027 180.432 122.139 180.864C122.354 181.692 122.119 182.799 121.513 183.819C120.756 185.087 119.653 185.865 118.735 185.865ZM120.776 180.108C119.995 180.108 118.977 180.842 118.305 181.969C117.755 182.892 117.529 183.916 117.718 184.64C117.805 184.973 117.978 185.224 118.218 185.362C118.997 185.813 120.364 185.022 121.193 183.63C121.743 182.706 121.97 181.682 121.78 180.958C121.694 180.625 121.52 180.375 121.28 180.236C121.13 180.15 120.959 180.11 120.776 180.11V180.108Z",
    fill: "url(#paint134_linear_376_5139)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M152.262 177.569C152.008 177.569 151.773 177.51 151.566 177.39C151.237 177.2 151.005 176.871 150.893 176.439C150.678 175.61 150.912 174.504 151.519 173.484C151.947 172.766 152.516 172.174 153.119 171.813C153.206 171.759 153.32 171.789 153.373 171.878C153.426 171.967 153.397 172.081 153.308 172.132C152.756 172.462 152.234 173.01 151.838 173.675C151.289 174.598 151.062 175.622 151.251 176.346C151.338 176.679 151.511 176.93 151.752 177.068C152.108 177.273 152.597 177.232 153.127 176.952C153.215 176.904 153.33 176.938 153.377 177.029C153.424 177.119 153.391 177.232 153.3 177.279C152.938 177.471 152.585 177.567 152.262 177.567V177.569Z",
    fill: "url(#paint135_linear_376_5139)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M142.703 183.04C142.451 183.04 142.213 182.981 142.002 182.858C141.673 182.669 141.44 182.34 141.328 181.907C141.111 181.077 141.348 179.972 141.954 178.952C142.918 177.337 144.445 176.52 145.434 177.09C145.763 177.279 145.995 177.609 146.108 178.041C146.322 178.869 146.088 179.974 145.481 180.996C144.725 182.265 143.621 183.04 142.703 183.042V183.04ZM144.744 177.283C143.964 177.283 142.945 178.017 142.274 179.144C141.724 180.067 141.497 181.091 141.687 181.815C141.773 182.148 141.947 182.399 142.187 182.539C142.969 182.992 144.332 182.197 145.162 180.807C145.712 179.883 145.938 178.86 145.749 178.136C145.662 177.802 145.489 177.552 145.249 177.413C145.099 177.327 144.927 177.285 144.744 177.285V177.283Z",
    fill: "url(#paint136_linear_376_5139)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M133.139 188.506C132.887 188.506 132.648 188.447 132.437 188.324C132.108 188.135 131.876 187.806 131.763 187.374C131.547 186.543 131.783 185.438 132.39 184.418C133.353 182.803 134.882 181.984 135.869 182.556C136.198 182.745 136.431 183.075 136.543 183.507C136.76 184.336 136.525 185.44 135.917 186.462C135.16 187.731 134.057 188.508 133.139 188.508V188.506ZM135.18 182.749C134.4 182.749 133.381 183.483 132.709 184.61C132.159 185.533 131.933 186.557 132.122 187.281C132.209 187.614 132.382 187.865 132.622 188.003C133.407 188.459 134.768 187.664 135.597 186.271C136.147 185.348 136.372 184.324 136.185 183.6C136.098 183.266 135.925 183.016 135.684 182.876C135.534 182.789 135.363 182.747 135.18 182.747V182.749Z",
    fill: "url(#paint137_linear_376_5139)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M123.574 193.975C123.321 193.975 123.083 193.916 122.87 193.793C122.541 193.604 122.309 193.274 122.196 192.842C121.98 192.014 122.214 190.909 122.823 189.887C123.786 188.271 125.317 187.453 126.304 188.023C126.633 188.212 126.866 188.542 126.978 188.974C127.195 189.804 126.958 190.909 126.352 191.929C125.595 193.195 124.492 193.973 123.576 193.973L123.574 193.975ZM123.142 190.076C122.592 191 122.366 192.024 122.555 192.748C122.642 193.081 122.815 193.332 123.055 193.47C123.838 193.923 125.201 193.128 126.03 191.738C126.58 190.814 126.807 189.79 126.618 189.066C126.531 188.733 126.357 188.482 126.117 188.342C125.335 187.891 123.972 188.684 123.142 190.075V190.076Z",
    fill: "url(#paint138_linear_376_5139)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M115.095 199.094C115.032 199.094 114.969 199.061 114.935 199.001C114.884 198.913 114.913 198.798 115.002 198.747C115.552 198.425 116.06 197.893 116.468 197.206C117.018 196.283 117.244 195.259 117.055 194.535C116.968 194.202 116.795 193.951 116.555 193.811C116.194 193.604 115.699 193.647 115.162 193.937C115.073 193.985 114.959 193.951 114.911 193.862C114.862 193.771 114.896 193.659 114.986 193.61C115.64 193.259 116.263 193.215 116.74 193.489C117.069 193.679 117.301 194.008 117.414 194.44C117.63 195.271 117.394 196.376 116.787 197.395C116.346 198.135 115.792 198.713 115.189 199.066C115.16 199.084 115.128 199.092 115.095 199.092V199.094Z",
    fill: "url(#paint139_linear_376_5139)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M141.438 203.05C141.337 203.05 141.257 202.971 141.253 202.87C141.227 202.124 141.479 201.272 141.956 200.469C142.92 198.853 144.448 198.035 145.435 198.605C145.936 198.895 146.204 199.487 146.186 200.274C146.186 200.376 146.111 200.453 145.997 200.455C145.895 200.453 145.814 200.369 145.816 200.266C145.83 199.621 145.629 199.145 145.25 198.926C144.468 198.473 143.105 199.268 142.275 200.659C141.832 201.4 141.601 202.181 141.623 202.856C141.627 202.959 141.546 203.046 141.444 203.048H141.438V203.05Z",
    fill: "url(#paint140_linear_376_5139)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M131.87 208.485C131.77 208.485 131.687 208.404 131.685 208.303C131.671 207.562 131.922 206.721 132.388 205.936C133.352 204.32 134.881 203.502 135.868 204.072C136.362 204.356 136.628 204.938 136.618 205.707C136.617 205.81 136.542 205.877 136.431 205.891C136.329 205.891 136.246 205.806 136.248 205.703C136.256 205.074 136.055 204.61 135.683 204.395C134.9 203.941 133.537 204.736 132.708 206.127C132.28 206.843 132.042 207.634 132.056 208.297C132.057 208.4 131.977 208.485 131.874 208.487H131.87V208.485Z",
    fill: "url(#paint141_linear_376_5139)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M122.305 213.921C122.203 213.921 122.12 213.839 122.12 213.736C122.114 213.002 122.365 212.174 122.824 211.402C123.787 209.787 125.318 208.968 126.305 209.538C126.79 209.818 127.058 210.386 127.056 211.14C127.056 211.242 126.973 211.325 126.87 211.325C126.768 211.325 126.685 211.242 126.685 211.14C126.685 210.526 126.484 210.073 126.12 209.861C125.338 209.41 123.974 210.203 123.145 211.594C122.719 212.308 122.487 213.067 122.493 213.734C122.493 213.837 122.41 213.921 122.307 213.921H122.305Z",
    fill: "url(#paint142_linear_376_5139)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M117.305 216.762C117.203 216.762 117.12 216.679 117.12 216.577C117.114 215.979 116.913 215.535 116.555 215.328C116.194 215.121 115.699 215.162 115.164 215.452C115.073 215.502 114.961 215.466 114.911 215.377C114.862 215.287 114.896 215.174 114.986 215.125C115.64 214.772 116.263 214.728 116.74 215.005C117.217 215.281 117.484 215.837 117.49 216.573C117.49 216.675 117.41 216.76 117.305 216.76V216.762Z",
    fill: "url(#paint143_linear_376_5139)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M152.262 155.796C152.009 155.796 151.773 155.737 151.566 155.616C151.097 155.344 150.831 154.8 150.815 154.08C150.813 153.977 150.894 153.892 150.997 153.89H151.001C151.101 153.89 151.184 153.971 151.186 154.072C151.198 154.656 151.399 155.09 151.751 155.293C152.106 155.498 152.595 155.458 153.127 155.176C153.215 155.129 153.329 155.163 153.377 155.253C153.424 155.344 153.391 155.457 153.3 155.504C152.937 155.695 152.585 155.792 152.26 155.792L152.262 155.796Z",
    fill: "url(#paint144_linear_376_5139)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M142.702 161.264C142.45 161.264 142.211 161.205 142.001 161.083C141.524 160.807 141.256 160.25 141.25 159.514C141.25 159.412 141.331 159.327 141.435 159.327C141.538 159.327 141.62 159.41 141.62 159.51C141.626 160.11 141.827 160.554 142.186 160.761C142.968 161.215 144.331 160.42 145.161 159.029C145.579 158.331 145.809 157.583 145.813 156.926C145.813 156.824 145.896 156.741 145.998 156.741C146.101 156.741 146.183 156.826 146.183 156.928C146.179 157.65 145.929 158.465 145.478 159.221C144.722 160.489 143.618 161.266 142.7 161.266L142.702 161.264Z",
    fill: "url(#paint145_linear_376_5139)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M133.14 166.732C132.887 166.732 132.649 166.675 132.438 166.551C131.95 166.269 131.682 165.695 131.688 164.935C131.688 164.833 131.77 164.75 131.873 164.75C131.975 164.75 132.058 164.835 132.058 164.937C132.054 165.557 132.255 166.016 132.623 166.227C133.406 166.677 134.769 165.886 135.598 164.495C136.024 163.781 136.256 163.02 136.251 162.355C136.251 162.252 136.333 162.167 136.436 162.167C136.548 162.167 136.621 162.248 136.623 162.353C136.629 163.087 136.379 163.915 135.92 164.687C135.163 165.955 134.06 166.732 133.142 166.732H133.14Z",
    fill: "url(#paint146_linear_376_5139)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M123.574 172.201C123.322 172.201 123.084 172.142 122.873 172.02C122.378 171.734 122.112 171.154 122.122 170.382C122.122 170.28 122.227 170.187 122.31 170.199C122.412 170.199 122.495 170.284 122.493 170.386C122.485 171.015 122.686 171.481 123.058 171.696C123.84 172.148 125.204 171.355 126.033 169.964C126.461 169.248 126.699 168.457 126.685 167.794C126.683 167.691 126.766 167.606 126.867 167.604C126.987 167.604 127.054 167.683 127.056 167.786C127.07 168.528 126.819 169.368 126.35 170.153C125.594 171.422 124.491 172.197 123.572 172.199L123.574 172.201Z",
    fill: "url(#paint147_linear_376_5139)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 177.33C115.011 177.33 114.948 177.297 114.915 177.24C114.864 177.151 114.893 177.036 114.982 176.985C115.541 176.656 116.069 176.105 116.469 175.433C116.903 174.705 117.141 173.904 117.121 173.233C117.119 173.13 117.198 173.045 117.301 173.042H117.307C117.407 173.042 117.49 173.12 117.492 173.221C117.513 173.971 117.263 174.825 116.788 175.622C116.357 176.346 115.782 176.944 115.171 177.305C115.141 177.322 115.108 177.33 115.076 177.33H115.074Z",
    fill: "url(#paint148_linear_376_5139)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M147.488 191.075C147.235 191.075 146.997 191.016 146.784 190.893C146.455 190.704 146.223 190.374 146.11 189.942C145.894 189.112 146.128 188.007 146.737 186.987C147.7 185.371 149.229 184.553 150.218 185.123C150.547 185.312 150.78 185.642 150.892 186.074C151.109 186.904 150.872 188.009 150.266 189.029C149.509 190.296 148.406 191.073 147.49 191.073L147.488 191.075ZM147.056 187.177C146.506 188.1 146.28 189.124 146.469 189.848C146.556 190.181 146.729 190.432 146.969 190.57C147.752 191.023 149.115 190.23 149.944 188.838C150.494 187.914 150.721 186.891 150.532 186.167C150.445 185.833 150.272 185.583 150.031 185.443C149.251 184.991 147.886 185.784 147.056 187.175V187.177Z",
    fill: "url(#paint149_linear_376_5139)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M137.923 196.541C137.671 196.541 137.432 196.482 137.22 196.36C136.891 196.171 136.658 195.841 136.546 195.409C136.331 194.58 136.566 193.476 137.172 192.454C138.136 190.838 139.667 190.017 140.654 190.59C140.983 190.779 141.215 191.108 141.328 191.54C141.544 192.371 141.308 193.476 140.701 194.496C139.944 195.762 138.841 196.539 137.925 196.539L137.923 196.541ZM137.492 192.643C136.942 193.566 136.715 194.59 136.904 195.314C136.991 195.648 137.164 195.898 137.405 196.036C138.187 196.49 139.55 195.697 140.38 194.304C140.93 193.381 141.156 192.357 140.967 191.633C140.88 191.3 140.707 191.049 140.467 190.909C139.684 190.457 138.321 191.25 137.492 192.641V192.643Z",
    fill: "url(#paint150_linear_376_5139)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M128.358 202.01C128.105 202.01 127.867 201.951 127.654 201.828C127.325 201.639 127.093 201.309 126.98 200.877C126.766 200.049 127 198.942 127.607 197.922C128.57 196.304 130.099 195.49 131.088 196.058C131.417 196.247 131.65 196.577 131.762 197.009C131.977 197.837 131.742 198.944 131.136 199.964C130.379 201.232 129.276 202.01 128.358 202.01ZM130.399 196.253C129.619 196.253 128.598 196.987 127.928 198.114C127.378 199.037 127.152 200.061 127.341 200.785C127.428 201.118 127.601 201.369 127.841 201.507C128.624 201.958 129.989 201.165 130.816 199.775C131.366 198.851 131.593 197.827 131.404 197.103C131.317 196.77 131.143 196.52 130.903 196.381C130.753 196.295 130.582 196.255 130.399 196.255V196.253Z",
    fill: "url(#paint151_linear_376_5139)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M118.792 207.476C118.54 207.476 118.301 207.417 118.091 207.295C117.762 207.105 117.529 206.776 117.417 206.344C117.2 205.513 117.436 204.409 118.043 203.389C119.007 201.773 120.536 200.954 121.523 201.526C121.852 201.716 122.084 202.045 122.197 202.477C122.411 203.306 122.177 204.41 121.57 205.432C120.813 206.701 119.71 207.478 118.792 207.478V207.476ZM120.833 201.72C120.053 201.72 119.034 202.453 118.362 203.58C117.813 204.503 117.586 205.527 117.775 206.251C117.862 206.584 118.035 206.835 118.276 206.975C119.058 207.427 120.421 206.634 121.251 205.243C121.8 204.32 122.027 203.296 121.838 202.572C121.751 202.238 121.578 201.988 121.337 201.85C121.188 201.763 121.016 201.722 120.833 201.722V201.72Z",
    fill: "url(#paint152_linear_376_5139)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M151.003 197.613C150.904 197.613 150.822 197.534 150.818 197.435C150.788 196.689 151.044 195.802 151.519 195.003C151.947 194.285 152.516 193.693 153.119 193.332C153.206 193.278 153.32 193.308 153.373 193.397C153.426 193.486 153.397 193.6 153.308 193.651C152.756 193.981 152.234 194.529 151.838 195.194C151.397 195.934 151.161 196.747 151.188 197.421C151.192 197.524 151.113 197.611 151.011 197.615H151.003V197.613Z",
    fill: "url(#paint153_linear_376_5139)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M191.357 218.03C191.325 218.03 191.294 218.022 191.266 218.006L153.125 196.329C153.068 196.296 153.03 196.235 153.03 196.168V152.818C153.03 152.751 153.066 152.69 153.125 152.656L191.266 130.981C191.323 130.948 191.392 130.948 191.449 130.981L229.59 152.656C229.648 152.69 229.685 152.751 229.685 152.818V196.168C229.685 196.235 229.65 196.296 229.59 196.329L191.449 218.006C191.422 218.022 191.39 218.03 191.359 218.03H191.357ZM153.403 196.059L191.357 217.63L229.311 196.059V152.924L191.357 131.354L153.403 152.924V196.059Z",
    fill: "url(#paint154_linear_376_5139)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M191.356 218.03C191.325 218.03 191.291 218.022 191.262 218.005C191.173 217.951 191.143 217.839 191.197 217.75L228.985 153.323L191.447 174.655C191.39 174.688 191.321 174.688 191.264 174.655L153.122 152.98C153.034 152.929 153.002 152.816 153.052 152.727C153.103 152.637 153.215 152.605 153.304 152.658L191.352 174.282L229.401 152.658C229.474 152.617 229.566 152.629 229.624 152.69C229.683 152.749 229.694 152.842 229.651 152.915L191.51 217.941C191.474 218.001 191.413 218.032 191.35 218.032L191.356 218.03Z",
    fill: "url(#paint155_linear_376_5139)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M191.356 218.03C191.291 218.03 191.23 217.997 191.196 217.94L172.219 185.584L153.309 196.332C153.218 196.381 153.108 196.351 153.057 196.263C153.008 196.174 153.037 196.059 153.128 196.01L172.034 185.266L153.059 152.917C153.025 152.86 153.025 152.789 153.059 152.731C153.092 152.674 153.153 152.639 153.22 152.639H229.501C229.603 152.639 229.686 152.722 229.686 152.824C229.686 152.927 229.603 153.01 229.501 153.01H153.545L172.359 185.085L191.271 174.337C191.328 174.304 191.399 174.304 191.456 174.337C191.513 174.371 191.549 174.432 191.549 174.497V217.849C191.549 217.934 191.494 218.007 191.411 218.028C191.395 218.032 191.377 218.034 191.362 218.034L191.356 218.03ZM172.542 185.401L191.17 217.162V174.815L172.542 185.403V185.401Z",
    fill: "url(#paint156_linear_376_5139)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 196.356C229.463 196.356 229.431 196.348 229.404 196.332L191.263 174.657C191.205 174.623 191.168 174.562 191.168 174.495V131.145C191.168 131.043 191.251 130.96 191.353 130.96C191.456 130.96 191.538 131.043 191.538 131.145V174.389L229.585 196.01C229.674 196.062 229.705 196.174 229.656 196.263C229.62 196.324 229.559 196.358 229.494 196.358V196.356Z",
    fill: "url(#paint157_linear_376_5139)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M153.215 185.073C153.149 185.073 153.086 185.04 153.053 184.978C153.004 184.89 153.033 184.775 153.124 184.726L181.406 168.823V136.693C181.406 136.59 181.489 136.507 181.591 136.507C181.694 136.507 181.777 136.59 181.777 136.693V168.932C181.777 168.999 181.741 169.062 181.682 169.094L153.305 185.048C153.278 185.063 153.246 185.071 153.215 185.071V185.073Z",
    fill: "url(#paint158_linear_376_5139)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M153.214 174.288C153.149 174.288 153.086 174.254 153.053 174.193C153.003 174.104 153.035 173.99 153.123 173.941L171.901 163.422V142.092C171.901 141.99 171.984 141.907 172.087 141.907C172.189 141.907 172.272 141.99 172.272 142.092V163.53C172.272 163.597 172.236 163.661 172.177 163.692L153.305 174.264C153.275 174.28 153.246 174.288 153.214 174.288Z",
    fill: "url(#paint159_linear_376_5139)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M153.215 163.629C153.149 163.629 153.086 163.595 153.053 163.534C153.004 163.445 153.033 163.331 153.124 163.282L162.4 158.036V147.494C162.4 147.391 162.482 147.308 162.585 147.308C162.687 147.308 162.77 147.391 162.77 147.494V158.145C162.77 158.212 162.735 158.273 162.675 158.306L153.305 163.605C153.276 163.621 153.244 163.629 153.215 163.629Z",
    fill: "url(#paint160_linear_376_5139)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M229.495 185.073C229.463 185.073 229.432 185.065 229.404 185.049L201.027 169.096C200.968 169.062 200.933 169.001 200.933 168.934V136.695C200.933 136.592 201.015 136.509 201.118 136.509C201.22 136.509 201.303 136.592 201.303 136.695V168.825L229.585 184.728C229.676 184.777 229.705 184.892 229.656 184.98C229.623 185.042 229.56 185.075 229.495 185.075V185.073Z",
    fill: "url(#paint161_linear_376_5139)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 174.288C229.463 174.288 229.433 174.28 229.404 174.264L210.531 163.692C210.472 163.659 210.437 163.597 210.437 163.53V142.092C210.437 141.99 210.519 141.907 210.622 141.907C210.724 141.907 210.807 141.99 210.807 142.092V163.422L229.585 173.941C229.674 173.99 229.705 174.104 229.656 174.193C229.622 174.254 229.559 174.288 229.494 174.288Z",
    fill: "url(#paint162_linear_376_5139)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M229.495 163.629C229.463 163.629 229.432 163.621 229.404 163.605L220.034 158.306C219.977 158.273 219.939 158.212 219.939 158.145V147.494C219.939 147.391 220.022 147.308 220.125 147.308C220.227 147.308 220.31 147.391 220.31 147.494V158.036L229.586 163.282C229.674 163.333 229.706 163.445 229.657 163.534C229.623 163.595 229.56 163.629 229.495 163.629Z",
    fill: "url(#paint163_linear_376_5139)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M219.846 201.838C219.815 201.838 219.783 201.83 219.756 201.814L191.355 185.851L162.955 201.814C162.868 201.864 162.754 201.834 162.702 201.743C162.653 201.655 162.683 201.54 162.773 201.491L191.264 185.476C191.322 185.444 191.389 185.444 191.446 185.476L219.937 201.491C220.027 201.54 220.057 201.655 220.008 201.743C219.974 201.804 219.911 201.838 219.846 201.838Z",
    fill: "url(#paint164_linear_376_5139)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M210.258 207.289C210.227 207.289 210.195 207.281 210.167 207.265L191.356 196.703L172.544 207.265C172.456 207.314 172.341 207.283 172.292 207.194C172.243 207.105 172.273 206.991 172.363 206.941L191.265 196.328C191.322 196.296 191.389 196.296 191.447 196.328L210.349 206.941C210.439 206.993 210.469 207.105 210.42 207.194C210.386 207.255 210.323 207.289 210.258 207.289Z",
    fill: "url(#paint165_linear_376_5139)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M182.031 212.731C181.966 212.731 181.903 212.698 181.869 212.637C181.82 212.548 181.85 212.434 181.94 212.384L191.285 207.123C191.34 207.091 191.411 207.091 191.466 207.123L200.773 212.384C200.862 212.435 200.894 212.548 200.844 212.637C200.793 212.725 200.679 212.755 200.592 212.708L191.378 207.498L182.124 212.708C182.096 212.724 182.064 212.731 182.033 212.731H182.031Z",
    fill: "url(#paint166_linear_376_5139)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M153.215 153.004C153.184 153.004 153.152 152.996 153.124 152.98L114.983 131.306C114.926 131.272 114.889 131.211 114.889 131.144V87.794C114.889 87.7269 114.924 87.6657 114.983 87.6322L153.124 65.9573C153.182 65.9237 153.251 65.9237 153.308 65.9573L191.449 87.6322C191.506 87.6657 191.543 87.7269 191.543 87.794V131.144C191.543 131.211 191.508 131.272 191.449 131.306L153.308 152.98C153.28 152.996 153.249 153.004 153.217 153.004H153.215ZM115.261 131.035L153.215 152.606L191.169 131.035V87.9005L153.215 66.3301L115.261 87.9005V131.035Z",
    fill: "url(#paint167_linear_376_5139)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M153.216 109.654C153.184 109.654 153.153 109.646 153.125 109.63L114.984 87.9556C114.895 87.9043 114.864 87.7918 114.913 87.7031C114.964 87.6143 115.076 87.5827 115.165 87.634L153.214 109.258L191.262 87.634C191.351 87.5827 191.463 87.6143 191.514 87.7031C191.564 87.7918 191.534 87.9063 191.444 87.9556L153.302 109.63C153.275 109.646 153.243 109.654 153.212 109.654H153.216Z",
    fill: "url(#paint168_linear_376_5139)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M153.214 153.004C153.112 153.004 153.029 152.922 153.029 152.819V109.469C153.029 109.367 153.112 109.284 153.214 109.284C153.317 109.284 153.4 109.367 153.4 109.469V152.819C153.4 152.922 153.317 153.004 153.214 153.004Z",
    fill: "url(#paint169_linear_376_5139)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M153.256 101.83C153.224 101.83 153.193 101.822 153.165 101.807L129.148 88.1629C129.091 88.1294 129.054 88.0682 129.054 88.0012C129.054 87.9341 129.089 87.8729 129.146 87.8394L153.163 74.0378C153.22 74.0043 153.291 74.0043 153.348 74.0378L177.06 87.8019C177.117 87.8355 177.152 87.8966 177.152 87.9637C177.152 88.0308 177.117 88.0919 177.06 88.1254L153.348 101.805C153.319 101.82 153.287 101.83 153.256 101.83ZM129.613 87.9992L153.254 101.43L176.595 87.9637L153.254 74.4146L129.613 87.9992Z",
    fill: "url(#paint170_linear_376_5139)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M160.327 141.094C160.293 141.094 160.262 141.087 160.234 141.069C160.177 141.035 160.142 140.974 160.142 140.909V113.768C160.142 113.7 160.177 113.639 160.236 113.606L184.286 99.9956C184.344 99.9621 184.415 99.964 184.472 99.9956C184.529 100.029 184.564 100.09 184.564 100.155V127.255C184.564 127.323 184.529 127.384 184.47 127.417L160.419 141.069C160.392 141.085 160.36 141.092 160.329 141.092L160.327 141.094ZM160.512 113.876V140.589L184.19 127.149V100.475L160.512 113.874V113.876Z",
    fill: "url(#paint171_linear_376_5139)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M146.145 141.095C146.113 141.095 146.082 141.087 146.054 141.071L122.004 127.419C121.947 127.386 121.909 127.325 121.909 127.258V100.158C121.909 100.091 121.945 100.031 122.002 99.9978C122.059 99.9643 122.128 99.9643 122.187 99.9978L146.237 113.608C146.294 113.642 146.332 113.703 146.332 113.77V140.911C146.332 140.978 146.296 141.039 146.239 141.071C146.21 141.089 146.178 141.097 146.147 141.097L146.145 141.095ZM122.282 127.149L145.959 140.59V113.876L122.282 100.477V127.151V127.149Z",
    fill: "url(#paint172_linear_376_5139)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9348 153.004C76.9033 153.004 76.8717 152.996 76.8442 152.98L38.703 131.306C38.6458 131.272 38.6084 131.211 38.6084 131.144V87.794C38.6084 87.7269 38.6439 87.6657 38.703 87.6322L76.8442 65.9573C76.9013 65.9237 76.9702 65.9237 77.0274 65.9573L115.169 87.6322C115.226 87.6657 115.263 87.7269 115.263 87.794V131.144C115.263 131.211 115.228 131.272 115.169 131.306L77.0274 152.98C76.9998 152.996 76.9683 153.004 76.9368 153.004H76.9348ZM38.9808 131.035L76.9348 152.606L114.889 131.035V87.9005L76.9348 66.3301L38.9808 87.9005V131.035Z",
    fill: "url(#paint173_linear_376_5139)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9354 109.654C76.9038 109.654 76.8723 109.646 76.8447 109.63L38.7035 87.9556C38.6149 87.9043 38.5834 87.7918 38.6326 87.7031C38.6838 87.6143 38.7961 87.5827 38.8868 87.634L76.9354 109.258L114.984 87.634C115.073 87.5827 115.185 87.6143 115.236 87.7031C115.285 87.7918 115.256 87.9063 115.165 87.9556L77.024 109.63C76.9964 109.646 76.9649 109.654 76.9334 109.654H76.9354Z",
    fill: "url(#paint174_linear_376_5139)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9343 153.005C76.9343 153.005 76.9225 153.005 76.9244 153.005C76.9106 153.005 76.8988 153.003 76.885 152.999C76.8752 152.997 76.8653 152.993 76.8555 152.989C76.824 152.975 76.7983 152.951 76.7786 152.922C76.7786 152.922 76.7747 152.916 76.7727 152.914L38.6335 87.8891C38.6 87.8319 38.6 87.7609 38.6335 87.7037C38.667 87.6464 38.7281 87.6109 38.7951 87.6109H76.7491V66.1215C76.7491 66.0189 76.8318 65.936 76.9343 65.936C77.0367 65.936 77.1195 66.0189 77.1195 66.1215V87.6109H115.074C115.14 87.6109 115.202 87.6464 115.235 87.7037C115.269 87.7609 115.269 87.8319 115.235 87.8891L77.0958 152.912C77.084 152.934 77.0663 152.953 77.0466 152.969C77.0387 152.977 77.0269 152.983 77.017 152.987C76.9914 153.001 76.9619 153.007 76.9343 153.007V153.005ZM77.1195 87.9779V152.135L114.75 87.9779H77.1195ZM39.1182 87.9779L76.7491 152.135V87.9779H39.1182Z",
    fill: "url(#paint175_linear_376_5139)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 131.329C115.043 131.329 115.012 131.322 114.984 131.306L76.9358 109.682L38.8872 131.306C38.7966 131.357 38.6862 131.326 38.633 131.237C38.5838 131.148 38.6133 131.034 38.704 130.984L76.8451 109.309C76.9023 109.276 76.9712 109.276 77.0284 109.309L115.17 130.984C115.258 131.036 115.29 131.148 115.24 131.237C115.205 131.298 115.144 131.331 115.079 131.331L115.075 131.329Z",
    fill: "url(#paint176_linear_376_5139)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 87.9792C191.323 87.9792 191.292 87.9713 191.264 87.9556L153.123 66.2807C153.066 66.2471 153.028 66.186 153.028 66.1189V22.7671C153.028 22.7 153.064 22.6389 153.123 22.6053L191.262 0.928473C191.319 0.894936 191.388 0.894936 191.445 0.928473L229.587 22.6034C229.644 22.6369 229.681 22.6981 229.681 22.7651V66.1169C229.681 66.184 229.646 66.2452 229.587 66.2787L191.445 87.9536C191.418 87.9694 191.386 87.9773 191.355 87.9773V87.9792ZM153.401 66.0104L191.355 87.5807L229.309 66.0104V22.8736L191.355 1.30527L153.401 22.8756V66.0104Z",
    fill: "url(#paint177_linear_376_5139)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M191.354 44.6274C191.323 44.6274 191.291 44.6195 191.264 44.6037L166.035 30.2656C166.008 30.2577 165.982 30.2419 165.96 30.2221L153.125 22.9268C153.054 22.8874 153.018 22.8065 153.034 22.7276C153.05 22.6487 153.115 22.5895 153.196 22.5796L216.748 15.3632C216.813 15.3573 216.875 15.3809 216.914 15.4322C216.953 15.4816 216.967 15.5486 216.945 15.6078L213.963 24.3709L229.476 22.5796C229.561 22.5717 229.647 22.623 229.673 22.7059C229.701 22.7907 229.665 22.8814 229.588 22.9248L191.447 44.5997C191.419 44.6155 191.388 44.6234 191.356 44.6234L191.354 44.6274ZM166.68 30.2044L191.354 44.2269L210.515 33.3372L213.419 24.8088L166.68 30.2044ZM213.827 24.7615L211.001 33.061L228.607 23.0551L213.827 24.7615ZM153.8 22.8854L166.13 29.8927L213.549 24.4182L216.494 15.7656L153.8 22.8854Z",
    fill: "url(#paint178_linear_376_5139)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 87.979C191.253 87.979 191.17 87.8961 191.17 87.7935V44.4437C191.17 44.3412 191.253 44.2583 191.355 44.2583C191.458 44.2583 191.54 44.3412 191.54 44.4437V87.7935C191.54 87.8961 191.458 87.979 191.355 87.979Z",
    fill: "url(#paint179_linear_376_5139)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M153.214 66.3025C153.17 66.3025 153.125 66.2867 153.089 66.2552C153.013 66.1861 153.007 66.0697 153.074 65.9928L178.653 37.1804C178.722 37.1034 178.838 37.0975 178.915 37.1646C178.992 37.2336 178.998 37.35 178.931 37.427L153.351 66.2413C153.316 66.2828 153.263 66.3045 153.214 66.3045V66.3025Z",
    fill: "url(#paint180_linear_376_5139)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M178.795 37.4899C178.775 37.4899 178.754 37.4859 178.734 37.48C178.637 37.4465 178.586 37.3399 178.62 37.2433L191.18 1.02899C191.213 0.932324 191.32 0.881032 191.416 0.914569C191.513 0.948106 191.564 1.05464 191.53 1.1513L178.97 37.3636C178.943 37.4405 178.872 37.4879 178.795 37.4879V37.4899Z",
    fill: "url(#paint181_linear_376_5139)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M153.214 44.7717C153.17 44.7717 153.125 44.7559 153.089 44.7244C153.013 44.6553 153.007 44.5389 153.074 44.462L165.945 29.9641C166.014 29.8871 166.13 29.8812 166.207 29.9483C166.284 30.0173 166.29 30.1337 166.223 30.2107L153.351 44.7086C153.316 44.75 153.263 44.7717 153.214 44.7717Z",
    fill: "url(#paint182_linear_376_5139)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M166.085 30.2732C166.065 30.2732 166.044 30.2693 166.024 30.2633C165.927 30.2298 165.876 30.1233 165.91 30.0266L172.254 11.7863C172.287 11.6896 172.394 11.6384 172.49 11.6719C172.587 11.7054 172.638 11.812 172.604 11.9086L166.26 30.1489C166.233 30.2259 166.162 30.2732 166.085 30.2732Z",
    fill: "url(#paint183_linear_376_5139)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M165.773 73.4422C165.73 73.4422 165.685 73.4264 165.649 73.3948C165.572 73.3258 165.566 73.2094 165.633 73.1324L191.214 44.32C191.283 44.2431 191.4 44.2372 191.476 44.3042C191.553 44.3733 191.559 44.4897 191.492 44.5666L165.911 73.379C165.876 73.4204 165.822 73.4422 165.773 73.4422Z",
    fill: "url(#paint184_linear_376_5139)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M178.712 80.7945C178.668 80.7945 178.623 80.7788 178.588 80.7472C178.511 80.6781 178.505 80.5618 178.572 80.4848L191.215 66.2453C191.284 66.1684 191.4 66.1625 191.477 66.2295C191.553 66.2986 191.559 66.415 191.492 66.4919L178.85 80.7314C178.814 80.7728 178.761 80.7945 178.712 80.7945Z",
    fill: "url(#paint185_linear_376_5139)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 66.3025C229.443 66.3025 229.391 66.2808 229.356 66.2394L203.775 37.425C203.706 37.3481 203.714 37.2317 203.79 37.1626C203.867 37.0956 203.984 37.1015 204.052 37.1784L229.634 65.9908C229.703 66.0678 229.695 66.1842 229.618 66.2532C229.582 66.2848 229.539 66.3005 229.494 66.3005V66.3025Z",
    fill: "url(#paint186_linear_376_5139)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 44.7714C229.443 44.7714 229.391 44.7497 229.356 44.7083L216.485 30.2104C216.416 30.1334 216.424 30.017 216.5 29.948C216.577 29.8809 216.693 29.8849 216.762 29.9638L229.634 44.4617C229.703 44.5386 229.695 44.655 229.618 44.7241C229.583 44.7556 229.539 44.7714 229.494 44.7714Z",
    fill: "url(#paint187_linear_376_5139)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M216.934 73.4422C216.883 73.4422 216.832 73.4204 216.796 73.379L191.217 44.5666C191.148 44.4897 191.156 44.3733 191.233 44.3042C191.308 44.2372 191.426 44.2431 191.495 44.32L217.074 73.1324C217.143 73.2094 217.135 73.3258 217.058 73.3948C217.023 73.4264 216.979 73.4422 216.934 73.4422Z",
    fill: "url(#paint188_linear_376_5139)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M203.995 80.7942C203.944 80.7942 203.892 80.7725 203.857 80.7311L191.214 66.4916C191.145 66.4147 191.153 66.2983 191.23 66.2292C191.305 66.1622 191.423 66.1661 191.492 66.245L204.135 80.4845C204.204 80.5615 204.196 80.6779 204.119 80.7469C204.084 80.7785 204.04 80.7942 203.995 80.7942Z",
    fill: "url(#paint189_linear_376_5139)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 44.6275C191.335 44.6275 191.313 44.6236 191.293 44.6177C191.197 44.5841 191.146 44.4776 191.179 44.3809L203.739 8.16864C203.773 8.07197 203.879 8.02068 203.976 8.05422C204.072 8.08775 204.123 8.19428 204.09 8.29095L191.53 44.5032C191.502 44.5802 191.431 44.6275 191.355 44.6275Z",
    fill: "url(#paint190_linear_376_5139)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M178.734 80.8063C178.663 80.8063 178.594 80.7649 178.564 80.6959L153.046 22.8422C153.005 22.7475 153.046 22.639 153.141 22.5976C153.231 22.5561 153.344 22.5976 153.385 22.6923L178.903 80.5459C178.945 80.6406 178.903 80.7491 178.809 80.7906C178.785 80.8024 178.759 80.8063 178.734 80.8063Z",
    fill: "url(#paint191_linear_376_5139)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 87.9792C191.284 87.9792 191.215 87.9377 191.185 87.8687L165.915 30.163C165.874 30.0683 165.915 29.9598 166.01 29.9184C166.107 29.8769 166.213 29.9184 166.254 30.0131L191.524 87.7188C191.566 87.8135 191.524 87.922 191.43 87.9634C191.404 87.9733 191.38 87.9792 191.355 87.9792Z",
    fill: "url(#paint192_linear_376_5139)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 65.9846C191.284 65.9846 191.215 65.9431 191.185 65.8741L178.625 37.3793C178.584 37.2846 178.625 37.1761 178.72 37.1347C178.811 37.0933 178.923 37.1347 178.964 37.2294L191.524 65.7242C191.566 65.8189 191.524 65.9274 191.43 65.9688C191.406 65.9806 191.38 65.9846 191.355 65.9846Z",
    fill: "url(#paint193_linear_376_5139)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M165.847 73.3591C165.776 73.3591 165.707 73.3177 165.678 73.2467L153.129 44.5645C153.088 44.4698 153.129 44.3613 153.224 44.3198C153.32 44.2804 153.427 44.3198 153.468 44.4165L166.016 73.0987C166.058 73.1934 166.016 73.3019 165.922 73.3433C165.896 73.3532 165.873 73.3591 165.847 73.3591Z",
    fill: "url(#paint194_linear_376_5139)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M203.976 80.8065C203.95 80.8065 203.924 80.8006 203.901 80.7907C203.806 80.7493 203.765 80.6388 203.806 80.5461L229.324 22.6925C229.366 22.5997 229.478 22.5563 229.568 22.5978C229.663 22.6392 229.704 22.7497 229.663 22.8424L204.145 80.696C204.115 80.7651 204.046 80.8065 203.976 80.8065Z",
    fill: "url(#paint195_linear_376_5139)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 87.9794C191.329 87.9794 191.306 87.9734 191.28 87.9636C191.188 87.9222 191.144 87.8117 191.186 87.719L216.454 30.0133C216.495 29.9205 216.601 29.8771 216.698 29.9186C216.792 29.96 216.834 30.0705 216.792 30.1632L191.525 87.8689C191.495 87.9379 191.426 87.9794 191.355 87.9794Z",
    fill: "url(#paint196_linear_376_5139)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M191.354 65.9846C191.329 65.9846 191.303 65.9787 191.28 65.9688C191.185 65.9274 191.144 65.8169 191.185 65.7242L203.745 37.2294C203.786 37.1347 203.899 37.0933 203.989 37.1347C204.084 37.1761 204.125 37.2866 204.084 37.3793L191.524 65.8741C191.494 65.9431 191.425 65.9846 191.354 65.9846Z",
    fill: "url(#paint197_linear_376_5139)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M216.863 73.3588C216.837 73.3588 216.814 73.3529 216.788 73.343C216.695 73.3016 216.652 73.1931 216.693 73.0984L229.242 44.4162C229.283 44.3215 229.391 44.2801 229.486 44.3196C229.581 44.361 229.622 44.4695 229.581 44.5642L217.032 73.2464C217.003 73.3174 216.934 73.3588 216.863 73.3588Z",
    fill: "url(#paint198_linear_376_5139)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 55.5272C191.324 55.5272 191.292 55.5193 191.265 55.5035L153.123 33.8109C153.035 33.7596 153.003 33.6471 153.053 33.5584C153.104 33.4676 153.218 33.4361 153.305 33.4893L191.353 55.1307L229.402 33.6353C229.491 33.584 229.605 33.6156 229.654 33.7063C229.703 33.7951 229.674 33.9095 229.583 33.9588L191.442 55.5055C191.414 55.5213 191.381 55.5292 191.351 55.5292L191.355 55.5272Z",
    fill: "url(#paint199_linear_376_5139)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 66.2885C191.324 66.2885 191.292 66.2806 191.265 66.2648L153.123 44.5722C153.035 44.5209 153.003 44.4084 153.053 44.3197C153.104 44.2309 153.218 44.1973 153.305 44.2506L191.353 65.892L229.402 44.3966C229.491 44.3473 229.605 44.3769 229.654 44.4676C229.703 44.5564 229.674 44.6708 229.583 44.7201L191.442 66.2668C191.414 66.2826 191.381 66.2905 191.351 66.2905L191.355 66.2885Z",
    fill: "url(#paint200_linear_376_5139)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 77.0619C191.324 77.0619 191.292 77.054 191.265 77.0382L153.123 55.3456C153.035 55.2943 153.003 55.1818 153.053 55.093C153.104 55.0023 153.218 54.9707 153.305 55.024L191.353 76.6654L229.402 55.17C229.491 55.1187 229.605 55.1502 229.654 55.241C229.703 55.3298 229.674 55.4442 229.583 55.4935L191.442 77.0402C191.414 77.056 191.381 77.0639 191.351 77.0639L191.355 77.0619Z",
    fill: "url(#paint201_linear_376_5139)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M200.881 39.214C200.849 39.214 200.818 39.2061 200.788 39.1903L162.781 17.4405C162.692 17.3892 162.661 17.2747 162.712 17.186C162.761 17.0972 162.876 17.0656 162.964 17.1169L200.972 38.8668C201.06 38.9181 201.092 39.0325 201.04 39.1213C201.007 39.1805 200.944 39.214 200.879 39.214H200.881Z",
    fill: "url(#paint202_linear_376_5139)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M210.446 33.777C210.415 33.777 210.383 33.7691 210.354 33.7533L172.345 12.0034C172.256 11.9522 172.224 11.8377 172.276 11.749C172.327 11.6602 172.439 11.6286 172.53 11.6799L210.539 33.4298C210.628 33.4811 210.659 33.5955 210.608 33.6843C210.574 33.7434 210.511 33.777 210.446 33.777Z",
    fill: "url(#paint203_linear_376_5139)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M219.968 28.3658C219.936 28.3658 219.905 28.358 219.875 28.3422L181.866 6.59231C181.777 6.54102 181.746 6.4266 181.797 6.33782C181.846 6.24905 181.961 6.21748 182.049 6.26878L220.058 28.0186C220.147 28.0699 220.179 28.1844 220.127 28.2731C220.094 28.3323 220.031 28.3658 219.966 28.3658H219.968Z",
    fill: "url(#paint204_linear_376_5139)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M172.587 12.1123C172.494 12.1123 172.413 12.0412 172.402 11.9465C172.39 11.844 172.463 11.7532 172.565 11.7414L203.846 8.17262C203.954 8.16078 204.039 8.23575 204.051 8.33636C204.063 8.43894 203.99 8.52969 203.887 8.54153L172.607 12.1103C172.607 12.1103 172.593 12.1103 172.585 12.1103L172.587 12.1123Z",
    fill: "url(#paint205_linear_376_5139)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M178.856 37.482C178.764 37.482 178.683 37.411 178.671 37.3163C178.659 37.2137 178.732 37.1229 178.835 37.1111L210.202 33.5345C210.307 33.5226 210.395 33.5956 210.407 33.6982C210.419 33.8008 210.346 33.8915 210.244 33.9034L178.876 37.48C178.876 37.48 178.862 37.48 178.854 37.48L178.856 37.482Z",
    fill: "url(#paint206_linear_376_5139)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7942 218.031C38.7626 218.031 38.7311 218.023 38.7035 218.007L0.562343 196.332C0.505207 196.299 0.467773 196.238 0.467773 196.171V152.819C0.467773 152.752 0.503237 152.691 0.562343 152.657L38.7035 130.982C38.7607 130.949 38.8296 130.949 38.8868 130.982L77.0279 152.657C77.0851 152.691 77.1225 152.752 77.1225 152.819V196.171C77.1225 196.238 77.0871 196.299 77.0279 196.332L38.8868 218.007C38.8592 218.023 38.8277 218.031 38.7961 218.031H38.7942ZM0.840142 196.062L38.7942 217.632L76.7482 196.062V152.927L38.7942 131.357L0.840142 152.927V196.062Z",
    fill: "url(#paint207_linear_376_5139)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7947 174.681C38.7632 174.681 38.7317 174.673 38.7041 174.657L0.562922 152.98C0.474263 152.929 0.442739 152.817 0.491995 152.728C0.54322 152.637 0.655521 152.605 0.744181 152.659L38.7928 174.282L76.8414 152.659C76.93 152.605 77.0423 152.639 77.0935 152.728C77.1428 152.817 77.1132 152.931 77.0226 152.98L38.8814 174.655C38.8538 174.671 38.8223 174.679 38.7908 174.679L38.7947 174.681Z",
    fill: "url(#paint208_linear_376_5139)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7946 218.031C38.6921 218.031 38.6094 217.948 38.6094 217.845V174.496C38.6094 174.393 38.6921 174.31 38.7946 174.31C38.897 174.31 38.9798 174.393 38.9798 174.496V217.845C38.9798 217.948 38.897 218.031 38.7946 218.031Z",
    fill: "url(#paint209_linear_376_5139)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7947 218.031C38.7632 218.031 38.7317 218.023 38.7041 218.007L0.562922 196.332C0.474263 196.281 0.442739 196.168 0.491995 196.08C0.54322 195.991 0.655521 195.959 0.744181 196.01L38.8854 217.685C38.974 217.737 39.0056 217.849 38.9563 217.938C38.9228 217.999 38.8598 218.033 38.7947 218.033V218.031Z",
    fill: "url(#paint210_linear_376_5139)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7947 209.414C38.7632 209.414 38.7317 209.406 38.7041 209.39L0.562922 187.715C0.474263 187.664 0.442739 187.552 0.491995 187.463C0.54322 187.374 0.655521 187.342 0.744181 187.394L38.8854 209.069C38.974 209.12 39.0056 209.232 38.9563 209.321C38.9228 209.382 38.8598 209.416 38.7947 209.416V209.414Z",
    fill: "url(#paint211_linear_376_5139)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7947 200.743C38.7632 200.743 38.7317 200.736 38.7041 200.72L0.562922 179.045C0.474263 178.994 0.442739 178.881 0.491995 178.792C0.54322 178.704 0.655521 178.67 0.744181 178.723L38.8854 200.398C38.974 200.449 39.0056 200.562 38.9563 200.651C38.9228 200.712 38.8598 200.745 38.7947 200.745V200.743Z",
    fill: "url(#paint212_linear_376_5139)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7947 192.073C38.7632 192.073 38.7317 192.065 38.7041 192.049L0.562922 170.373C0.474263 170.321 0.442739 170.209 0.491995 170.12C0.54322 170.031 0.655521 170 0.744181 170.051L38.8854 191.726C38.974 191.777 39.0056 191.89 38.9563 191.978C38.9228 192.04 38.8598 192.073 38.7947 192.073Z",
    fill: "url(#paint213_linear_376_5139)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7947 183.403C38.7632 183.403 38.7317 183.395 38.7041 183.379L0.562922 161.702C0.474263 161.651 0.442739 161.538 0.491995 161.45C0.54322 161.361 0.655521 161.329 0.744181 161.381L38.8854 183.055C38.974 183.107 39.0056 183.219 38.9563 183.308C38.9228 183.369 38.8598 183.403 38.7947 183.403Z",
    fill: "url(#paint214_linear_376_5139)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6647 213.549C46.5622 213.549 46.4795 213.466 46.4795 213.363V170.021C46.4795 169.919 46.5622 169.836 46.6647 169.836C46.7671 169.836 46.8499 169.919 46.8499 170.021V213.363C46.8499 213.466 46.7671 213.549 46.6647 213.549Z",
    fill: "url(#paint215_linear_376_5139)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M54.317 209.208C54.2146 209.208 54.1318 209.126 54.1318 209.023V165.681C54.1318 165.578 54.2146 165.496 54.317 165.496C54.4195 165.496 54.5022 165.578 54.5022 165.681V209.023C54.5022 209.126 54.4195 209.208 54.317 209.208Z",
    fill: "url(#paint216_linear_376_5139)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9694 204.861C61.8669 204.861 61.7842 204.778 61.7842 204.675V161.333C61.7842 161.231 61.8669 161.148 61.9694 161.148C62.0718 161.148 62.1546 161.231 62.1546 161.333V204.675C62.1546 204.778 62.0718 204.861 61.9694 204.861Z",
    fill: "url(#paint217_linear_376_5139)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6217 200.511C69.5193 200.511 69.4365 200.428 69.4365 200.325V156.983C69.4365 156.881 69.5193 156.798 69.6217 156.798C69.7242 156.798 69.8069 156.881 69.8069 156.983V200.325C69.8069 200.428 69.7242 200.511 69.6217 200.511Z",
    fill: "url(#paint218_linear_376_5139)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7946 174.681C38.7296 174.681 38.6685 174.647 38.633 174.586C38.5838 174.497 38.6133 174.383 38.704 174.334L76.8451 152.659C76.9338 152.606 77.0461 152.639 77.0973 152.728C77.1466 152.817 77.117 152.931 77.0264 152.98L38.8852 174.655C38.8557 174.671 38.8241 174.679 38.7946 174.679V174.681Z",
    fill: "url(#paint219_linear_376_5139)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M31.236 170.404C31.171 170.404 31.1099 170.371 31.0744 170.309C31.0252 170.221 31.0547 170.106 31.1454 170.055L69.2866 148.38C69.3752 148.329 69.4875 148.36 69.5387 148.449C69.588 148.538 69.5584 148.652 69.4678 148.702L31.3266 170.377C31.2971 170.392 31.2655 170.4 31.236 170.4V170.404Z",
    fill: "url(#paint220_linear_376_5139)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5924 166.056C23.5274 166.056 23.4664 166.022 23.4309 165.961C23.3816 165.873 23.4112 165.758 23.5018 165.709L61.643 144.034C61.7317 143.983 61.844 144.014 61.8952 144.103C61.9444 144.192 61.9149 144.306 61.8243 144.355L23.6831 166.03C23.6535 166.046 23.622 166.054 23.5924 166.054V166.056Z",
    fill: "url(#paint221_linear_376_5139)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9479 161.706C15.8829 161.706 15.8218 161.672 15.7864 161.611C15.7371 161.522 15.7667 161.408 15.8573 161.359L53.9985 139.684C54.0871 139.63 54.1994 139.664 54.2507 139.753C54.2999 139.842 54.2704 139.956 54.1797 140.005L16.0385 161.68C16.009 161.696 15.9775 161.704 15.9479 161.704V161.706Z",
    fill: "url(#paint222_linear_376_5139)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30338 157.356C8.23836 157.356 8.17729 157.322 8.14182 157.261C8.09257 157.172 8.12212 157.058 8.21275 157.007L46.3539 135.332C46.4426 135.28 46.5549 135.312 46.6061 135.401C46.6554 135.49 46.6258 135.604 46.5352 135.653L8.39401 157.328C8.36446 157.344 8.33293 157.352 8.30338 157.352V157.356Z",
    fill: "url(#paint223_linear_376_5139)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M115.074 348.082C115.043 348.082 115.011 348.074 114.984 348.059L76.8426 326.384C76.7855 326.35 76.748 326.289 76.748 326.222V282.872C76.748 282.805 76.7835 282.744 76.8426 282.71L114.984 261.035C115.041 261.004 115.11 261.004 115.167 261.035L153.308 282.71C153.365 282.744 153.403 282.805 153.403 282.872V326.222C153.403 326.289 153.367 326.35 153.308 326.384L115.167 348.059C115.139 348.074 115.108 348.082 115.076 348.082H115.074ZM77.1204 326.113L115.074 347.684L153.028 326.113V282.979L115.074 261.408L77.1204 282.979V326.113Z",
    fill: "url(#paint224_linear_376_5139)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 304.732C115.043 304.732 115.012 304.724 114.984 304.709L76.8432 283.034C76.7545 282.982 76.723 282.87 76.7723 282.781C76.8235 282.692 76.9358 282.661 77.0245 282.71L115.073 304.334L153.122 282.71C153.21 282.661 153.323 282.69 153.374 282.781C153.423 282.87 153.394 282.984 153.303 283.034L115.162 304.709C115.134 304.724 115.103 304.732 115.071 304.732H115.075Z",
    fill: "url(#paint225_linear_376_5139)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 348.082C114.972 348.082 114.89 347.999 114.89 347.897V304.547C114.89 304.444 114.972 304.361 115.075 304.361C115.177 304.361 115.26 304.444 115.26 304.547V347.897C115.26 347.999 115.177 348.082 115.075 348.082Z",
    fill: "url(#paint226_linear_376_5139)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 348.082C115.043 348.082 115.012 348.074 114.984 348.058L76.8432 326.383C76.7545 326.332 76.723 326.22 76.7723 326.131C76.8235 326.042 76.9358 326.011 77.0245 326.06L115.166 347.735C115.254 347.786 115.286 347.899 115.237 347.987C115.203 348.048 115.14 348.082 115.075 348.082Z",
    fill: "url(#paint227_linear_376_5139)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 339.467C115.043 339.467 115.012 339.459 114.984 339.444L76.8432 317.769C76.7545 317.717 76.723 317.605 76.7723 317.516C76.8235 317.425 76.9358 317.396 77.0245 317.445L115.166 339.12C115.254 339.171 115.286 339.284 115.237 339.372C115.203 339.434 115.14 339.467 115.075 339.467Z",
    fill: "url(#paint228_linear_376_5139)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 330.797C115.043 330.797 115.012 330.789 114.984 330.773L76.8432 309.096C76.7545 309.045 76.723 308.933 76.7723 308.844C76.8235 308.753 76.9358 308.723 77.0245 308.773L115.166 330.45C115.254 330.501 115.286 330.613 115.237 330.702C115.201 330.763 115.14 330.797 115.075 330.797Z",
    fill: "url(#paint229_linear_376_5139)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 322.124C115.043 322.124 115.012 322.117 114.984 322.101L76.8432 300.426C76.7545 300.375 76.723 300.262 76.7723 300.173C76.8235 300.085 76.9358 300.053 77.0245 300.102L115.166 321.777C115.254 321.829 115.286 321.941 115.237 322.03C115.203 322.091 115.14 322.124 115.075 322.124Z",
    fill: "url(#paint230_linear_376_5139)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 313.454C115.043 313.454 115.012 313.446 114.984 313.43L76.8432 291.756C76.7545 291.704 76.723 291.592 76.7723 291.501C76.8235 291.412 76.9358 291.381 77.0245 291.43L115.166 313.105C115.254 313.156 115.286 313.269 115.237 313.357C115.203 313.419 115.14 313.452 115.075 313.452V313.454Z",
    fill: "url(#paint231_linear_376_5139)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M122.945 343.6C122.843 343.6 122.76 343.517 122.76 343.415V300.073C122.76 299.97 122.843 299.887 122.945 299.887C123.047 299.887 123.13 299.97 123.13 300.073V343.415C123.13 343.517 123.047 343.6 122.945 343.6Z",
    fill: "url(#paint232_linear_376_5139)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M130.597 339.262C130.495 339.262 130.412 339.179 130.412 339.077V295.735C130.412 295.632 130.495 295.549 130.597 295.549C130.7 295.549 130.783 295.632 130.783 295.735V339.077C130.783 339.179 130.7 339.262 130.597 339.262Z",
    fill: "url(#paint233_linear_376_5139)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M138.25 334.912C138.147 334.912 138.064 334.829 138.064 334.727V291.385C138.064 291.282 138.147 291.199 138.25 291.199C138.352 291.199 138.435 291.282 138.435 291.385V334.727C138.435 334.829 138.352 334.912 138.25 334.912Z",
    fill: "url(#paint234_linear_376_5139)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M145.902 330.564C145.8 330.564 145.717 330.481 145.717 330.378V287.037C145.717 286.934 145.8 286.851 145.902 286.851C146.004 286.851 146.087 286.934 146.087 287.037V330.378C146.087 330.481 146.004 330.564 145.902 330.564Z",
    fill: "url(#paint235_linear_376_5139)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M107.179 300.27C107.114 300.27 107.053 300.236 107.018 300.175C106.969 300.086 106.998 299.972 107.089 299.923L145.23 278.246C145.319 278.197 145.431 278.226 145.482 278.317C145.531 278.406 145.502 278.52 145.411 278.569L107.27 300.246C107.24 300.262 107.209 300.27 107.179 300.27Z",
    fill: "url(#paint236_linear_376_5139)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5358 295.92C99.4708 295.92 99.4097 295.886 99.3742 295.825C99.325 295.736 99.3545 295.622 99.4452 295.573L137.586 273.896C137.675 273.846 137.787 273.876 137.839 273.967C137.888 274.056 137.858 274.17 137.768 274.219L99.6264 295.896C99.5969 295.912 99.5654 295.92 99.5358 295.92Z",
    fill: "url(#paint237_linear_376_5139)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8893 291.572C91.8243 291.572 91.7632 291.538 91.7278 291.477C91.6785 291.388 91.7081 291.274 91.7987 291.224L129.94 269.548C130.029 269.498 130.141 269.528 130.192 269.619C130.241 269.707 130.212 269.822 130.121 269.871L91.9799 291.548C91.9504 291.564 91.9189 291.572 91.8893 291.572Z",
    fill: "url(#paint238_linear_376_5139)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2448 287.222C84.1798 287.222 84.1187 287.189 84.0832 287.127C84.034 287.039 84.0635 286.924 84.1542 286.875L122.295 265.198C122.384 265.149 122.496 265.178 122.548 265.269C122.597 265.358 122.567 265.472 122.477 265.522L84.3354 287.198C84.3059 287.214 84.2743 287.222 84.2448 287.222Z",
    fill: "url(#paint239_linear_376_5139)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 348.082C115.01 348.082 114.949 348.049 114.913 347.988C114.864 347.899 114.894 347.785 114.984 347.735L153.125 326.06C153.214 326.011 153.326 326.041 153.378 326.131C153.427 326.22 153.397 326.335 153.307 326.384L115.165 348.059C115.136 348.075 115.104 348.082 115.075 348.082Z",
    fill: "url(#paint240_linear_376_5139)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 339.467C115.01 339.467 114.949 339.434 114.913 339.372C114.864 339.284 114.894 339.169 114.984 339.12L153.125 317.445C153.214 317.396 153.326 317.425 153.378 317.516C153.427 317.605 153.397 317.719 153.307 317.769L115.165 339.444C115.136 339.459 115.104 339.467 115.075 339.467Z",
    fill: "url(#paint241_linear_376_5139)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 330.797C115.01 330.797 114.949 330.763 114.913 330.702C114.864 330.613 114.894 330.499 114.984 330.45L153.125 308.773C153.214 308.723 153.326 308.753 153.378 308.844C153.427 308.933 153.397 309.047 153.307 309.096L115.165 330.773C115.136 330.789 115.104 330.797 115.075 330.797Z",
    fill: "url(#paint242_linear_376_5139)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 322.124C115.01 322.124 114.949 322.091 114.913 322.03C114.864 321.941 114.894 321.827 114.984 321.777L153.125 300.102C153.214 300.053 153.326 300.083 153.378 300.173C153.427 300.262 153.397 300.377 153.307 300.426L115.165 322.101C115.136 322.117 115.104 322.124 115.075 322.124Z",
    fill: "url(#paint243_linear_376_5139)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M115.075 313.454C115.01 313.454 114.949 313.42 114.913 313.359C114.864 313.271 114.894 313.156 114.984 313.107L153.125 291.432C153.214 291.383 153.326 291.412 153.378 291.503C153.427 291.592 153.397 291.706 153.307 291.757L115.165 313.432C115.136 313.448 115.104 313.456 115.075 313.456V313.454Z",
    fill: "url(#paint244_linear_376_5139)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M107.204 343.6C107.101 343.6 107.019 343.517 107.019 343.415V300.073C107.019 299.97 107.101 299.887 107.204 299.887C107.306 299.887 107.389 299.97 107.389 300.073V343.415C107.389 343.517 107.306 343.6 107.204 343.6Z",
    fill: "url(#paint245_linear_376_5139)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5495 339.262C99.447 339.262 99.3643 339.179 99.3643 339.077V295.735C99.3643 295.632 99.447 295.549 99.5495 295.549C99.6519 295.549 99.7347 295.632 99.7347 295.735V339.077C99.7347 339.179 99.6519 339.262 99.5495 339.262Z",
    fill: "url(#paint246_linear_376_5139)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8971 334.912C91.7947 334.912 91.7119 334.829 91.7119 334.727V291.385C91.7119 291.282 91.7947 291.199 91.8971 291.199C91.9996 291.199 92.0823 291.282 92.0823 291.385V334.727C92.0823 334.829 91.9996 334.912 91.8971 334.912Z",
    fill: "url(#paint247_linear_376_5139)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2448 330.564C84.1423 330.564 84.0596 330.481 84.0596 330.378V287.037C84.0596 286.934 84.1423 286.851 84.2448 286.851C84.3472 286.851 84.43 286.934 84.43 287.037V330.378C84.43 330.481 84.3472 330.564 84.2448 330.564Z",
    fill: "url(#paint248_linear_376_5139)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M122.968 300.27C122.936 300.27 122.905 300.262 122.877 300.246L84.7358 278.569C84.6471 278.518 84.6156 278.406 84.6648 278.317C84.7161 278.226 84.8284 278.197 84.917 278.246L123.058 299.923C123.147 299.974 123.178 300.086 123.129 300.175C123.094 300.236 123.033 300.27 122.968 300.27Z",
    fill: "url(#paint249_linear_376_5139)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M130.614 295.92C130.583 295.92 130.551 295.912 130.523 295.896L92.3823 274.219C92.2936 274.168 92.2621 274.056 92.3113 273.967C92.3626 273.878 92.4749 273.847 92.5635 273.896L130.705 295.573C130.793 295.624 130.825 295.736 130.776 295.825C130.74 295.886 130.679 295.92 130.614 295.92Z",
    fill: "url(#paint250_linear_376_5139)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M138.258 291.572C138.226 291.572 138.195 291.564 138.167 291.549L100.026 269.872C99.9372 269.82 99.9056 269.708 99.9549 269.619C100.006 269.53 100.118 269.499 100.207 269.548L138.348 291.225C138.437 291.276 138.468 291.389 138.419 291.478C138.384 291.539 138.323 291.572 138.258 291.572Z",
    fill: "url(#paint251_linear_376_5139)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M145.902 287.222C145.871 287.222 145.839 287.214 145.812 287.198L107.67 265.522C107.582 265.47 107.55 265.358 107.599 265.269C107.649 265.178 107.763 265.149 107.852 265.198L145.993 286.875C146.081 286.926 146.113 287.039 146.064 287.127C146.03 287.189 145.967 287.222 145.902 287.222Z",
    fill: "url(#paint252_linear_376_5139)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M267.634 218.03C267.602 218.03 267.571 218.022 267.543 218.006L229.402 196.331C229.345 196.298 229.308 196.237 229.308 196.17V152.818C229.308 152.751 229.343 152.69 229.402 152.656L267.543 130.981C267.6 130.948 267.669 130.948 267.727 130.981L305.868 152.656C305.925 152.69 305.962 152.751 305.962 152.818V196.17C305.962 196.237 305.927 196.298 305.868 196.331L267.727 218.006C267.699 218.022 267.668 218.03 267.636 218.03H267.634ZM229.68 196.061L267.634 217.631L305.588 196.061V152.926L267.634 131.356L229.68 152.926V196.061Z",
    fill: "url(#paint253_linear_376_5139)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M267.635 174.68C267.603 174.68 267.572 174.672 267.544 174.656L229.403 152.981C229.314 152.93 229.283 152.818 229.332 152.729C229.383 152.638 229.495 152.606 229.584 152.66L267.633 174.283L305.681 152.66C305.77 152.606 305.882 152.64 305.933 152.729C305.983 152.818 305.953 152.932 305.862 152.981L267.721 174.656C267.694 174.672 267.662 174.68 267.631 174.68H267.635Z",
    fill: "url(#paint254_linear_376_5139)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M267.634 218.03C267.532 218.03 267.449 217.947 267.449 217.845V174.495C267.449 174.392 267.532 174.31 267.634 174.31C267.737 174.31 267.82 174.392 267.82 174.495V217.845C267.82 217.947 267.737 218.03 267.634 218.03Z",
    fill: "url(#paint255_linear_376_5139)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 158.886C229.451 158.886 229.405 158.871 229.37 158.839C229.293 158.77 229.287 158.654 229.354 158.577L232.806 154.698L234.486 149.82C234.52 149.723 234.628 149.672 234.723 149.705C234.819 149.739 234.871 149.845 234.839 149.942L233.147 154.856C233.139 154.88 233.127 154.901 233.109 154.919L229.632 158.825C229.596 158.867 229.543 158.886 229.494 158.886Z",
    fill: "url(#paint256_linear_376_5139)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M239.008 201.763C238.964 201.763 238.919 201.747 238.883 201.716C238.807 201.646 238.801 201.53 238.868 201.453L264.47 172.694L276.946 136.474C276.979 136.377 277.088 136.326 277.182 136.359C277.279 136.393 277.33 136.499 277.298 136.596L264.811 172.85C264.803 172.874 264.792 172.895 264.774 172.913L239.147 201.7C239.112 201.741 239.059 201.761 239.01 201.761L239.008 201.763Z",
    fill: "url(#paint257_linear_376_5139)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M245.335 205.357C245.291 205.357 245.246 205.342 245.211 205.31C245.134 205.241 245.128 205.125 245.195 205.048L267.496 179.997C267.564 179.92 267.683 179.914 267.758 179.981C267.834 180.051 267.84 180.167 267.773 180.244L245.473 205.294C245.437 205.336 245.384 205.355 245.335 205.355V205.357Z",
    fill: "url(#paint258_linear_376_5139)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M251.673 208.959C251.629 208.959 251.584 208.943 251.548 208.912C251.472 208.843 251.466 208.726 251.533 208.65L267.495 190.719C267.564 190.642 267.682 190.636 267.757 190.703C267.834 190.772 267.84 190.889 267.773 190.966L251.81 208.896C251.775 208.938 251.722 208.957 251.673 208.957V208.959Z",
    fill: "url(#paint259_linear_376_5139)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M258.064 212.591C258.021 212.591 257.976 212.576 257.94 212.544C257.863 212.475 257.857 212.359 257.924 212.282L267.494 201.532C267.563 201.455 267.681 201.449 267.756 201.516C267.832 201.585 267.838 201.702 267.771 201.779L258.202 212.528C258.167 212.57 258.113 212.591 258.064 212.591Z",
    fill: "url(#paint260_linear_376_5139)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M264.39 216.188C264.347 216.188 264.302 216.172 264.266 216.14C264.189 216.071 264.183 215.955 264.25 215.878L267.47 212.262C267.539 212.185 267.657 212.179 267.732 212.246C267.809 212.315 267.815 212.432 267.748 212.509L264.528 216.125C264.493 216.166 264.44 216.188 264.39 216.188Z",
    fill: "url(#paint261_linear_376_5139)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M272.698 171.802C272.679 171.802 272.657 171.798 272.637 171.792C272.541 171.759 272.489 171.652 272.521 171.556L283.349 140.115C283.383 140.019 283.491 139.967 283.586 140.001C283.682 140.035 283.733 140.141 283.702 140.238L272.874 171.678C272.846 171.755 272.775 171.804 272.698 171.804V171.802Z",
    fill: "url(#paint262_linear_376_5139)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M282.122 166.446C282.102 166.446 282.081 166.442 282.061 166.436C281.965 166.403 281.913 166.296 281.945 166.2L289.688 143.716C289.721 143.619 289.832 143.568 289.924 143.602C290.021 143.635 290.072 143.742 290.04 143.838L282.297 166.322C282.27 166.399 282.199 166.448 282.122 166.448V166.446Z",
    fill: "url(#paint263_linear_376_5139)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M291.593 161.065C291.573 161.065 291.551 161.061 291.532 161.055C291.435 161.021 291.384 160.915 291.416 160.818L296.059 147.336C296.093 147.239 296.203 147.188 296.296 147.222C296.392 147.255 296.443 147.362 296.412 147.458L291.768 160.94C291.741 161.017 291.67 161.067 291.593 161.067V161.065Z",
    fill: "url(#paint264_linear_376_5139)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M300.969 155.736C300.949 155.736 300.927 155.732 300.908 155.726C300.811 155.692 300.76 155.586 300.792 155.489L302.366 150.92C302.399 150.823 302.508 150.772 302.602 150.806C302.699 150.839 302.75 150.946 302.718 151.042L301.144 155.611C301.117 155.688 301.046 155.738 300.969 155.738V155.736Z",
    fill: "url(#paint265_linear_376_5139)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M232.675 198.163C232.632 198.163 232.587 198.147 232.551 198.115C232.475 198.046 232.469 197.93 232.536 197.853L258.138 169.094L270.612 132.874C270.645 132.777 270.754 132.726 270.848 132.759C270.945 132.793 270.996 132.899 270.964 132.996L258.479 169.25C258.471 169.273 258.46 169.295 258.442 169.313L232.815 198.1C232.78 198.141 232.727 198.161 232.677 198.161L232.675 198.163Z",
    fill: "url(#paint266_linear_376_5139)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 191.007C229.451 191.007 229.405 190.992 229.37 190.96C229.293 190.891 229.287 190.775 229.354 190.698L251.795 165.489L262.717 133.775C262.751 133.678 262.859 133.627 262.954 133.661C263.05 133.694 263.102 133.801 263.07 133.897L252.135 165.647C252.128 165.671 252.116 165.693 252.098 165.71L229.632 190.946C229.596 190.988 229.543 191.007 229.494 191.007Z",
    fill: "url(#paint267_linear_376_5139)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 180.279C229.451 180.279 229.405 180.263 229.37 180.232C229.293 180.163 229.287 180.046 229.354 179.969L245.453 161.885L253.288 139.135C253.322 139.038 253.43 138.987 253.524 139.021C253.621 139.054 253.672 139.161 253.641 139.257L245.793 162.043C245.785 162.067 245.774 162.088 245.756 162.106L229.632 180.218C229.596 180.259 229.543 180.279 229.494 180.279Z",
    fill: "url(#paint268_linear_376_5139)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 169.558C229.451 169.558 229.405 169.542 229.37 169.51C229.293 169.441 229.287 169.325 229.354 169.248L239.114 158.283L243.865 144.489C243.898 144.393 244.008 144.341 244.101 144.375C244.197 144.409 244.249 144.515 244.217 144.612L239.455 158.441C239.447 158.465 239.436 158.486 239.418 158.504L229.632 169.496C229.596 169.538 229.543 169.558 229.494 169.558Z",
    fill: "url(#paint269_linear_376_5139)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M264.439 216.214C264.368 216.214 264.299 216.172 264.268 216.103L239.108 158.455C239.084 158.401 239.088 158.338 239.118 158.287C239.148 158.236 239.199 158.202 239.258 158.194L302.586 150.834C302.694 150.822 302.781 150.895 302.793 150.998C302.805 151.1 302.732 151.191 302.631 151.205L239.551 158.537L264.61 215.955C264.652 216.05 264.608 216.158 264.514 216.2C264.488 216.21 264.465 216.216 264.439 216.216V216.214Z",
    fill: "url(#paint270_linear_376_5139)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 212.629C258.061 212.629 257.992 212.588 257.96 212.519L232.801 154.87C232.777 154.817 232.781 154.754 232.81 154.703C232.84 154.651 232.891 154.618 232.95 154.61L296.279 147.249C296.383 147.24 296.474 147.311 296.485 147.413C296.497 147.516 296.424 147.607 296.324 147.62L233.244 154.953L258.303 212.371C258.344 212.466 258.301 212.574 258.206 212.615C258.181 212.625 258.157 212.631 258.131 212.631V212.629Z",
    fill: "url(#paint271_linear_376_5139)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M267.634 212.617C267.564 212.617 267.495 212.575 267.463 212.506L245.446 162.057C245.422 162.003 245.426 161.94 245.456 161.889C245.485 161.838 245.537 161.804 245.596 161.796L300.947 155.363C301.051 155.355 301.142 155.424 301.154 155.527C301.165 155.629 301.092 155.72 300.992 155.734L245.889 162.137L267.806 212.356C267.847 212.451 267.804 212.56 267.709 212.601C267.684 212.611 267.66 212.617 267.634 212.617Z",
    fill: "url(#paint272_linear_376_5139)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M267.635 201.69C267.564 201.69 267.495 201.649 267.464 201.578L251.789 165.661C251.765 165.608 251.769 165.545 251.799 165.493C251.828 165.442 251.879 165.409 251.939 165.401L291.349 160.82C291.453 160.812 291.544 160.881 291.555 160.984C291.567 161.086 291.494 161.177 291.394 161.191L252.232 165.742L267.807 201.43C267.848 201.524 267.805 201.633 267.71 201.674C267.684 201.684 267.661 201.69 267.635 201.69Z",
    fill: "url(#paint273_linear_376_5139)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M267.635 190.761C267.564 190.761 267.495 190.719 267.463 190.648L258.131 169.263C258.107 169.21 258.111 169.147 258.14 169.096C258.17 169.044 258.221 169.011 258.28 169.003L281.743 166.275C281.854 166.267 281.937 166.336 281.95 166.438C281.964 166.541 281.889 166.632 281.789 166.645L258.574 169.344L267.806 190.498C267.848 190.593 267.804 190.701 267.71 190.743C267.684 190.753 267.66 190.759 267.635 190.759V190.761Z",
    fill: "url(#paint274_linear_376_5139)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M267.635 179.847C267.564 179.847 267.495 179.806 267.463 179.735L264.465 172.862C264.441 172.808 264.445 172.745 264.474 172.694C264.504 172.643 264.555 172.609 264.614 172.601L272.156 171.725C272.267 171.714 272.351 171.787 272.363 171.889C272.375 171.992 272.302 172.082 272.202 172.096L264.91 172.945L267.81 179.587C267.851 179.682 267.808 179.79 267.713 179.832C267.688 179.841 267.664 179.847 267.639 179.847H267.635Z",
    fill: "url(#paint275_linear_376_5139)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M232.972 154.98C232.879 154.98 232.798 154.911 232.786 154.817C232.775 154.714 232.847 154.623 232.948 154.61L295.821 147.3C295.928 147.293 296.016 147.362 296.028 147.464C296.04 147.567 295.967 147.657 295.866 147.671L232.993 154.98C232.993 154.98 232.979 154.98 232.972 154.98Z",
    fill: "url(#paint276_linear_376_5139)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M234.583 150.301C234.49 150.301 234.41 150.232 234.398 150.137C234.386 150.035 234.459 149.944 234.559 149.93L289.715 143.519C289.827 143.511 289.91 143.58 289.922 143.682C289.934 143.785 289.861 143.876 289.76 143.89L234.605 150.301C234.605 150.301 234.591 150.301 234.583 150.301Z",
    fill: "url(#paint277_linear_376_5139)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M243.971 144.947C243.876 144.947 243.797 144.878 243.785 144.783C243.774 144.68 243.847 144.59 243.947 144.576L283.487 139.979C283.597 139.967 283.68 140.04 283.694 140.143C283.708 140.246 283.633 140.336 283.532 140.35L243.992 144.947C243.992 144.947 243.979 144.947 243.971 144.947Z",
    fill: "url(#paint278_linear_376_5139)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M253.408 139.549C253.314 139.549 253.235 139.48 253.223 139.386C253.211 139.283 253.284 139.192 253.384 139.178L277.204 136.411C277.305 136.401 277.399 136.472 277.411 136.574C277.423 136.677 277.35 136.768 277.25 136.781L253.43 139.549C253.43 139.549 253.416 139.549 253.408 139.549Z",
    fill: "url(#paint279_linear_376_5139)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M262.863 134.114C262.769 134.114 262.69 134.045 262.678 133.951C262.666 133.848 262.739 133.757 262.84 133.744L270.87 132.81C270.982 132.801 271.065 132.872 271.077 132.974C271.089 133.077 271.016 133.168 270.915 133.181L262.885 134.114C262.885 134.114 262.871 134.114 262.863 134.114Z",
    fill: "url(#paint280_linear_376_5139)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M251.787 208.834C251.716 208.834 251.647 208.792 251.618 208.723L229.541 158.536C229.5 158.443 229.541 158.332 229.636 158.291C229.727 158.252 229.839 158.291 229.88 158.386L251.956 208.573C251.998 208.666 251.956 208.776 251.862 208.818C251.838 208.828 251.813 208.834 251.787 208.834Z",
    fill: "url(#paint281_linear_376_5139)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M245.634 205.527C245.563 205.527 245.494 205.486 245.464 205.416L229.557 169.252C229.516 169.157 229.557 169.048 229.652 169.007C229.742 168.967 229.855 169.007 229.896 169.102L245.803 205.267C245.845 205.359 245.803 205.47 245.709 205.511C245.685 205.521 245.66 205.527 245.634 205.527Z",
    fill: "url(#paint282_linear_376_5139)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M239.263 201.907C239.192 201.907 239.123 201.866 239.093 201.797L229.496 179.978C229.455 179.885 229.496 179.774 229.591 179.733C229.682 179.694 229.794 179.733 229.835 179.828L239.432 201.647C239.474 201.739 239.432 201.85 239.338 201.891C239.314 201.901 239.288 201.907 239.263 201.907Z",
    fill: "url(#paint283_linear_376_5139)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M232.943 198.314C232.873 198.314 232.804 198.273 232.774 198.204L229.482 190.721C229.44 190.627 229.482 190.518 229.576 190.477C229.667 190.437 229.779 190.477 229.821 190.571L233.113 198.054C233.154 198.147 233.113 198.257 233.018 198.299C232.995 198.309 232.969 198.314 232.943 198.314Z",
    fill: "url(#paint284_linear_376_5139)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M271.262 215.969C271.211 215.969 271.16 215.947 271.124 215.905L267.497 211.836C267.428 211.759 267.436 211.642 267.513 211.573C267.588 211.504 267.706 211.51 267.775 211.589L271.402 215.659C271.471 215.736 271.463 215.852 271.387 215.921C271.351 215.953 271.308 215.969 271.262 215.969Z",
    fill: "url(#paint285_linear_376_5139)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M277.557 212.392C277.506 212.392 277.455 212.371 277.419 212.329L267.497 201.199C267.428 201.122 267.436 201.006 267.513 200.937C267.588 200.868 267.706 200.873 267.775 200.952L277.697 212.085C277.766 212.162 277.758 212.278 277.681 212.347C277.646 212.379 277.603 212.394 277.557 212.394V212.392Z",
    fill: "url(#paint286_linear_376_5139)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M283.852 208.813C283.801 208.813 283.75 208.792 283.714 208.752L267.497 190.559C267.428 190.482 267.436 190.366 267.513 190.297C267.588 190.23 267.706 190.236 267.775 190.313L283.992 208.506C284.061 208.583 284.053 208.699 283.976 208.768C283.941 208.8 283.897 208.815 283.852 208.815V208.813Z",
    fill: "url(#paint287_linear_376_5139)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M290.226 205.192C290.174 205.192 290.123 205.17 290.088 205.131L267.495 179.786C267.426 179.709 267.434 179.593 267.511 179.524C267.586 179.455 267.704 179.461 267.773 179.54L290.366 204.884C290.434 204.961 290.427 205.077 290.35 205.146C290.314 205.178 290.271 205.194 290.226 205.194V205.192Z",
    fill: "url(#paint288_linear_376_5139)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M296.563 201.589C296.512 201.589 296.461 201.568 296.426 201.528L270.805 172.787C270.736 172.71 270.744 172.593 270.821 172.524C270.896 172.457 271.014 172.463 271.083 172.54L296.703 201.282C296.772 201.359 296.764 201.475 296.688 201.544C296.652 201.576 296.609 201.591 296.563 201.591V201.589Z",
    fill: "url(#paint289_linear_376_5139)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M302.905 197.985C302.854 197.985 302.803 197.964 302.768 197.924L277.119 169.149C277.05 169.072 277.058 168.956 277.135 168.887C277.21 168.818 277.328 168.824 277.397 168.903L303.045 197.677C303.114 197.754 303.106 197.871 303.03 197.94C302.994 197.971 302.951 197.987 302.905 197.987V197.985Z",
    fill: "url(#paint290_linear_376_5139)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M305.774 190.502C305.723 190.502 305.671 190.48 305.636 190.441L283.449 165.552C283.381 165.476 283.388 165.359 283.465 165.29C283.54 165.223 283.658 165.229 283.727 165.306L305.914 190.194C305.983 190.271 305.975 190.388 305.898 190.457C305.863 190.488 305.819 190.504 305.774 190.504V190.502Z",
    fill: "url(#paint291_linear_376_5139)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M305.774 179.733C305.723 179.733 305.672 179.711 305.636 179.671L289.822 161.93C289.753 161.853 289.76 161.737 289.837 161.668C289.912 161.599 290.03 161.607 290.099 161.684L305.914 179.425C305.983 179.502 305.975 179.618 305.898 179.687C305.863 179.719 305.82 179.735 305.774 179.735V179.733Z",
    fill: "url(#paint292_linear_376_5139)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M305.774 169.019C305.723 169.019 305.672 168.997 305.636 168.958L296.159 158.329C296.09 158.252 296.098 158.135 296.175 158.066C296.25 157.999 296.368 158.003 296.437 158.082L305.914 168.711C305.983 168.788 305.975 168.905 305.898 168.974C305.863 169.005 305.819 169.021 305.774 169.021V169.019Z",
    fill: "url(#paint293_linear_376_5139)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M305.774 158.358C305.723 158.358 305.672 158.336 305.636 158.297L302.47 154.744C302.401 154.667 302.409 154.55 302.486 154.481C302.561 154.412 302.679 154.42 302.748 154.497L305.914 158.05C305.983 158.127 305.975 158.243 305.898 158.312C305.863 158.344 305.819 158.36 305.774 158.36V158.358Z",
    fill: "url(#paint294_linear_376_5139)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M267.635 180.708C267.609 180.708 267.583 180.702 267.558 180.692C267.465 180.65 267.424 180.54 267.465 180.447L271.077 172.367C271.118 172.272 271.228 172.231 271.323 172.274C271.416 172.315 271.457 172.426 271.416 172.519L267.804 180.599C267.773 180.668 267.706 180.71 267.635 180.71V180.708Z",
    fill: "url(#paint295_linear_376_5139)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M277.655 212.337C277.63 212.337 277.606 212.331 277.58 212.321C277.486 212.279 277.444 212.171 277.486 212.076L302.76 154.363C302.801 154.268 302.907 154.227 303.004 154.268C303.096 154.309 303.14 154.42 303.098 154.513L277.825 212.226C277.795 212.295 277.726 212.337 277.655 212.337Z",
    fill: "url(#paint296_linear_376_5139)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M284.085 208.683C284.059 208.683 284.035 208.678 284.01 208.668C283.917 208.626 283.874 208.516 283.915 208.423L305.607 158.889C305.648 158.794 305.755 158.752 305.851 158.794C305.946 158.835 305.987 158.946 305.946 159.038L284.254 208.573C284.224 208.642 284.155 208.683 284.085 208.683Z",
    fill: "url(#paint297_linear_376_5139)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M290.391 205.099C290.365 205.099 290.341 205.093 290.316 205.083C290.221 205.041 290.18 204.931 290.221 204.838L305.606 169.705C305.648 169.61 305.754 169.569 305.851 169.61C305.945 169.652 305.987 169.762 305.945 169.855L290.56 204.988C290.53 205.057 290.461 205.099 290.391 205.099Z",
    fill: "url(#paint298_linear_376_5139)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M296.7 201.514C296.674 201.514 296.651 201.508 296.625 201.498C296.532 201.457 296.489 201.346 296.53 201.254L305.607 180.528C305.648 180.433 305.755 180.392 305.851 180.433C305.946 180.474 305.987 180.585 305.946 180.678L296.869 201.404C296.84 201.473 296.771 201.514 296.7 201.514Z",
    fill: "url(#paint299_linear_376_5139)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M303.004 197.93C302.978 197.93 302.954 197.924 302.929 197.914C302.836 197.873 302.793 197.762 302.834 197.669L305.604 191.345C305.646 191.25 305.752 191.208 305.848 191.25C305.943 191.291 305.984 191.402 305.943 191.495L303.173 197.819C303.143 197.888 303.074 197.93 303.004 197.93Z",
    fill: "url(#paint300_linear_376_5139)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M271.418 215.882C271.392 215.882 271.369 215.876 271.343 215.866C271.248 215.825 271.207 215.716 271.248 215.622L296.522 157.908C296.564 157.813 296.67 157.772 296.767 157.813C296.861 157.855 296.902 157.965 296.861 158.058L271.587 215.772C271.558 215.841 271.489 215.882 271.418 215.882Z",
    fill: "url(#paint301_linear_376_5139)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M267.635 213.674C267.61 213.674 267.586 213.668 267.56 213.659C267.468 213.617 267.425 213.509 267.466 213.414L290.2 161.498C290.241 161.404 290.348 161.362 290.444 161.404C290.537 161.445 290.58 161.556 290.539 161.648L267.805 213.564C267.775 213.633 267.706 213.674 267.635 213.674Z",
    fill: "url(#paint302_linear_376_5139)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M267.635 202.765C267.61 202.765 267.586 202.759 267.56 202.749C267.468 202.708 267.425 202.597 267.466 202.505L283.84 165.113C283.882 165.018 283.988 164.977 284.085 165.018C284.179 165.059 284.221 165.17 284.179 165.263L267.805 202.655C267.775 202.724 267.706 202.765 267.635 202.765Z",
    fill: "url(#paint303_linear_376_5139)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M267.635 191.867C267.61 191.867 267.586 191.861 267.56 191.851C267.468 191.81 267.425 191.699 267.466 191.607L277.486 168.724C277.528 168.63 277.634 168.588 277.731 168.63C277.823 168.671 277.867 168.782 277.825 168.874L267.805 191.757C267.775 191.826 267.706 191.867 267.635 191.867Z",
    fill: "url(#paint304_linear_376_5139)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M191.356 348.082C191.324 348.082 191.293 348.074 191.265 348.058L153.124 326.383C153.067 326.35 153.029 326.288 153.029 326.221V282.872C153.029 282.805 153.065 282.743 153.124 282.71L191.265 261.035C191.322 261.003 191.391 261.003 191.448 261.035L229.589 282.71C229.647 282.743 229.684 282.805 229.684 282.872V326.221C229.684 326.288 229.649 326.35 229.589 326.383L191.448 348.058C191.421 348.074 191.389 348.082 191.358 348.082H191.356ZM153.402 326.113L191.356 347.683L229.31 326.113V282.978L191.356 261.408L153.402 282.978V326.113Z",
    fill: "url(#paint305_linear_376_5139)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 304.732C191.323 304.732 191.292 304.724 191.264 304.708L153.123 283.033C153.05 282.992 153.013 282.905 153.034 282.824C153.056 282.741 153.131 282.686 153.214 282.686H229.494C229.579 282.686 229.652 282.743 229.673 282.824C229.695 282.905 229.658 282.992 229.585 283.033L191.444 304.708C191.416 304.724 191.384 304.732 191.353 304.732H191.355ZM153.919 283.057L191.355 304.333L228.791 283.057H153.917H153.919Z",
    fill: "url(#paint306_linear_376_5139)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 348.082C191.339 348.082 191.322 348.08 191.306 348.076C191.225 348.055 191.168 347.982 191.168 347.897V261.195C191.168 261.093 191.251 261.01 191.353 261.01C191.456 261.01 191.538 261.093 191.538 261.195V347.212L229.333 282.775C229.384 282.687 229.498 282.657 229.587 282.708C229.676 282.762 229.705 282.874 229.654 282.963L191.513 347.99C191.479 348.047 191.416 348.08 191.353 348.08L191.355 348.082Z",
    fill: "url(#paint307_linear_376_5139)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M191.394 296.908C191.363 296.908 191.331 296.9 191.304 296.884L167.287 283.241C167.23 283.207 167.192 283.146 167.192 283.079C167.192 283.012 167.228 282.951 167.287 282.917L191.304 269.117C191.361 269.084 191.432 269.084 191.489 269.117L215.2 282.882C215.257 282.915 215.293 282.976 215.293 283.041C215.293 283.106 215.257 283.17 215.2 283.203L191.489 296.882C191.459 296.898 191.428 296.908 191.396 296.908H191.394ZM167.754 283.077L191.394 296.507L214.735 283.041L191.394 269.492L167.754 283.077Z",
    fill: "url(#paint308_linear_376_5139)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M198.465 336.173C198.432 336.173 198.4 336.165 198.373 336.147C198.316 336.113 198.28 336.052 198.28 335.987V308.846C198.28 308.779 198.316 308.717 198.375 308.684L222.425 295.074C222.482 295.04 222.553 295.042 222.61 295.074C222.667 295.107 222.703 295.168 222.703 295.234V322.334C222.703 322.401 222.667 322.462 222.608 322.495L198.558 336.147C198.53 336.163 198.499 336.171 198.467 336.171L198.465 336.173ZM198.651 308.954V335.668L222.329 322.227V295.553L198.651 308.952V308.954Z",
    fill: "url(#paint309_linear_376_5139)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M184.285 336.172C184.254 336.172 184.222 336.164 184.195 336.149L160.144 322.497C160.087 322.464 160.05 322.402 160.05 322.335V295.235C160.05 295.17 160.085 295.109 160.142 295.075C160.2 295.042 160.269 295.042 160.328 295.075L184.378 308.686C184.435 308.719 184.472 308.78 184.472 308.847V335.989C184.472 336.054 184.437 336.115 184.38 336.149C184.35 336.164 184.319 336.174 184.287 336.174L184.285 336.172ZM160.422 322.227L184.1 335.667V308.954L160.422 295.555V322.229V322.227Z",
    fill: "url(#paint310_linear_376_5139)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M229.494 326.407C229.462 326.407 229.431 326.399 229.403 326.383L191.355 304.76L153.306 326.383C153.215 326.433 153.105 326.403 153.054 326.312C153.005 326.224 153.034 326.109 153.125 326.058L191.266 304.383C191.323 304.351 191.392 304.351 191.449 304.383L229.59 326.058C229.679 326.109 229.711 326.222 229.661 326.312C229.626 326.374 229.565 326.407 229.5 326.407H229.494Z",
    fill: "url(#paint311_linear_376_5139)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 348.082C191.292 348.082 191.229 348.048 191.196 347.991L153.054 282.965C153.003 282.876 153.033 282.761 153.121 282.71C153.21 282.657 153.322 282.688 153.376 282.777L191.517 347.804C191.568 347.893 191.538 348.007 191.45 348.058C191.42 348.076 191.387 348.084 191.355 348.084V348.082Z",
    fill: "url(#paint312_linear_376_5139)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_376_5139",
    x1: 214.788,
    y1: 69.0903,
    x2: 239.734,
    y2: 74.5321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_376_5139",
    x1: 195.846,
    y1: 79.9253,
    x2: 220.793,
    y2: 85.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_376_5139",
    x1: 214.914,
    y1: 90.7622,
    x2: 239.86,
    y2: 96.2044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_376_5139",
    x1: 233.855,
    y1: 79.9272,
    x2: 258.801,
    y2: 85.3691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_376_5139",
    x1: 228.583,
    y1: 102.74,
    x2: 246.995,
    y2: 104.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_376_5139",
    x1: 247.66,
    y1: 113.469,
    x2: 266.074,
    y2: 115.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_376_5139",
    x1: 247.6,
    y1: 91.9043,
    x2: 266.014,
    y2: 93.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_376_5139",
    x1: 228.645,
    y1: 124.305,
    x2: 247.059,
    y2: 126.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_376_5139",
    x1: 209.542,
    y1: 102.678,
    x2: 227.976,
    y2: 104.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_376_5139",
    x1: 190.445,
    y1: 113.381,
    x2: 208.88,
    y2: 115.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_376_5139",
    x1: 190.506,
    y1: 91.8608,
    x2: 208.941,
    y2: 93.6969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_376_5139",
    x1: 209.481,
    y1: 124.196,
    x2: 227.914,
    y2: 126.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_376_5139",
    x1: 188.304,
    y1: 65.9321,
    x2: 260.941,
    y2: 73.9616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_376_5139",
    x1: 188.305,
    y1: 87.6094,
    x2: 250.054,
    y2: 114.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_376_5139",
    x1: 229.296,
    y1: 109.283,
    x2: 229.651,
    y2: 109.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_376_5139",
    x1: 151.584,
    y1: 225.954,
    x2: 188.172,
    y2: 229.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_376_5139",
    x1: 113.451,
    y1: 225.947,
    x2: 150.024,
    y2: 229.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_376_5139",
    x1: 124.096,
    y1: 202.392,
    x2: 173.668,
    y2: 213.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_376_5139",
    x1: 112.025,
    y1: 195.985,
    x2: 184.661,
    y2: 204.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_376_5139",
    x1: 112.026,
    y1: 217.66,
    x2: 173.775,
    y2: 244.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_376_5139",
    x1: 153.015,
    y1: 239.337,
    x2: 153.371,
    y2: 239.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_376_5139",
    x1: 188.305,
    y1: 195.985,
    x2: 260.94,
    y2: 204.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_376_5139",
    x1: 188.306,
    y1: 217.66,
    x2: 250.056,
    y2: 244.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_376_5139",
    x1: 229.295,
    y1: 239.337,
    x2: 229.65,
    y2: 239.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_376_5139",
    x1: 190.064,
    y1: 234.276,
    x2: 217.15,
    y2: 240.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_376_5139",
    x1: 199.057,
    y1: 249.745,
    x2: 226.049,
    y2: 255.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_376_5139",
    x1: 237.573,
    y1: 228.217,
    x2: 265.386,
    y2: 230.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_376_5139",
    x1: 228.216,
    y1: 222.92,
    x2: 256.124,
    y2: 224.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_376_5139",
    x1: 197.859,
    y1: 212.605,
    x2: 198.042,
    y2: 215.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_376_5139",
    x1: 198.16,
    y1: 222.868,
    x2: 198.347,
    y2: 226.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_376_5139",
    x1: 35.7437,
    y1: 195.985,
    x2: 108.38,
    y2: 204.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_376_5139",
    x1: 35.7448,
    y1: 217.66,
    x2: 97.4952,
    y2: 244.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_376_5139",
    x1: 76.7342,
    y1: 239.337,
    x2: 77.0895,
    y2: 239.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_376_5139",
    x1: 73.8427,
    y1: 237.806,
    x2: 79.2469,
    y2: 238.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_376_5139",
    x1: 69.3423,
    y1: 235.426,
    x2: 82.6075,
    y2: 237.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_376_5139",
    x1: 64.845,
    y1: 233.047,
    x2: 85.9691,
    y2: 236.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_376_5139",
    x1: 60.3416,
    y1: 230.659,
    x2: 89.3305,
    y2: 234.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_376_5139",
    x1: 55.8484,
    y1: 228.289,
    x2: 92.6905,
    y2: 233.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_376_5139",
    x1: 51.3511,
    y1: 225.91,
    x2: 96.0523,
    y2: 232.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_376_5139",
    x1: 46.8519,
    y1: 223.533,
    x2: 99.4102,
    y2: 231.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_376_5139",
    x1: 42.3546,
    y1: 221.154,
    x2: 102.772,
    y2: 230.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_376_5139",
    x1: 37.8563,
    y1: 218.776,
    x2: 106.132,
    y2: 228.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_376_5139",
    x1: 77.614,
    y1: 220.184,
    x2: 112.232,
    y2: 222.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_376_5139",
    x1: 37.2537,
    y1: 220.186,
    x2: 71.8706,
    y2: 222.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_376_5139",
    x1: 37.4101,
    y1: 224.941,
    x2: 68.0329,
    y2: 227.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_376_5139",
    x1: 81.9548,
    y1: 224.94,
    x2: 112.582,
    y2: 227.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_376_5139",
    x1: 37.5664,
    y1: 229.699,
    x2: 64.1971,
    y2: 231.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_376_5139",
    x1: 86.2959,
    y1: 229.699,
    x2: 112.928,
    y2: 231.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_376_5139",
    x1: 37.7208,
    y1: 234.458,
    x2: 60.3593,
    y2: 236.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_376_5139",
    x1: 90.6387,
    y1: 234.457,
    x2: 113.278,
    y2: 236.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_376_5139",
    x1: 37.8792,
    y1: 239.215,
    x2: 56.5237,
    y2: 240.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_376_5139",
    x1: 94.9816,
    y1: 239.213,
    x2: 113.629,
    y2: 240.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_376_5139",
    x1: 38.0355,
    y1: 243.97,
    x2: 52.6879,
    y2: 245.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_376_5139",
    x1: 99.3226,
    y1: 243.97,
    x2: 113.976,
    y2: 245.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_376_5139",
    x1: 38.1919,
    y1: 248.729,
    x2: 48.8502,
    y2: 249.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_376_5139",
    x1: 103.664,
    y1: 248.728,
    x2: 114.325,
    y2: 249.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_376_5139",
    x1: 38.3483,
    y1: 253.486,
    x2: 45.0144,
    y2: 253.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_376_5139",
    x1: 108.007,
    y1: 253.484,
    x2: 114.675,
    y2: 253.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_376_5139",
    x1: 38.5026,
    y1: 258.244,
    x2: 41.1765,
    y2: 258.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_376_5139",
    x1: 112.348,
    y1: 258.242,
    x2: 115.023,
    y2: 258.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_376_5139",
    x1: 38.0149,
    y1: 216.46,
    x2: 38.1303,
    y2: 219.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_376_5139",
    x1: 42.3531,
    y1: 214.176,
    x2: 42.4828,
    y2: 217.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_376_5139",
    x1: 46.788,
    y1: 211.82,
    x2: 46.9368,
    y2: 214.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_376_5139",
    x1: 51.2422,
    y1: 209.465,
    x2: 51.4166,
    y2: 212.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_376_5139",
    x1: 55.6974,
    y1: 207.109,
    x2: 55.9079,
    y2: 209.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_376_5139",
    x1: 60.1506,
    y1: 204.754,
    x2: 60.4161,
    y2: 207.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_376_5139",
    x1: 64.6058,
    y1: 202.398,
    x2: 64.9646,
    y2: 205.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_376_5139",
    x1: 69.06,
    y1: 200.043,
    x2: 69.6088,
    y2: 202.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_376_5139",
    x1: 73.5345,
    y1: 197.687,
    x2: 74.6185,
    y2: 200.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_376_5139",
    x1: 73.8844,
    y1: 0.903314,
    x2: 146.519,
    y2: 8.93206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_376_5139",
    x1: 73.8855,
    y1: 22.582,
    x2: 135.635,
    y2: 49.5398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_376_5139",
    x1: 114.876,
    y1: 44.2583,
    x2: 115.231,
    y2: 44.2587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_376_5139",
    x1: 84.8987,
    y1: 6.00439,
    x2: 103.778,
    y2: 10.1193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_376_5139",
    x1: 123.091,
    y1: 6.00439,
    x2: 141.97,
    y2: 10.1193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_376_5139",
    x1: 123.106,
    y1: 27.8789,
    x2: 142.097,
    y2: 30.6267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_376_5139",
    x1: 85.3171,
    y1: 27.8789,
    x2: 104.307,
    y2: 30.6265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_376_5139",
    x1: 76.3746,
    y1: 32.8232,
    x2: 85.9583,
    y2: 33.3498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_376_5139",
    x1: 143.003,
    y1: 32.8218,
    x2: 152.586,
    y2: 33.3483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_376_5139",
    x1: 114.492,
    y1: 54.3037,
    x2: 124.593,
    y2: 54.8719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_376_5139",
    x1: 104.301,
    y1: 54.3022,
    x2: 114.402,
    y2: 54.8705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_376_5139",
    x1: 123.539,
    y1: 65.147,
    x2: 142.672,
    y2: 67.9471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_376_5139",
    x1: 84.7095,
    y1: 65.1494,
    x2: 103.844,
    y2: 67.9499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_376_5139",
    x1: 73.8843,
    y1: 130.957,
    x2: 146.521,
    y2: 138.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_376_5139",
    x1: 73.8855,
    y1: 152.635,
    x2: 135.635,
    y2: 179.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_376_5139",
    x1: 114.876,
    y1: 174.308,
    x2: 115.231,
    y2: 174.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_376_5139",
    x1: 87.7208,
    y1: 148.137,
    x2: 93.9576,
    y2: 149.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_376_5139",
    x1: 97.2463,
    y1: 153.608,
    x2: 103.481,
    y2: 154.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_376_5139",
    x1: 106.771,
    y1: 159.08,
    x2: 113.007,
    y2: 160.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_376_5139",
    x1: 116.296,
    y1: 164.551,
    x2: 122.533,
    y2: 165.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_376_5139",
    x1: 93.4744,
    y1: 140.42,
    x2: 98.833,
    y2: 141.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_376_5139",
    x1: 102.006,
    y1: 145.342,
    x2: 108.243,
    y2: 146.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_376_5139",
    x1: 111.532,
    y1: 150.812,
    x2: 117.769,
    y2: 152.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_376_5139",
    x1: 121.059,
    y1: 156.285,
    x2: 127.295,
    y2: 157.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_376_5139",
    x1: 130.625,
    y1: 161.755,
    x2: 135.866,
    y2: 162.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_376_5139",
    x1: 79.0433,
    y1: 151.302,
    x2: 80.3849,
    y2: 151.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_376_5139",
    x1: 83.9249,
    y1: 156.287,
    x2: 89.3243,
    y2: 157.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_376_5139",
    x1: 93.504,
    y1: 161.753,
    x2: 98.8568,
    y2: 162.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_376_5139",
    x1: 112.706,
    y1: 172.698,
    x2: 115.679,
    y2: 174.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_376_5139",
    x1: 106.707,
    y1: 137.277,
    x2: 112.944,
    y2: 138.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_376_5139",
    x1: 116.234,
    y1: 142.748,
    x2: 122.47,
    y2: 144.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_376_5139",
    x1: 125.759,
    y1: 148.218,
    x2: 131.996,
    y2: 149.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_376_5139",
    x1: 135.285,
    y1: 153.691,
    x2: 141.52,
    y2: 155.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_376_5139",
    x1: 112.43,
    y1: 132.25,
    x2: 115.665,
    y2: 134.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_376_5139",
    x1: 120.983,
    y1: 135.107,
    x2: 126.405,
    y2: 136.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_376_5139",
    x1: 130.505,
    y1: 140.553,
    x2: 135.973,
    y2: 141.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_376_5139",
    x1: 140.03,
    y1: 145.996,
    x2: 145.542,
    y2: 147.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_376_5139",
    x1: 149.722,
    y1: 151.44,
    x2: 151.176,
    y2: 151.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_376_5139",
    x1: 103.082,
    y1: 167.224,
    x2: 108.389,
    y2: 168.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_376_5139",
    x1: 79.1856,
    y1: 163.33,
    x2: 83.8759,
    y2: 163.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_376_5139",
    x1: 88.751,
    y1: 168.796,
    x2: 93.4413,
    y2: 169.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_376_5139",
    x1: 98.3165,
    y1: 174.267,
    x2: 103.005,
    y2: 174.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_376_5139",
    x1: 107.882,
    y1: 179.733,
    x2: 112.57,
    y2: 180.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_376_5139",
    x1: 76.6464,
    y1: 171.708,
    x2: 79.2476,
    y2: 171.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_376_5139",
    x1: 83.9121,
    y1: 176.906,
    x2: 88.6024,
    y2: 177.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_376_5139",
    x1: 93.4795,
    y1: 182.373,
    x2: 98.1698,
    y2: 182.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_376_5139",
    x1: 103.043,
    y1: 187.842,
    x2: 107.733,
    y2: 188.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_376_5139",
    x1: 112.7,
    y1: 193.314,
    x2: 115.059,
    y2: 193.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_376_5139",
    x1: 76.6484,
    y1: 193.226,
    x2: 79.2418,
    y2: 193.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_376_5139",
    x1: 83.9122,
    y1: 198.425,
    x2: 88.5675,
    y2: 199.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_376_5139",
    x1: 93.4777,
    y1: 203.892,
    x2: 98.1309,
    y2: 204.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_376_5139",
    x1: 103.046,
    y1: 209.358,
    x2: 107.7,
    y2: 209.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_376_5139",
    x1: 112.703,
    y1: 214.829,
    x2: 115.012,
    y2: 215.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_376_5139",
    x1: 76.6465,
    y1: 153.966,
    x2: 79.1648,
    y2: 154.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_376_5139",
    x1: 83.9162,
    y1: 156.81,
    x2: 88.5603,
    y2: 157.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_376_5139",
    x1: 93.4778,
    y1: 162.254,
    x2: 98.121,
    y2: 162.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_376_5139",
    x1: 103.043,
    y1: 167.686,
    x2: 107.688,
    y2: 168.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_376_5139",
    x1: 112.7,
    y1: 173.119,
    x2: 115.051,
    y2: 173.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_376_5139",
    x1: 79.1289,
    y1: 184.941,
    x2: 83.8192,
    y2: 185.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_376_5139",
    x1: 88.6934,
    y1: 190.411,
    x2: 93.3819,
    y2: 190.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_376_5139",
    x1: 98.2589,
    y1: 195.876,
    x2: 102.947,
    y2: 196.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_376_5139",
    x1: 107.824,
    y1: 201.344,
    x2: 112.515,
    y2: 201.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_376_5139",
    x1: 145.793,
    y1: 163.332,
    x2: 150.481,
    y2: 163.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_376_5139",
    x1: 136.228,
    y1: 168.796,
    x2: 140.918,
    y2: 169.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_376_5139",
    x1: 126.66,
    y1: 174.265,
    x2: 131.349,
    y2: 174.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_376_5139",
    x1: 117.095,
    y1: 179.732,
    x2: 121.783,
    y2: 180.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_376_5139",
    x1: 150.718,
    y1: 171.786,
    x2: 153.19,
    y2: 171.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_376_5139",
    x1: 141.065,
    y1: 176.909,
    x2: 145.752,
    y2: 177.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_376_5139",
    x1: 131.5,
    y1: 182.374,
    x2: 136.188,
    y2: 182.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_376_5139",
    x1: 121.933,
    y1: 187.842,
    x2: 126.623,
    y2: 188.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_376_5139",
    x1: 114.791,
    y1: 193.311,
    x2: 117.281,
    y2: 193.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_376_5139",
    x1: 141.067,
    y1: 198.424,
    x2: 145.717,
    y2: 199.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_376_5139",
    x1: 131.5,
    y1: 203.891,
    x2: 136.148,
    y2: 204.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_376_5139",
    x1: 121.936,
    y1: 209.357,
    x2: 126.584,
    y2: 209.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_376_5139",
    x1: 114.791,
    y1: 214.825,
    x2: 117.218,
    y2: 215.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_376_5139",
    x1: 150.719,
    y1: 153.89,
    x2: 153.126,
    y2: 154.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_376_5139",
    x1: 141.066,
    y1: 156.741,
    x2: 145.711,
    y2: 157.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_376_5139",
    x1: 131.503,
    y1: 162.167,
    x2: 136.151,
    y2: 162.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_376_5139",
    x1: 121.938,
    y1: 167.604,
    x2: 126.586,
    y2: 168.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_376_5139",
    x1: 114.792,
    y1: 173.042,
    x2: 117.275,
    y2: 173.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_376_5139",
    x1: 145.847,
    y1: 184.942,
    x2: 150.537,
    y2: 185.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_376_5139",
    x1: 136.283,
    y1: 190.408,
    x2: 140.972,
    y2: 190.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_376_5139",
    x1: 126.718,
    y1: 195.877,
    x2: 131.406,
    y2: 196.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_376_5139",
    x1: 117.153,
    y1: 201.344,
    x2: 121.841,
    y2: 201.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_376_5139",
    x1: 150.719,
    y1: 193.305,
    x2: 153.184,
    y2: 193.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_376_5139",
    x1: 150.167,
    y1: 130.956,
    x2: 222.803,
    y2: 138.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_376_5139",
    x1: 150.165,
    y1: 152.632,
    x2: 222.125,
    y2: 163.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_376_5139",
    x1: 150.17,
    y1: 152.639,
    x2: 222.133,
    y2: 163.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_376_5139",
    x1: 189.729,
    y1: 130.96,
    x2: 226.467,
    y2: 133.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_376_5139",
    x1: 151.955,
    y1: 136.507,
    x2: 179.377,
    y2: 138.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_376_5139",
    x1: 152.31,
    y1: 141.907,
    x2: 170.665,
    y2: 143.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_376_5139",
    x1: 152.665,
    y1: 147.308,
    x2: 161.956,
    y2: 148.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_376_5139",
    x1: 199.859,
    y1: 136.509,
    x2: 227.28,
    y2: 138.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_376_5139",
    x1: 209.718,
    y1: 141.907,
    x2: 228.072,
    y2: 143.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_376_5139",
    x1: 219.576,
    y1: 147.308,
    x2: 228.866,
    y2: 148.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_376_5139",
    x1: 160.536,
    y1: 185.452,
    x2: 206.641,
    y2: 205.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_376_5139",
    x1: 170.842,
    y1: 196.304,
    x2: 201.601,
    y2: 209.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_376_5139",
    x1: 181.135,
    y1: 207.099,
    x2: 196.599,
    y2: 213.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_376_5139",
    x1: 112.025,
    y1: 65.9321,
    x2: 184.661,
    y2: 73.9616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_376_5139",
    x1: 112.026,
    y1: 87.6094,
    x2: 173.774,
    y2: 114.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_376_5139",
    x1: 153.015,
    y1: 109.284,
    x2: 153.371,
    y2: 109.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_376_5139",
    x1: 127.257,
    y1: 74.0127,
    x2: 171.314,
    y2: 83.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_376_5139",
    x1: 159.229,
    y1: 99.9712,
    x2: 182.525,
    y2: 101.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_376_5139",
    x1: 120.997,
    y1: 99.9727,
    x2: 144.292,
    y2: 101.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_376_5139",
    x1: 35.7447,
    y1: 65.9321,
    x2: 108.381,
    y2: 73.9616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_376_5139",
    x1: 35.7458,
    y1: 87.6094,
    x2: 97.4952,
    y2: 114.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_376_5139",
    x1: 35.7448,
    y1: 65.936,
    x2: 108.379,
    y2: 73.9651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_376_5139",
    x1: 35.7456,
    y1: 109.284,
    x2: 97.4995,
    y2: 136.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_376_5139",
    x1: 150.165,
    y1: 0.903314,
    x2: 222.799,
    y2: 8.93206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_376_5139",
    x1: 150.167,
    y1: 15.3623,
    x2: 216.512,
    y2: 37.1824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_376_5139",
    x1: 191.156,
    y1: 44.2583,
    x2: 191.511,
    y2: 44.2587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_376_5139",
    x1: 152.058,
    y1: 37.1182,
    x2: 176.641,
    y2: 39.8627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_376_5139",
    x1: 178.126,
    y1: 0.904294,
    x2: 190.505,
    y2: 1.45369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_376_5139",
    x1: 152.533,
    y1: 29.9019,
    x2: 165.077,
    y2: 31.3045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_376_5139",
    x1: 165.649,
    y1: 11.6616,
    x2: 172.076,
    y2: 11.9528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_376_5139",
    x1: 164.617,
    y1: 44.2578,
    x2: 189.203,
    y2: 47.0029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_376_5139",
    x1: 178.039,
    y1: 66.1831,
    x2: 190.367,
    y2: 67.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_376_5139",
    x1: 202.758,
    y1: 37.1162,
    x2: 227.345,
    y2: 39.8615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_376_5139",
    x1: 215.943,
    y1: 29.9009,
    x2: 228.488,
    y2: 31.3038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_376_5139",
    x1: 190.2,
    y1: 44.2578,
    x2: 214.785,
    y2: 47.0029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_376_5139",
    x1: 190.681,
    y1: 66.1821,
    x2: 203.01,
    y2: 67.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_376_5139",
    x1: 190.686,
    y1: 8.04394,
    x2: 203.065,
    y2: 8.59336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_376_5139",
    x1: 152.063,
    y1: 22.5815,
    x2: 176.818,
    y2: 23.9636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_376_5139",
    x1: 164.942,
    y1: 29.9023,
    x2: 189.46,
    y2: 31.2616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_376_5139",
    x1: 178.126,
    y1: 37.1187,
    x2: 190.49,
    y2: 37.8141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_376_5139",
    x1: 152.631,
    y1: 44.3047,
    x2: 164.984,
    y2: 44.9944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_376_5139",
    x1: 202.823,
    y1: 22.582,
    x2: 227.577,
    y2: 23.9641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_376_5139",
    x1: 190.212,
    y1: 29.9028,
    x2: 214.728,
    y2: 31.2618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_376_5139",
    x1: 190.686,
    y1: 37.1187,
    x2: 203.05,
    y2: 37.8141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_376_5139",
    x1: 216.195,
    y1: 44.3047,
    x2: 228.548,
    y2: 44.9944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_376_5139",
    x1: 150.166,
    y1: 33.4634,
    x2: 211.933,
    y2: 60.4044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_376_5139",
    x1: 150.166,
    y1: 44.2251,
    x2: 211.933,
    y2: 71.1665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_376_5139",
    x1: 150.166,
    y1: 54.998,
    x2: 211.933,
    y2: 81.9391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_376_5139",
    x1: 161.254,
    y1: 17.0923,
    x2: 196.396,
    y2: 24.7476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_376_5139",
    x1: 170.817,
    y1: 11.6553,
    x2: 205.963,
    y2: 19.3121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_376_5139",
    x1: 180.339,
    y1: 6.24414,
    x2: 215.483,
    y2: 13.9003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_376_5139",
    x1: 171.218,
    y1: 8.17139,
    x2: 186.269,
    y2: 23.3504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_376_5139",
    x1: 177.484,
    y1: 33.5332,
    x2: 192.565,
    y2: 48.7537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_376_5139",
    x1: -2.39597,
    y1: 130.957,
    x2: 70.2406,
    y2: 138.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_376_5139",
    x1: -2.39476,
    y1: 152.633,
    x2: 59.3565,
    y2: 179.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_376_5139",
    x1: 38.5955,
    y1: 174.31,
    x2: 38.9508,
    y2: 174.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_376_5139",
    x1: -0.969976,
    y1: 195.986,
    x2: 34.2726,
    y2: 203.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_376_5139",
    x1: -0.969976,
    y1: 187.369,
    x2: 34.2726,
    y2: 195.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_376_5139",
    x1: -0.969976,
    y1: 178.698,
    x2: 34.2727,
    y2: 186.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_376_5139",
    x1: -0.969976,
    y1: 170.026,
    x2: 34.2726,
    y2: 177.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_376_5139",
    x1: -0.969976,
    y1: 161.356,
    x2: 34.2726,
    y2: 169.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_376_5139",
    x1: 46.4657,
    y1: 169.836,
    x2: 46.8209,
    y2: 169.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_376_5139",
    x1: 54.118,
    y1: 165.496,
    x2: 54.4733,
    y2: 165.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_376_5139",
    x1: 61.7703,
    y1: 161.148,
    x2: 62.1256,
    y2: 161.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_376_5139",
    x1: 69.4227,
    y1: 156.798,
    x2: 69.778,
    y2: 156.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_376_5139",
    x1: 37.1706,
    y1: 152.633,
    x2: 72.414,
    y2: 160.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_376_5139",
    x1: 29.612,
    y1: 148.355,
    x2: 64.8555,
    y2: 156.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_376_5139",
    x1: 21.9685,
    y1: 144.009,
    x2: 57.2117,
    y2: 151.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_376_5139",
    x1: 14.3239,
    y1: 139.658,
    x2: 49.5673,
    y2: 147.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_376_5139",
    x1: 6.67941,
    y1: 135.307,
    x2: 41.9229,
    y2: 143.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_376_5139",
    x1: 73.8843,
    y1: 261.012,
    x2: 146.521,
    y2: 269.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_376_5139",
    x1: 73.8855,
    y1: 282.687,
    x2: 135.635,
    y2: 309.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_376_5139",
    x1: 114.876,
    y1: 304.361,
    x2: 115.231,
    y2: 304.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_376_5139",
    x1: 75.3103,
    y1: 326.037,
    x2: 110.553,
    y2: 333.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_376_5139",
    x1: 75.3103,
    y1: 317.421,
    x2: 110.553,
    y2: 325.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_376_5139",
    x1: 75.3103,
    y1: 308.749,
    x2: 110.553,
    y2: 316.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_376_5139",
    x1: 75.3103,
    y1: 300.079,
    x2: 110.553,
    y2: 307.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_376_5139",
    x1: 75.3103,
    y1: 291.407,
    x2: 110.553,
    y2: 299.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_376_5139",
    x1: 122.746,
    y1: 299.887,
    x2: 123.101,
    y2: 299.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_376_5139",
    x1: 130.398,
    y1: 295.549,
    x2: 130.754,
    y2: 295.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_376_5139",
    x1: 138.051,
    y1: 291.199,
    x2: 138.406,
    y2: 291.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_376_5139",
    x1: 145.703,
    y1: 286.851,
    x2: 146.058,
    y2: 286.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_376_5139",
    x1: 105.555,
    y1: 278.222,
    x2: 140.799,
    y2: 285.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_376_5139",
    x1: 97.9118,
    y1: 273.872,
    x2: 133.155,
    y2: 281.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_376_5139",
    x1: 90.2653,
    y1: 269.524,
    x2: 125.509,
    y2: 277.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_376_5139",
    x1: 82.6208,
    y1: 265.174,
    x2: 117.864,
    y2: 272.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_376_5139",
    x1: 113.451,
    y1: 326.037,
    x2: 148.694,
    y2: 333.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_376_5139",
    x1: 113.451,
    y1: 317.421,
    x2: 148.694,
    y2: 325.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_376_5139",
    x1: 113.451,
    y1: 308.749,
    x2: 148.694,
    y2: 316.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_376_5139",
    x1: 113.451,
    y1: 300.079,
    x2: 148.694,
    y2: 307.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_376_5139",
    x1: 113.451,
    y1: 291.408,
    x2: 148.694,
    y2: 299.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_376_5139",
    x1: 107.005,
    y1: 299.887,
    x2: 107.36,
    y2: 299.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_376_5139",
    x1: 99.3504,
    y1: 295.549,
    x2: 99.7057,
    y2: 295.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_376_5139",
    x1: 91.6981,
    y1: 291.199,
    x2: 92.0533,
    y2: 291.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_376_5139",
    x1: 84.0457,
    y1: 286.851,
    x2: 84.401,
    y2: 286.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_376_5139",
    x1: 83.2029,
    y1: 278.222,
    x2: 118.446,
    y2: 285.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_376_5139",
    x1: 90.8494,
    y1: 273.873,
    x2: 126.092,
    y2: 281.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_376_5139",
    x1: 98.4929,
    y1: 269.525,
    x2: 133.736,
    y2: 277.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_376_5139",
    x1: 106.137,
    y1: 265.174,
    x2: 141.38,
    y2: 272.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_376_5139",
    x1: 226.444,
    y1: 130.956,
    x2: 299.08,
    y2: 138.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_376_5139",
    x1: 226.445,
    y1: 152.634,
    x2: 288.195,
    y2: 179.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_376_5139",
    x1: 267.435,
    y1: 174.31,
    x2: 267.791,
    y2: 174.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_376_5139",
    x1: 229.101,
    y1: 149.695,
    x2: 234.385,
    y2: 150.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_376_5139",
    x1: 237.383,
    y1: 136.349,
    x2: 274.098,
    y2: 139.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_376_5139",
    x1: 244.301,
    y1: 179.935,
    x2: 265.778,
    y2: 182.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_376_5139",
    x1: 250.876,
    y1: 190.657,
    x2: 266.348,
    y2: 192.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_376_5139",
    x1: 257.507,
    y1: 201.47,
    x2: 266.922,
    y2: 202.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_376_5139",
    x1: 264.07,
    y1: 212.2,
    x2: 267.47,
    y2: 212.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_376_5139",
    x1: 272.093,
    y1: 139.991,
    x2: 282.814,
    y2: 140.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_376_5139",
    x1: 281.632,
    y1: 143.591,
    x2: 289.4,
    y2: 143.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_376_5139",
    x1: 291.219,
    y1: 147.211,
    x2: 296.019,
    y2: 147.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_376_5139",
    x1: 300.71,
    y1: 150.795,
    x2: 302.571,
    y2: 150.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_376_5139",
    x1: 231.052,
    y1: 132.749,
    x2: 267.764,
    y2: 135.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_376_5139",
    x1: 228.046,
    y1: 133.65,
    x2: 260.262,
    y2: 136.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_376_5139",
    x1: 228.398,
    y1: 139.01,
    x2: 251.619,
    y2: 140.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_376_5139",
    x1: 228.75,
    y1: 144.365,
    x2: 242.981,
    y2: 145.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_376_5139",
    x1: 236.713,
    y1: 150.833,
    x2: 296.912,
    y2: 158.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_376_5139",
    x1: 230.405,
    y1: 147.249,
    x2: 290.604,
    y2: 154.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_376_5139",
    x1: 243.349,
    y1: 155.362,
    x2: 296.011,
    y2: 161.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_376_5139",
    x1: 250.287,
    y1: 160.819,
    x2: 287.884,
    y2: 165.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_376_5139",
    x1: 257.225,
    y1: 166.274,
    x2: 279.751,
    y2: 169.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_376_5139",
    x1: 264.154,
    y1: 171.724,
    x2: 271.633,
    y2: 172.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_376_5139",
    x1: 230.422,
    y1: 147.3,
    x2: 259.741,
    y2: 177.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_376_5139",
    x1: 232.322,
    y1: 143.518,
    x2: 258.219,
    y2: 170.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_376_5139",
    x1: 242.293,
    y1: 139.978,
    x2: 261.27,
    y2: 159.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_376_5139",
    x1: 252.318,
    y1: 136.41,
    x2: 264.303,
    y2: 148.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_376_5139",
    x1: 262.363,
    y1: 132.81,
    x2: 267.236,
    y2: 136.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_376_5139",
    x1: 228.687,
    y1: 158.276,
    x2: 250.15,
    y2: 159.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_376_5139",
    x1: 228.933,
    y1: 168.992,
    x2: 244.498,
    y2: 169.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_376_5139",
    x1: 229.108,
    y1: 179.718,
    x2: 238.638,
    y2: 180.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_376_5139",
    x1: 229.329,
    y1: 190.461,
    x2: 232.83,
    y2: 190.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_376_5139",
    x1: 267.301,
    y1: 211.525,
    x2: 271.088,
    y2: 211.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_376_5139",
    x1: 267.066,
    y1: 200.889,
    x2: 276.816,
    y2: 201.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_376_5139",
    x1: 266.83,
    y1: 190.25,
    x2: 282.544,
    y2: 192.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_376_5139",
    x1: 266.59,
    y1: 179.476,
    x2: 288.343,
    y2: 181.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_376_5139",
    x1: 269.787,
    y1: 172.478,
    x2: 294.408,
    y2: 175.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_376_5139",
    x1: 276.1,
    y1: 168.839,
    x2: 300.748,
    y2: 171.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_376_5139",
    x1: 282.56,
    y1: 165.244,
    x2: 303.928,
    y2: 167.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_376_5139",
    x1: 289.17,
    y1: 161.621,
    x2: 304.502,
    y2: 163.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_376_5139",
    x1: 295.744,
    y1: 158.019,
    x2: 305.073,
    y2: 159.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_376_5139",
    x1: 302.291,
    y1: 154.434,
    x2: 305.641,
    y2: 154.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_376_5139",
    x1: 267.3,
    y1: 172.257,
    x2: 271.107,
    y2: 172.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_376_5139",
    x1: 276.512,
    y1: 154.252,
    x2: 301.033,
    y2: 155.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_376_5139",
    x1: 283.075,
    y1: 158.778,
    x2: 304.172,
    y2: 159.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_376_5139",
    x1: 289.616,
    y1: 169.594,
    x2: 304.682,
    y2: 170.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_376_5139",
    x1: 296.162,
    y1: 180.417,
    x2: 305.195,
    y2: 180.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_376_5139",
    x1: 302.701,
    y1: 191.234,
    x2: 305.703,
    y2: 191.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_376_5139",
    x1: 270.274,
    y1: 157.797,
    x2: 294.796,
    y2: 159.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_376_5139",
    x1: 266.587,
    y1: 161.388,
    x2: 288.68,
    y2: 162.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_376_5139",
    x1: 266.825,
    y1: 165.002,
    x2: 282.836,
    y2: 165.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_376_5139",
    x1: 267.062,
    y1: 168.614,
    x2: 276.997,
    y2: 169.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_376_5139",
    x1: 150.166,
    y1: 261.011,
    x2: 222.802,
    y2: 269.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_376_5139",
    x1: 150.165,
    y1: 282.686,
    x2: 211.915,
    y2: 309.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_376_5139",
    x1: 189.729,
    y1: 261.01,
    x2: 226.554,
    y2: 263.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_376_5139",
    x1: 165.395,
    y1: 269.092,
    x2: 209.454,
    y2: 278.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_376_5139",
    x1: 197.368,
    y1: 295.049,
    x2: 220.664,
    y2: 296.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_376_5139",
    x1: 159.137,
    y1: 295.05,
    x2: 182.433,
    y2: 296.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_376_5139",
    x1: 150.167,
    y1: 304.359,
    x2: 211.921,
    y2: 331.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_376_5139",
    x1: 151.591,
    y1: 282.684,
    x2: 188.329,
    y2: 285.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.9231ab9ceb9a19957a1d0b7f9f0639ff.svg";
export { ForwardRef as ReactComponent };